LS.ui = {};
/**
 * 请求接口地址集合
 * html片段
 */
(function () {
  var routes = {
    getCartListUrl: `${LS.site.baseUrl}/cart?sections=looksky-cart`,
    addCartItemUrl: `${LS.site.baseUrl}/cart/add.js`,
    updateCartItemUrl: `${LS.site.baseUrl}/cart/update.js`,
    changeCarItemtUrl: `${LS.site.baseUrl}/cart/change.js`,
    getCarJSONUrl: `${LS.site.baseUrl}/cart?sections=looksky-cart-data`,
    getQueryProductPropertyInfoApi:
      "/global/rest/v1/api/shopify/product/queryProductPropertyInfo",
    getqueryShopifyDiscountListApi:
      "/global/rest/v1/api/shopify/discounts/queryShopifyDiscountList",
    getProductSizeGuideInfo: '/global/rest/v1/api/shopify/product/queryProductSizeGuideInfo',
    // also love接口
    getAlsoloveProductListApi: "/global/rest/v1/api/shopify/product/queryRecommendProductPageV2",
    // 投票答题接口
    writeQuestionApi: "/global/rest/v1/api/activity/vote/question/fillOutQuestion",
    questionListApi: "/global/rest/v1/api/activity/vote/question/list",
    activityVoteResult: "/global/rest/v1/api/activity/vote/result",
    activityVoteRedeemGiftCard: "/global/rest/v1/api/activity/vote/redeemGiftCard",
    activityVoteSubscribeLatestNews: "/global/rest/v1/api/activity/vote/subscribeLatestNews",
    // 查询基础配置
    appBasicConfigApi: "/global/rest/v1/api/shopify/app/basic/config",
    // 查询集合商品分页
    queryCollectionProductPageApi: "/global/rest/v1/api/shopify/product/queryCollectionProductPage",
    // 用户登录注册忘记密码模块
    userLoginMailApi: "/global/rest/v1/api/user/login/mail",
    userRegisterMailApi: "/global/rest/v1/api/user/mail/register",
    userForgetPswMailApi: "/global/rest/v1/api/user/sendForgetPasswordEmail",
    resetPasswordApi: "/global/rest/v1/api/user/changePassword",
    // 发送邮箱登录验证码
    sendLoginVerifyCode: "/global/rest/v1/api/user/sendLoginVerifyCode",
    // 通过邮箱验证码登录
    loginByVerifyCode: "/global/rest/v1/api/user/loginByVerifyCode",
    // 发送登录链接到邮箱
    sendLoginLinkToEmail: "/global/rest/v1/api/user/sendLoginLinkToEmail",
    // 通过邮箱链接登录
    loginFromEmailLoginLink: "/global/rest/v1/api/user/loginFromEmailLoginLink",
    // 第三方登录
    loginFromFacebook: "/global/rest/v1/api/user/login/from/facebook",
    loginFromGoogle: "/global/rest/v1/api/user/login/from/google",
    loginFromApple: "/global/rest/v1/api/user/login/from/apple",
    // 评论
    getProductCommentInfo: '/global/rest/v1/api/shopify/comment/getProductCommentInfo',
    getRecomComments: '/global/rest/v1/api/shopify/comment/queryMainPageComments',
    batchGetProductRating: '/global/rest/v1/api/shopify/comment/batchGetProductRating',
    getUserOrderCommentInfoApi: '/global/rest/v1/api/shopify/comment/getUserOrderCommentInfo',
    saveUserOrderCommentApi: '/global/rest/v1/api/shopify/comment/saveUserOrderComment',
    fileUploadImagesApi: '/global/rest/v1/api/shopify/file/uploadImages',
    getShopCommentConfigApi: '/global/rest/v1/api/shopify/comment/getShopCommentConfig',

    // 个人中心
    getUserInfo: '/global/rest/v1/api/user/points/queryUserPointsInfo',
    // 我的订单
    getMyOrders: '/global/rest/v1/api/shopify/order/queryShopifyOrderPageV2',
    // 用户积分服务
    queryUserPointsInfoApi: "/global/rest/v1/api/user/points/queryUserPointsInfo",
    redeemDiscountCodeApi: "/global/rest/v1/api/user/points/redeemDiscountCode",
    queryUserPointsDetailApi: "/global/rest/v1/api/user/points/queryUserPointsDetail",
    queryVipInfoApi: "/global/rest/v1/api/user/points/queryVipInfo",
    doPointsTaskApi: "/global/rest/v1/api/user/points/doPointsTask",
    queryUserCouponsApi: "/global/rest/v1/api/user/points/queryUserCoupons",
    checkAndReceiveDiscountCode: "/global/rest/v1/api/user/points/checkAndReceiveDiscountCode",

    // 订阅
    subscribe: '/global/rest/v1/api/user/userSubscribe',
    subscribeV2: '/global/rest/v1/api/user/userSubscribeV2',
    getSubscribeEmailStatus: '/global/rest/v1/api/user/queryEmailInfo',
    getSubscribeEmailCoupons: '/global/rest/v1/api/user/points/queryUserAvailableCoupons',

    // 转介绍
    inviteQueryUserReferralsPage: '/global/rest/v1/api/shopify/invite/queryUserReferralsPage',
    inviteSendInvitedEmails: '/global/rest/v1/api/shopify/invite/sendInvitedEmails',
    // 邀请弹窗相关接口
    buildInvite: '/global/rest/v1/api/shopify/invite/buildInvitation',
    checkUserIsFirstOrder: '/global/rest/v1/api/shopify/invite/checkUserIsFirstOrder',
    bindCodeFromInvite: '/global/rest/v1/api/shopify/invite/bindCode',

    // 多语言
    changeUserLanguage: '/global/rest/v1/api/shopify/i18n/changeUserLanguage',

    // 查询Shopify商品列表
    productQueryProductList: '/global/rest/v1/api/shopify/product/queryProductList',

    // 查询集合banner组件配置
    listBannerByCollectionId: '/global/rest/v1/api/shopify/collection/listBannerByCollectionId',

    updateUserSubscribe: '/global/rest/v1/api/user/updateUserSubscribeV2',

    // 网红关联商品集合
    getKolProducts: `${LS.site.baseUrl}/collections/grae-cove-irl?sections=looksky-kol-data`,
    // 查询邮箱是否有上传尺码
    checkHasSizeByEmail: '/global/rest/v1/api/shopify/body/size/hasWriteBodySize',
    // 提交用户尺码
    submitUserBodySize: '/global/rest/v1/api/shopify/body/size/saveUserBodySize',
    // 获取退款订单
    getOrderRefundList: '/global/rest/v1/api/shopify/order/queryOrderRefundList',
    // 提交退款数据
    submitOrderRefundList: '/global/rest/v1/api/shopify/order/submitOrderRefundList',
    // 已注册用户订阅
    userSubscribe: '/global/rest/v1/api/user/userJustSubscribe',
    getCanExchangeProducts: `${LS.site.baseUrl}/collections/all-clothing?sections=looksky-exchange-data`,
    getCollectionFilter: '/global/rest/v1/api/shopify/product/getCollectionFilter',
    getCollectionSkcList: '/global/rest/v1/api/shopify/product/pageCollectionSkc',
    getOrderInfo: '/global/rest/v1/api/order/pageOrder',
    submitVoteEmail: '/global/rest/v1/api/user/tagUserByEmail',
    // 获取赠品库存信息
    getGiftStock: '/global/rest/v1/api/shopify/product/fetchPillowcasesStock',
    // 消耗赠品库存
    consumeGiftStock: '/global/rest/v1/api/shopify/product/consumeOnePillowcasesStock',
    subscribeSMS: '/global/rest/v1/api/user/userSMSSubscribe',
    submitUserRedeemInfo: '/global/rest/v1/api/shopify/order/submitUserRedeemInfo',
    getUserRedeemInfo: '/global/rest/v1/api/shopify/order/getUserRedeemInfo'
  };

  LS.ui.routes = routes;
})();

/**
 * 常量
 * reportType 上报类型
 * reportMap 上报字段  这里区分了购物车页面和侧边栏
 */
(function() {
  var reportType = {
    'moduleShow': 'module_show',
    'click': 'click',
    'custom': 'custom',
    'forTest': 'for_test'
  }
  // 侧边栏
  var reportMap = {
    'cartDrawerOpen': 'bag_drawer.clc_push',
    'cartDrawerAutoOpen': 'bag_drawer.self_push',
    'cartCheckout': 'checkout.bag_drawer',
    'couponCode': 'copy_code.bag_drawer',
    'changeSku': 'changeSku',
    'changeSkuByOnSell': 'change_sku.bag_items.bag_drawer',
    'changeSkuBySoldout': 'change_sku.sold_out_items.bag_drawer',
    'increaseCartItemQuantity': 'add_quantity.bag_drawer',
    'minusCartItemQuantity': 'subtract_quantity.bag_drawer',
    'delCartItem': 'delCartItem',
    'delCartItemByOnSell': 'delete.bag_items.bag_drawer',
    'delCartItemBySoldout': 'delete.sold_out_items.bag_drawer',
    'delAllSoldout': 'delete_all.sold_out_items.bag_drawer',    
    'updateCartItem': 'update_bag_items.bag_drawer',
    'checkoutSoldout': 'sold_out_tip.checkout.bag_drawer',
    'confirmCheckoutSoldout': 'delete_and_continue_chekout.sold_out_items.bag_drawer',
    'closeCartDrawer': 'ic_close.bag_drawer',
    'closeSoldoutDrawer': 'ic_close.sold_out_tips',
    'closeChangeSkuDrawer': 'ic_close.change_sku',
    'clickCartDrawerOverlay': 'blank.bag_drawer',
    'clickChangeSkuOverlay': 'blank.change_sku',
    'clickSoldOoutOverlay': 'blank.sold_out_tips',
    'visitProductDetails': 'visitProductDetails',
    'visitProductDetailsByOnSell': 'product_details.bag_items.bag_drawer',
    'visitProductDetailsBySoldout': 'product_details.sold_out_items.bag_drawer',
    'visitProductDetailsByBoughtTother': 'product_details.bought_together.bag_drawer',
    'visitProductDetailsByCollection': 'product_details.collection.bag_drawer',
    'showBoughtTogether': 'product_show.bought_together.bag_drawer',
    'showBestTogether': 'product_show.collection.bag_drawer',
    'clickGoCheckout': 'go_checkout',
    'clickApplyCode': 'apply_code',
    'clickTotalDetail': 'total_detail',
    'showSalePop': 'sale_pop',
    'cartStateEmpty': 'bag_state.empty',
    'cartStateNormal': 'bag_state.normal',
    'cartStateHasSoldOut': 'bag_state.has_sold_out',
    'cartStateError': 'bag_state.error',
    'cartStateOnlySoldOut': 'bag_state.only_sold_out',
    'clickCouponsListOpen': 'coupons_list_open',
    'showCouponsListPop': 'coupons_list_pop',
    'clickBtnCocnfirm': 'btn_cocnfirm',
    'clickCancelUse': 'cancel_use',
    'clickIcCloseCouponsListPop': 'ic_close.coupons_list_pop',
    'clickBlankCouponsListPop': 'blank.coupons_list_pop',
  }

  // 购物车页面上报字段
  if (LS.site.page == 'cart') {
    reportMap = {
      'cartCheckout': 'checkout',
      'couponCode': 'copy_code',
      'changeSku': 'changeSku',
      'changeSkuByOnSell': 'change_sku.bag_items',
      'changeSkuBySoldout': 'change_sku.sold_out_items',
      'increaseCartItemQuantity': 'add_quantity',
      'minusCartItemQuantity': 'subtract_quantity',
      'delCartItem': 'delCartItem',
      'delCartItemByOnSell': 'delete.bag_item',
      'delCartItemBySoldout': 'delete.sold_out_items',
      'delAllSoldout': 'delete_all.sold_out_items',
      'updateCartItem': 'update_bag_items',
      'checkoutSoldout': 'sold_out_tip.checkout',
      'confirmCheckoutSoldout': 'delete_and_continue_chekout.sold_out_items',
      'closeSoldoutDrawer': 'ic_close.sold_out_tips',
      'closeChangeSkuDrawer': 'ic_close.change_sku',
      'clickChangeSkuOverlay': 'blank.change_sku',
      'clickSoldOoutOverlay': 'blank.sold_out_tips',
      'visitProductDetails': 'visitProductDetails',
      'visitProductDetailsByOnSell': 'product_details.bag_items',
      'visitProductDetailsBySoldout': 'product_details.sold_out_items',
      'visitProductDetailsByBoughtTother': 'product_details.bought_together',
      'showBoughtTogether': 'product_show.bought_together',
      'showBestTogether': 'product_show.collection',
      'clickGoCheckout': 'go_checkout',
      'clickApplyCode': 'apply_code',
      'clickTotalDetail': 'total_detail',
      'showSalePop': 'sale_pop',
      'cartStatsEmpty': 'bag_state.empty',
      'cartStateNormal': 'bag_state.normal',
      'cartStateHasSoldOut': 'bag_state.has_sold_out',
      'cartStateError': 'bag_state.error',
      'cartStateOnlySoldOut': 'bag_state.only_sold_out',
      'clickCouponsListOpen': 'coupons_list_open',
      'showCouponsListPop': 'coupons_list_pop',
      'clickBtnCocnfirm': 'btn_cocnfirm',
      'clickCancelUse': 'cancel_use',
      'clickIcCloseCouponsListPop': 'ic_close.coupons_list_pop',
      'clickBlankCouponsListPop': 'blank.coupons_list_pop',
    }
  }

  // 商品详情页
  var productReportMap = {
    'showProductPicture': 'product_picture',
    'showProductAlsoLike': 'product_show.also_like',
    'clickProductAlsoLike': 'product_details.also_like',
    'showProductPairItWith': 'product_show.pair_it_with',
    'clickProductPairItWith': 'product_details.pair_it_with',
    'clickProductPicture': 'product_picture',
    'clickProductColor': 'color_click.product',
    'clickCollectionColor': 'color_click.',
    'clickBagPopColor': 'color_click.add_to_bag_pop',
    'clickProductSize': 'size_click.product',
    'clickBagPopSize': 'size_click.add_to_bag_pop',
    'clickSelectSize': 'size_click.select_pop',
    'clickSizeSelectProduct': 'size_select_click_product',
    'showSizeSelectPopProduct': 'size_select_pop_product',
    'showSizeSelectPopProductsize': 'size_select_pop_productsize',
    'showSizeSelectPopBodysize': 'size_select_pop_bodysize',
    'showSizeSelectPopFittag': 'size_select_pop_fittag',
    'showSizeSelectPopModelsize': 'size_select_pop_modelsize',
    'clickSizeGuide': 'size_guide',
    'showSizeGuidePop': 'size_guide_pop',
    'showSizeGuidePopProductSize': 'size_guide_pop_productsize',
    'clickSizeGuidePopProductSize': 'size_guide_pop_productsize',
    'clickSizeGuidePopBodySize': 'size_guide_pop_bodysize',
    'clickSizeGuidePopCountry': 'size_guide_pop_country',
    'clickCheckoutBuyitnow': 'checkout.buy_it_now',
    'clickBuyitnowToAddToBag': 'add_to_bag.product.buy_it_now',
    'clickAddtobagProductPop': 'add_to_bag.product_pop',
    'clickAddtobagProduct': 'add_to_bag.product',
    'clickAddtobagHomeCollection': 'add_to_bag.home',
    'clickAddtobagCollection': 'add_to_bag.collection',
    'clickAddtobagBottomCollection': 'add_to_bag.bottom_collection',
    'clickAddtobagRecentlyViewed': 'add_to_bag.recently_viewed',
    'clickAddtobagAlsoLike': 'add_to_bag.also_like',
    'clickAddtobagBoughtTogether': 'add_to_bag.bought_together',
    'clickAddtobagSearch': 'add_to_bag.search',
    'clickAddtobagIcon': 'add_to_bag_icon',
    'clickAddtobagPop': 'add_to_bag_pop',
    'clickReviews': 'reviews',
    'clickWriteReview': 'write_a_review',
    'clickShowMoreReview': 'show_more_review',
    'showReviews': 'reviews_show',
    'showBodySizeAbt': 'body_size.size_abt',
    'clickBodySizeAbt': 'body_size.size_abt',
    'showProductSizeAbt': 'product_size.size_abt',
    'clickProductSizeAbt': 'product_size.size_abt',
    'showStandardShipping': 'standard_shipping',
    'showFreeReturn': 'free_return',
    'showProductDetails': 'product_details',
    'showMatericalCare': 'materical_care',
    'clickSizeUnitCm': 'size_unit_cm',
    'clickSizeUnitInch': 'size_unit_inch',
    'showModelInformation': 'model_information',
    'showShoppingSecurity': 'shopping_security',
    'showShoppingSecurityPop': 'shopping_security_pop',
    'clickWhySoLow': 'why_so_low_click.product',
    'clickShoppingSecurityDetails': 'shopping_security_details',
    'clickShippingDetails':'shipping_details',
    'clickReturnDetails':'return_details',
    'clickDescDetails':'description_details',
    'clickCareInstrDetails':'care_instructions_details',
    'clickDetailsDetails':'details_details',
    'clickReviewsViewMore':'view_more_details',
    'showShopSecurityProduct':'shop_security.product',
    'clickShopSecurityProduct':'shop_security.product',
    'showShippingPopProduct':'shipping_pop.product',
    'showReturnPopProduct':'return_pop.product',
    'showShopSecurityPopProduct':'shop_security_pop.product',
    'showDescriptionDetailsProduct':'description_details.product',
    'showMaterialDetailsProduct':'material_details.product',
    'showCareInstructionsDetailsProduct':'care_instructions_details.product',
    'showDetailsDetailsProduct':'details_details.product',
    'showFeatureProduct':'feature.product',
    'showSchematicProduct':'Schematic.product',
    'showPriceComparisonProduct':'price_comparison.product',
    'showTotalCostProduct':'total_cost.product',
    'showBrandValueProduct':'brand_value.product',
    'showReferEarnProduct':'refer_earn.product',
    'showBagPopDiscountTipsProduct': 'bag_pop_discount_tips_product',
    'clickIcCloseBagPopDiscountTipsProduct': 'ic_close.bag_pop_discount_tips_product',
    'showBotDiscountTipsByGuest': 'join_us.bottom_discount_tips_product',
    'showBotMemberDiscountTipsByMember': 'member_coupon.bottom_discount_tips_product',
    'showBotMarketDiscountTipsByMember': 'sales_coupon.bottom_discount_tips_product',
    'showDiscountTipsByGuest': 'join_us.discount_tips_product',
    'showMemberDiscountTipsByMember': 'member_coupon.discount_tips_product',
    'showMarketDiscountTipsByMember': 'sales_coupon.discount_tips_product'
  }

  // 列表集合页
  var collectionReportMap = {
    'showProductCollection': 'product_show.collection',
    'clickProductCollection': 'product_details.collection',
    'clickRecentlyViewedCollection': 'product_details.recently_viewed',
    'clickBottomCollection': 'product_details.bottom_collection',
    'clickBestMatchCollection': 'best_match_click.collection',
    'clickNewestCollection': 'newest_click.collection',
    'clickPriceCollection': 'price_click.collection',
    'clickTagsCollection': 'tags_click.collection',
    'clickBackTop': 'top_click',
    'showTopBannerCollection': 'top_banner.collection',
    'showTopTextCollection': 'top_text.collection',
    'showRecentlyViewedCollection': 'product_show.recently_viewed',
    'clickRecentlyViewedProductCollection': 'product_details.recently_viewed',
    'showBottomBannerCollection': 'bottom_banner.collection',
    'clickBottomBannerCollection': 'bottom_banner.collection',
    'showBottomPictureCollection': 'bottom_picture.collection',
    'clickBottomPictureCollection': 'bottom_picture.collection',
    'showBottomCollectionCollection': 'bottom_collection.collection',
    'showBottomProductCollection': 'product_show.bottom_collection',
    'clickBottomProductCollection': 'product_details.bottom_collection',
  }

  // 首页
  var homeReportMap = {
    'showHomeSection': 'sections_show.home',
    'clickHomeSection': 'sections_click.home',
    'showProductHome': 'product_show.home',
    'clickProductHome': 'product_details.home',
    'showKolModule': 'irl_pop'
  }

  // 搜索页
  var searchReportMap = {
    'showProductSearch': 'product_show.search',
    'clickProductSearch': 'product_details.search',
    'clickHotSearches': 'hot_searches',
    'showRecentSearchBlock': 'recent_search_block',
    'clickRecentSearch': 'recent_search',
    'showDefaultSearch': 'default.search',
    'showResultsSearch': 'results.search',
    'clickSearch': 'search',
  }

  // 全局埋点
  var globalReportMap = {
    'clickLogo': 'logo_click',
    'clickMenu': 'menu_entry',
    'clickMenuLink': 'menu_sections',
    'clickSearch': 'search_entry',
    'clickBag': 'bag_entry',
    'showFooter': 'footer_show',
    'showGiveGet': 'give_get',
    'clickGiveGet': 'give_get',
    'clickFooterLink': 'footer_sections',
    'showMenu': 'menu_drawer',
    'clickAccountEntry': 'account_entry',
    'showSubscribePop': 'subscribe_pop',
    'clickIcCloseSubscribePop': 'ic_close.subscribe_pop',
    'clickBlankSubscribePop': 'blank.subscribe_pop',
    'clickBtnSubscribeSubscribePop': 'btn_subscribe.subscribe_pop',
    'clickBtnSubscribeFooter': 'btn_subscribe.footer',
    'clickBtnSubscribeCheckout': 'btn_subscribe.checkout',
    'showLoginPop': 'login_pop',
    'showCreatePop': 'create_pop',
    'customEmailLogin': 'email.login',
    'customEmailCreate': 'email.create',
    'customFirstNameCreate': 'first_name.create',
    'customLastNameCreate': 'last_name.create',
    'customPhoneNumberCreate': 'phone_number.create',
    'clickCancelSubscirbeCreate': 'cancel_subscirbe.create',
    'clickChooseSubscirbeCreate': 'choose_subscirbe.create',
    'clickDisagreePolicyCreate': 'disagree_policy.create',
    'clickAgreePolicyCreate': 'agree_policy.create',
    'clickFacebookLogin': 'facebook.login',
    'clickAppleLogin': 'apple.login',
    'clickGoogleLogin': 'google.login',
    'clickFacebookCreate': 'facebook.create',
    'clickAppleCreate': 'apple.create',
    'clickGoogleCreate': 'google.create',
    'clickBtnCreate': 'btn_create',
    'customFbackBtnCreateSuccess': 'fback.btn_create.success',
    'customFbackBtnCreateFail': 'fback.btn_create.fail',
    'clickBtnLogin': 'btn_login',
    'customFbackBtnLoginSuccess': 'fback.btn_login.success',
    'customFbackBtnLoginFail': 'fback.btn_login.fail',
    'clickForgetPassword': 'forget_password',
    'clickIcCloseLoginPop': 'ic_close.login_pop',
    'clickIcCloseCreatePop': 'ic_close.create_pop',
    'clickBlankLoginPop': 'blank.login_pop',
    'clickBlankCreatePop': 'blank.create_pop',
    'clickTabLogin': 'tab_login',
    'clickTabCreate': 'tab_create',
    'clickDisplayPassword': 'display.password',
    'clickHiddenPassword': 'hidden.password',
    'clickSubmitEmail': 'submit_email',
    'customFbackSubmitEmailSuccess': 'fback.submit_email.success',
    'customFbackSubmitEmailFail': 'fback.submit_email.fail',
    'customLogoutByDomainNoMatch': 'log_out.domain_no_match',
    'showSubtotalPop': 'subtotal_pop',
    'clickBlankSubtotalPop': 'blank_subtotal_pop',
    'clickDownArrowTopSubtotalPop': 'down_arrow_top.subtotal_pop',
    'clickDownArrowSubtotalPop': 'down_arrow.subtotal_pop',
    'showJoinUsDiscountTipsCart': 'join_us.discount_tips_cart',
    'showMemberDiscountTipsCart': 'member_coupon.discount_tips_cart',
    'showMarketDiscountTipsCart': 'sales_coupon.discount_tips_cart',
    'showJoinUsTopBanner': 'join_us.top_banner',
    'clickJoinUsTopBanner': 'join_us.top_banner',
  }

  // 邀请
  var referReportMap = {
    'showRefer': 'refer',
    'clickReferEarn': 'refer&earn',
    'clickCopyReferLink': 'copy_refer_link',
    'clickReferSendEmail': 'refer_send_email',
    'customrReferSendEmailError': 'refer_send_email_error',
    'clickMyPoints': 'my_points',
    'showPopReferNewCustomer': 'pop_refer_new_customer',
    'showPopReferBindingEmail': 'pop_refer_binding_email',
    'clickSubmitReferBindingEmail': 'submit_refer_binding_email',
  }

  // 账户模块埋点
  var accountReportMap = {
    'clickPointAccountPage': 'point.account_page',
    'clickPointAccountMenu': 'point.account_menu',
    'clickCoupontAccountPage': 'coupont.account_page',
    'clickCoupontAccountMenu': 'coupont.account_menu',
    'clickMyOrderAccountPage': 'my_order.account_page',
    'clickMyOrderAccountMenu': 'my_order.account_menu',
    'clickMyProfileAccountPage': 'my_profile.account_page',
    'clickMyProfileAccountMenu': 'my_profile.account_menu',
    'clickContactUsAccountPage': 'contact_us.account_page',
    'clickContactUsAccountMenu': 'contact_us.account_menu',
    'clickVipCenterAccountMenu': 'vip_center.account_menu',
    'clickVipCenterAccountPage': 'vip_center.account_page',
    'clickRedeem': 'redeem',
    'clickPointsRules': 'points_rules',
    'showPointsRulesPop': 'points_rules_pop',
    'clickPointsHistory': 'points_history',
    'showPointsHistoryPop': 'points_history_pop',
    'clickBtnGoShoppingPoints': 'btn_go_shopping.points',
    'clickFollowFacebook': 'follow.facebook',
    'clickFollowInstagram': 'follow.instagram',
    'clickOrderDetails': 'order_details',
    'clickTabUnused': 'tab_unused ',
    'clickTabUsed': 'tab_used',
    'clickTabExpired': 'tab_expired',
    'clickVipRules': 'vip_rules',
    'showVipRulesPop': 'vip_rules_pop',
    'clickBtnGoShoppingVip': 'btn_go_shopping.vip'
  }

  // checkout页面
  var checkoutReportMap = {
    'goBackShipping': 'back.shipping',
    'goBackInfo': 'back.info',
    'goBackCart': 'back.bag',
    'showCheckoutQuitDialog': 'stay_pop',
    'continueCheckoutByQuitDialog': 'continue_checkout.stay_pop',
    'closeQuitDialog': 'ic_close.stay_pop',
    'selectReasonByQuitDialog': 'btn_reason.stay_pop',
    'errorCatchByInfo': 'info_error.checkout',
    'errorCatchByShip': 'ship_error.checkout',
    'errorCatchByPayment': 'payment_error.checkout',
    'clickPaypalByInfo': 'paypal',
    'clickShoppayByInfo': 'shoppay',
    'clickGooglepayByInfo': 'googlepay',
    'clickApplepayByInfo': 'applepay',
    'contact_informationToApplyCode': 'apply_code.contact_information',
    'shipping_methodToApplyCode': 'apply_code.shipping_method',
    'payment_methodToApplyCode': 'apply_code.payment_method',
    'clickBreadcrumbByCart': 'cart.bread_nav',
    'clickBreadcrumbByInformation': 'information.bread_nav',
    'clickBreadcrumbByShipping': 'shipping.bread_nav',
    'clickBreadcrumbByPayment': 'payment.bread_nav',
    'contact_informationToClickContinueBtn': 'btn_continue.contact_information',
    'shipping_methodToClickContinueBtn': 'btn_continue.shipping_method',
    'payment_methodToClickContinueBtn': 'btn_continue.payment_method',
    'stock_problemsToClickContinueBtn': 'btn_continue.stock_problems',
    'thank_youToClickContinueBtn': 'continue_shopping',
    'contact_informationCatchFormError':'form_error.contact_information',
    'shipping_methodCatchFormError': 'form_error.shipping_method',
    'payment_methodCatchFormError': 'form_error.payment_method',
    'accountContact': 'account',
    'clickPaypal': 'paypal',
    'clickShoppay': 'shoppay',
    'clickGooglepay': 'googlepay',
    'clickApplepay': 'applepay',
    'contact_informationToClickOrderInfo': 'show__order_sum.contact_information',
    'shipping_methodToClickOrderInfo': 'show__order_sum.shipping_method',
    'payment_methodToClickOrderInfo': 'show__order_sum.payment_method',
    'thank_youToClickOrderInfo': 'show__order_sum.thank_you',
    'orderToClickOrderInfo': 'show__order_sum.order',
    'shipping_methodToClickBottomBack': 'return.shipping',
    'contact_informationToClickBottomBack': 'return.info',
    'cartToClickBottomBack': 'return.bag',
    'contact_informationToClickContact':'contact_us.contact_information',
    'shipping_methodToClickContact': 'contact_us.shipping_method',
    'payment_methodToClickContact': 'contact_us.payment_method',
    'thank_youToClickContact': 'contact_us.thank_you',
    'orderToClickContact': 'contact_us.order',
    'switchShipping': 'switch_shipping',
    'styleVote': 'style_vote',
    'voteNext': 'next.survey',
    'voteDislike': 'dislike_this_style.survey',
    'voteSubmit': 'submit.survey',
    'subscribeSMS': 'btn_sms_subscribe.checkout'
  }

  // vote投票需求埋点
  var voteReportMap = {
    'showVoteBanner': 'vote_banner',
    'showVotePop': 'vote_pop',
    'clickLetsVoteBanner': 'lets_vote.banner',
    'clickLetsVotePop': 'lets_vote.pop',
    'clickBackVote': 'back_vote',
    'clickDoneVote': 'done_vote',
    'showQaVote': 'qa_vote',
    'clickAboutVote': 'about_vote',
    'showAboutVotePop': 'about_vote_pop',
    'clickQaVoteFeedback': 'qa_vote_feedback',
    'showDoneVotePop': 'done_vote_pop',
    'clickRedeemVotePop': 'redeem_vote.pop',
    'clickRedeemVotePage': 'redeem_vote.page',
    'clickJoinVote': 'join_vote',
    'clickCopyGfcode': 'copy _gfcode',
    'clickGooglePlay': 'google_play',
    'clickAppStore': 'app_store',
    'showGetStartedSurvey': 'show_started_survey',
    'clickGetStartedSurvey': 'get_started_survey',
  }

  // 订单调查需求埋点
  var orderSurveyReportMap = {
    'showOrderSurvey01': 'order_survey01',
    'showOrderSurvey02': 'order_survey02',
    'showOrderSurveyResults': 'order_survey_results',
    'clickBelowOrderSurvey': 'below.order_survey',
    'clickMetOrderSurvey': 'met.order_survey',
    'clickExceededOrderSurvey': 'exceeded.order_survey',
    'clickNextOrderSurvey': 'next.order_survey',
    'clickCancelOrderSurvey': 'cancel.order_survey',
    'clickSkipOrderSurvey': 'skip.order_survey',
    'clickDoneOrderSurvey': 'done.order_survey',
    'clickGoShoppingOrderSurvey': 'go_shopping.order_survey',
  }

  // 切换国家埋点
  var i18nReportMap = {
    'clickMenuBtn': 'country_language_entry.menu',
    'clickHeaderBtn': 'country_language_entry.topmenu',
    'clickFooterBtn': 'country_language_entry.footer',
    'showPopup': 'country_language.select_pop',
    'clickCountrySelector': 'country_entry.select_pop',
    'clickLangSelector': 'language_entry.select_pop',
    'changeCountry': 'country_change.select_pop',
    'changeLang': 'country_change.select_pop',
    'savePopup': 'country_language_save.select_pop',
    'closePopup': 'country_language_close.select_pop',
    'showGeoTipsPopup': 'local_tips_pop',
    'closeGeoTipsPopup': 'close.local_tips_pop',
    'comfirmGeoTipsPopup': 'confirm.local_tips_pop',
  }

  // 用户订阅注册引导埋点
  var userSubscriptionReportMap = {
    'showJoinCollectivePop': 'join_collective_pop',
    'clickEditJoinCollectivePop': 'edit.join_collective_pop',
    'clickEditFooter': 'edit.footer',
    'clickBtnSignupJoinCollectivePop': 'btn_signup.join_collective_pop',
    'clickBtnSignupFooter': 'btn_signup.footer',
    'clickTermsOfServiceJoinCollectivePop': 'terms_of_service.join_collective_pop',
    'clickPrivacyPolicyJoinCollectivePop': 'privacy_policy.join_collective_pop',
    'clickIcCloseJoinCollectivePop': 'ic_close.join_collective_pop',
    'clickBlankJoinCollectivePop': 'blank.join_collective_pop',
    'showCollectivePackagePop': 'collective_package_pop',
    'clickOtherCouponsCollectivePackagePop': 'other_coupons.collective_package_pop',
    'showOtherCouponsCollectivePackagePop': 'other_coupons.collective_package_pop',
    'clickGoShoppingCollectivePackagePop': 'go_shopping.collective_package_pop',
    'clickIcCloseCollectivePackagePop': 'ic_close.collective_package_pop',
    'clickbBlankCollectivePackagePop': 'blank.collective_package_pop',
    'showLoginPop': 'login-pop',
    'clickBtnLoginLoginPop': 'btn_login.login-pop',
    'clickForgetPasswordLoginPop': 'forget_password.login-pop',
    'clickSubmitLoginPop': 'submit.login-pop',
    'clickIcCloseLoginPop': 'ic_close.login-pop',
    'clickBlankLoginPop': 'blank.login-pop',
    'showEmailSubmitSuccessPop': 'email_submit_success_pop',
    'clickShopToStartEarningEmail': 'shop_now.welcome_to_the_graecove_family.email',
    'clickResetPasswordEmail': 'reset_password.welcome_to_the_graecove_family.email',
    'clickLogInNowEmail': 'log_in_now.account_verification_and_login.email',
    'clickIcCloseBottomDiscountTipsProduct': 'ic_close.bottom_discount_tips_product',
    'closeBotDiscountTip': 'ic_close.bottom_discount_tips_product',
    'clickJoinUsDiscountTip': 'join_us.discount_tips_product',
    'clickBotJoinUsDiscountTip': 'join_us.bottom_discount_tips_product',
    'registered': 'registered',
    'logged_in': 'logged_in'
  }

  // 登录注册流程相关需求埋点
  var loginRegistrationProcessMap = {
    'showJoinCollectivePopSelfPush': 'join_collective_pop.self_push',
    'showJoinCollectivePopClcBall': 'join_collective_pop.clc_ball',
    'showJoinCollectivePopClcTopbanner': 'join_collective_pop.clc_topbanner',
    'showJoinCollectivePopClcDiscountTipsProduct': 'join_collective_pop.clc_discount_tips_product',
    'showJoinCollectivePopClcBottomDiscountTipsProduct': 'join_collective_pop.clc_bottom_discount_tips_product',
    'showJoinCollectivePopClcDiscoutTipsBag': 'join_collective_pop.clc_discout_tips_bag',
    'clickViewCollectionCollectivePackagePop': 'view_collection.collective_package_pop',
    'showCollectivePackagePopTwoButton': 'collective_package_pop.two_button',
    'showCollectivePackagePopOneButton': 'collective_package_pop.one_button',
    'showJoinUsFloatBall': 'join_us.float_ball',
    'clickJoinUsFloatBall': 'join_us.float_ball',
    'showCouponsFloatBall': 'coupons.float_ball',
    'clickCouponsFloatBall': 'coupons.float_ball',
    'showCouponsPop': 'coupons_pop',
    'showJoinUsModule': 'join_us.module'
  }

  var loginRegisterSourceFieldsMap = {
    'cart_guide': 'cart_guide',
    'product_guide': 'product_guide',
    'join_us_clc_topbanner': 'join_us_clc_topbanner',
    'join_us_self_push': 'join_us_self_push',
    'float_ball': 'float_ball',
    'footer_guide': 'footer_guide',
    'account': 'account',
    'other': 'other',
    'join_us_module': 'join_us_module'
  }

  var whatYouWantMap = {
    'submitForm': 'submit.what_you_want_pop',
    'clickWhatYouWant': 'what_you_want',
    'showWhatYouWant': 'what_you_want_pop',
    'color': 'color.what_you_want_pop',
    'size': 'size.what_you_want_pop',
    'email': 'email.what_you_want_pop',
  }

  var errorMsgMap = {
    baseError: LS.$t('public.toast.something_wrong'),
    noSize: LS.$t('public.add_pop.choose_size_tip'),
    noColor: LS.$t('public.add_pop.choose_color_tip'),
    lackOfSizeGuide: LS.$t('public.add_pop.lack_size_guide'),
    soldout: LS.$t('bag.product_sole_out_text'),
  }

  var languageMap = {
    'en': LS.$t('public.lang.US'),
    'fr': LS.$t('public.lang.FR'),
    'de': LS.$t('public.lang.DE'),
    'it': LS.$t('public.lang.IT'),
    'es': LS.$t('public.lang.ES'),
  };
  
  var NAME_US = LS.$t('public.country.US');
  var NAME_GB = LS.$t('public.country.GB');
  var NAME_CA = LS.$t('public.country.CA');
  var NAME_AU = LS.$t('public.country.AU');
  var NAME_NZ = LS.$t('public.country.NZ');
  var countryInfoMap = {
    // 澳大利亚
    'AU': {
      name: NAME_AU,
      key: 'AU',
      lang: 'en',
      symbolCode: 'AU',
      icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_au_3x_98808e7f-1750-4fae-8e26-f037bd4c368c.png?v=1662621153',
      text: NAME_AU + ' - AU$',
      standard: '109.00',
      express: '109.00',
      standardPostage: '11.00',
      expressPostage: '11.00',
      symbol: '$',
      standardDay: '6-9',
      expressDay: '6-9',
      currency: 'AUD'
    },
    // 加拿大
    'CA': {
      name: NAME_CA,
      key: 'CA',
      lang: 'en',
      symbolCode: 'CA',
      icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_Can_3x_92f7ed77-90c5-4da6-934c-197c41bfb367.png?v=1662621151',
      text: NAME_CA + ' - CA$',
      standard: '99.00',
      express: '99.00',
      standardPostage: '10',
      expressPostage: '10',
      symbol: '$',
      standardDay: '6-9',
      expressDay: '6-9',
      currency: 'CAD'
    },
    // 英国
    'GB': {
      name: NAME_GB,
      key: 'GB',
      lang: 'en',
      symbolCode: 'GB',
      icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_gb_3x_58ad6633-3e23-4fa8-876a-e57eb5c72cae.png?v=1662621152',
      text: NAME_GB + ' - GB£',
      standard: '69.00',
      express: '99.00',
      standardPostage: '6.00',
      expressPostage: '11.00',
      symbol: '£',
      standardDay: '6-9',
      expressDay: '4-6',
      currency: 'GBP'
    },
    // 美国
    'US': {
      name: NAME_US,
      key: 'US',
      lang: 'en',
      symbolCode: 'US',
      icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_us_3x_0b541a59-28b8-4f0f-8935-5f2eefba7081.png?v=1662621151',
      text: NAME_US + ' - US$',
      standard: '79.00',
      express: '119.00',
      standardPostage: '6.99',
      expressPostage: '11.99',
      symbol: '$',
      standardDay: '6-9',
      expressDay: '4-6',
      currency: 'USD'
    },
    // 新西兰
    'NZ': {
      name: NAME_NZ,
      key: 'NZ',
      lang: 'en',
      symbolCode: 'NZ',
      icon: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/20220930-171214.png?v=1664529276',
      text: NAME_NZ + ' - NZ$',
      standard: '129.00',
      express: '129.00',
      standardPostage: '18.00',
      expressPostage: '18.00',
      symbol: '$',
      standardDay: '6-9',
      expressDay: '6-9',
      currency: 'NZD'
    },
  };

  var vipRightsMap = [{
    label: 'C0',
    vipId: '1',
    rights: [
      '10% OFF（valid for 12 hours）',
      'Get Up to US$70 in Savings ',
      '10 points per US$1 spend',
      'Exclusive membership Events'
    ]
  }, {
    label: 'C1',
    vipId: '2',
    rights: [
      '13% OFF（valid for 7 days）',
      'Get Up to US$96 in Savings ',
      '15 points per US$1 spend',
      'Exclusive membership Events',
      '1V1 customers services',
    ]
  }, {
    label: 'C2',
    vipId: '3',
    rights: [
      '15% OFF（valid for 15 days）',
      'Get Up to US$126 in Savings',
      '20 points per US$1 spend',
      'Exclusive membership Events',
      '1V1 customers services',
      'Products reservation',
    ]
  }];

  var vipRightsMapByOtherCountry = [{
    label: 'C0',
    vipId: '1',
    rights: [
      '10% OFF (No minimum requirements, valid for 12 hours after registration)',
      '10% OFF 2pc (On orders over 2 items)',
      '13% OFF 2pc(On orders over 3 items)',
      '10 points per US$1 spend',
      'Exclusive membership Events'
    ]
  }, {
    label: 'C1',
    vipId: '2',
    rights: [
      '13% OFF (No minimum requirements, valid for 7 days after membership upgrade)',
      '13% OFF 2pc (On orders over 2 items)',
      '15% OFF 2pc (On orders over 3 items)',
      '15 points per US$1 spend',
      'Exclusive membership Events',
      '1V1 customers services',
    ]
  }, {
    label: 'C2',
    vipId: '3',
    rights: [
      '15% OFF (No minimum requirements, valid for 15 days after membership upgrade)',
      '15% OFF 2pc (On orders over 2 items)',
      '18% OFF 2pc(On orders over 3 items)',
      '20 points per US$1 spend',
      'Exclusive membership Events',
      '1V1 customers services',
      'Products reservation',
    ]
  }];

  var abtMap = {
    aatest: 'aatest',
    discountTipAfterLogin: 'login_discount_tip'
  };

  // app引导下载
  var appGuide = {
    'iosLink': 'https://apps.apple.com/us/app/looksky/id1621678652',
    'androidLink': 'https://play.google.com/store/apps/details?id=com.app.looksky'
  }
 
  // 需要授权登录的页面集合
  var authList = ['/pages/my', '/pages/refer', '/pages/vip-center', '/pages/my-point', 'pages/my-coupon', 'pages/forgetPwd'];

  // 生成商品block模块
  var productBlockDom = `
    <% for ( let [ index, item ] of new Map( data.record.map( ( item, index ) => [ index, item ] ) ) ) { %>
      <div stat-module-show="true" stat-module-show-id="<%= item.productId %>" data-skc-title="<%= item.skcTitle %>" stat-module-show-aid="<%= item.algorithmId %>" stat-module-show-title="<%= item.title %>" stat-module-show-price="<%= Number(item.displayPrice) %>" stat-module-show-selected-color="<%= item.currentSku %>" stat-module-show-color="<%= item.variantList[0].sku %>" data-product-id="<%= item.productId %>" class="ls-product-block" data-index="<%= index %>" data-is-new="<%= item.isNew %>">
        <div class="ls-product-block-innerbox">
          <div class="ls-product-block-image">
            <a class="ls-product-link" href="${LS.site.dir}/products/<%= item.handle %>" aria-label="<%= item.title %>" tabindex="-1">
              <div class="ls-product-block-image-box" data-media-id="<%= item.image.imageId %>">
                <div class="ls-rimage-wrapper-box ls-img-lazyload-placeholder js-lazyload-img" style="padding-top:133.33333333333334%">
                  <img class="shop-featured-img" data-lazyload-src="<%= item.imageSrc ? item.imageSrc : '' %>">
                </div>
              </div>
              <% if (item.productKind == 2 && (item.productType_a == 88 || item.productType_a == 89)) {%>
                <div class="product-block_free-shipping-tip">Free Shipping</div>
              <% }%>
            </a>
            <div class="ls-product-info-databox" target-product>
              <div class="product-basic-data"
                style="display: none;"
                product-kind="<%= item.productKind %>"
                product-category="<%= item.productCategory_a %>"
                product-material="<%= item.productMaterial %>"
                product-composition="<%= item.productComposition %>"
                product-type="<%= item.productType_a %>"
              ></div>
              <div class="js-product-json" style="display: none;">
                {
                  "id":<%= item.productId %>,
                  "title":"<%= item.title %>",
                  "handle":"<%= item.handle %>",
                  "product_url":"${LS.site.dir}/products/<%= item.handle %>",
                  "price":"<%= Number(item.displayPrice) %>",
                  "defaultPrice":"<%= Number(item.displayPrice) %>",
                  "price_code":"<%= item.displayPrice %>",
                  "compare_at_price":"<%= Number(item.displayComparePrice) %>",
                  "compare_at_price_code":"${LS.site.symbol}<%= (item.displayComparePrice / 100).toFixed(2) %>",
                  "currencyCode":"${LS.site.symbol}",
                  "images":<%= JSON.stringify(item.imageList) %>,
                  "variants":<%= JSON.stringify(item.variantList) %>,
                  "options_with_values":<%= JSON.stringify(item.optionList) %>
                }
              </div>
              <div class="ls-product-cart-icon" id="ls-product-cart-popup-<%= item.productId %>" ls_url="${LS.site.dir}/products/<%= item.handle %>" ls_id="<%= item.productId %>">
                <div class="ls-product-cart-icon-btn">
                  <img class="add-bag-icon" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_addtobag_2x_712ad897-9101-47d6-9e9c-04779245ba75.png?v=1658744018" />
                </div>
              </div>
              <a class="ls-product-link ls-product-quick-buy" href="${LS.site.dir}/products/<%= item.handle %>"></a>
              <div class="ls-quick-buy-btn">${LS.$t('public.add_pop.add_to_bag_btn')}</div>
            </div>
            <% if ( item.hasComparePrice || item.isNew ) { %>
              <div class="ls-product-label-box">
                <% if ( item.hasComparePrice ) { %>
                  <div class="ls-product-label-box-discount">
                    <div class="label-box-discount-wrapper label-box-discount-wrapper_abt">
                      <div class="discount-box">
                      -<%= 100 -  Math.ceil((item.displayPrice * 100) / item.displayComparePrice) %>%
                      </div>
                    </div>
                  </div>
                <% } else { %>   
                  <div class="ls-product-label-box-new">
                    <img class="ls-product-label-box-new-img" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/tag_ic_new_2x_c2b6bfd8-0592-4592-a514-2eeb3113a8e4.png?v=1658370581" />
                  </div>
                <% } %>
              </div>
            <% } %>
          </div>
          <div class="ls-product-block-info">
            <a class="ls-product-link" href="${LS.site.dir}/products/<%= item.handle %>">
              <div class="ls-product-block-title"><%= item.title %></div>
              <div class="reviews-star-box"></div>
            </a>
            <div class="ls-product-block-price <% if ( item.hasComparePrice ) { %>wrap<% } %>">
              <% if ( item.minPrice ) { %>
                <span class="has-diff-price-label">From</span>
              <% } %>
              <div class="product-block-amount-wrapper">
                <span class="ls-price-amount-sale <% if ( item.hasComparePrice ) { %>ls-price-amount-sale-red<% } %>">${countryInfoMap[LS.site.country].symbolCode}${LS.site.symbol}<%= LS.i18n.fmtAmount((item.displayPrice/100).toFixed(2)) %></span>
                <% if ( item.hasComparePrice ) { %>
                  <span class="ls-price-amount-compare">${countryInfoMap[LS.site.country].symbolCode}${LS.site.symbol}<%= LS.i18n.fmtAmount((item.displayComparePrice/100).toFixed(2)) %></span>
                <% } %>
              </div>
            </div>
            <div class="duties-VAT_text">Prices include duties and taxes.</div>
          </div>
          <div class="ls-product-block-variants">
            <% if ( item.filteredVariantList && item.filteredVariantList.length > 1 ) { %>
              <div class="ls-product-variants-list">
                <% for ( var [colorVairantIndex, colorVairantItem] of item.filteredVariantList.entries() ) { %>
                  <div class="ls-variants-image-box <% if ( item.defaultColor ? colorVairantItem.option1 == item.defaultColor : colorVairantIndex == 0 ) { %>ls-variants-image-active<% } %>" data-value="<%= colorVairantItem.option1 %>" data-media="<%= item.image.imageId %>" data-variant-id="<%= colorVairantItem.variantId %>" data-sku="<%= colorVairantItem.sku%>" data-img="<%= colorVairantItem.imageSrc ? colorVairantItem.imageSrc : '' %>">
                    <img data-lazyload-src="<%= colorVairantItem.selectOptImageSrc ? colorVairantItem.selectOptImageSrc : '' %>">
                  </div>
                <% } %>
              </div>
            <% } %>
          </div>
        </div>
      </div>
    <% } %>
  `;

var emptyDom = `
  <div class="common-empty-wrapper">
    <img class="common-empty-img" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ls_nofound.png?v=1650952464" />     
    <p class="common-empty-text">Found 0 results</p>           
  </div>           
`;
            
  var currencySymbol = 'US';
  var beddingCoupon = {
    currencyCode: LS.site.symbol,
    currencySymbol: currencySymbol,
    discountCode: 'Bedding20',
    discountId: '666',
    discountMinimalPurchaseAmount: '',
    discountPercentage: '20%',
    endTime: new Date().getTime() + 2592000000,
    redeemCouponAmount: '',
    remark: '',
    startTime: new Date().getTime(),
    userCouponType: 1,
    couponCategory: 1,
    isProductCoupon: true,
    minimalProductCount: ''
  }
  var normalCouponList = [{
    currencyCode: LS.site.symbol,
    currencySymbol: currencySymbol,
    discountCode: 'SA20',
    discountId: '999',
    discountMinimalPurchaseAmount: '',
    discountPercentage: '20%',
    endTime: new Date().getTime() + 2592000000,
    redeemCouponAmount: '',
    remark: '',
    startTime: new Date().getTime(),
    userCouponType: 1,
    couponCategory: 2,
    minimalProductCount: 2
  }, {
    currencyCode: LS.site.symbol,
    currencySymbol: currencySymbol,
    discountCode: 'SA25',
    discountId: '998',
    discountMinimalPurchaseAmount: '',
    discountPercentage: '25%',
    endTime: new Date().getTime() + 2592000000,
    redeemCouponAmount: '',
    remark: '',
    startTime: new Date().getTime(),
    userCouponType: 1,
    couponCategory: 2,
    minimalProductCount: 3
  }, {
    currencyCode: LS.site.symbol,
    currencySymbol: currencySymbol,
    discountCode: 'SA30',
    discountId: '997',
    discountMinimalPurchaseAmount: '',
    discountPercentage: '30%',
    endTime: new Date().getTime() + 2592000000,
    redeemCouponAmount: '',
    remark: '',
    startTime: new Date().getTime(),
    userCouponType: 1,
    couponCategory: 2,
    minimalProductCount: 4
  }];

  // var normalCouponList = [];

  // if (LS.site.country !== 'US') {
  //   normalCouponList = [];
  // }
  
  // 多店铺集合
  var shopMain = 'graecove';
  var shopAU = 'au-graecove';
  var shopUK = 'uk-graecove';
  var shopCA = 'ca-graecove';
  var shopMap = {
    '10001': shopMain,
    '10002': shopAU,
    '10003': shopUK,
    '10004': shopCA,
  }

  var isShopAU = shopMap[LS.site.shop] === shopAU;

  // 可兑换积分比例 美国US$1 = 300积分 澳大利亚 AU$1 = 450积分
  var pointRatio = LS.site.country === 'AU' ? 450 : 300;

  // 日期格式
  var dateFormat = LS.site.country === 'AU' ? 'dd.MM.yyyy' : 'MM.dd.yyyy';
  var dateTimeFormat = LS.site.country === 'AU' ? 'dd.MM.yyyy hh:mm:ss' : 'MM.dd.yyyy hh:mm:ss';

  // 评论积分奖励
  var textReviewPointNum = LS.site.country === 'AU' ? 300 : 200; // 文字
  var textImgReviewPointNum = LS.site.country === 'AU' ? 450 : 300; // 文字+图片

  LS.ui.reportType = reportType;
  LS.ui.reportMap = reportMap;
  LS.ui.homeReportMap = homeReportMap;
  LS.ui.searchReportMap = searchReportMap;
  LS.ui.productReportMap = productReportMap;
  LS.ui.collectionReportMap = collectionReportMap;
  LS.ui.globalReportMap = globalReportMap;
  LS.ui.referReportMap = referReportMap;
  LS.ui.accountReportMap = accountReportMap;
  LS.ui.voteReportMap = voteReportMap;
  LS.ui.orderSurveyReportMap = orderSurveyReportMap;
  LS.ui.errorMsgMap = errorMsgMap;
  LS.ui.abtMap = abtMap;
  LS.ui.countryInfoMap = countryInfoMap;
  LS.ui.checkoutReportMap = checkoutReportMap;
  LS.ui.appGuide = appGuide;
  LS.ui.languageMap = languageMap;
  LS.ui.authList = authList;
  LS.ui.productBlockDom = productBlockDom;
  LS.ui.emptyDom = emptyDom;
  LS.ui.i18nReportMap = i18nReportMap;
  LS.ui.userSubscriptionReportMap = userSubscriptionReportMap;
  LS.ui.loginRegistrationProcessMap = loginRegistrationProcessMap;
  LS.ui.normalCouponList = normalCouponList;
  LS.ui.beddingCoupon = beddingCoupon;
  LS.ui.shopMain = shopMain;
  LS.ui.shopAU = shopAU;
  LS.ui.shopMap = shopMap;
  LS.ui.isShopAU = isShopAU;
  LS.ui.pointRatio = pointRatio;
  LS.ui.dateFormat = dateFormat;
  LS.ui.dateTimeFormat = dateTimeFormat;
  LS.ui.textReviewPointNum = textReviewPointNum;
  LS.ui.textImgReviewPointNum = textImgReviewPointNum;
  LS.ui.vipRightsMap = vipRightsMap;
  LS.ui.vipRightsMapByOtherCountry = vipRightsMapByOtherCountry;
  LS.ui.loginRegisterSourceFieldsMap = loginRegisterSourceFieldsMap;
  LS.ui.whatYouWantMap = whatYouWantMap;
})();

/**
 * 正则校验
 */
(function() {
  var validator = {
    easyEmailReg: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    emailReg: /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
    numberReg: /^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
  }

  LS.ui.validator = validator
})();

/**
 * 集合列表
 */
(function () {
  var busyLoading = false;
  // 列表是否有下一页
  var isNextPage = "";
  var collectionPageCount = 0;
  var collectionPageNo = 0;
  // 购物车底部列表分页
  var cartCollectionPageNo = 0;
  var cartCollectionPageCount = 0;
  var firstLoadCollection = true;
  var curSubCollectionId = null;
  var hasNextSubCollectionId = null;
  // 集合模块分页
  var collectionModulePageNo = 0;
  var collectionModulePageCount = 0;
  var collectionFn = {
    handleCollectionDesc: function() {
      var descList = $('.sub-collection-desc-origin');
      for (var i = 0, len = descList.length; i < len; i++) {
        var descItem = $(descList[i]);
        var descText = descItem.find('.collection-sub-desc_text');
        if (!descText) return;
        var maxHeight = descText.css('max-height');
        if (!maxHeight) return;
        maxHeight = maxHeight.replace('px', '');
        var descHeight = descItem.find('.collection-sub-desc_info').height();
        if (descHeight > maxHeight) {
          descText.addClass('limit-height');
        }
        descItem.removeClass('sub-collection-desc-origin');
      }
    },
    getCollectionModule: function(obj) {
      var dom = obj.dom;
      var collectionId = obj.collectionId || '';
      var canLoadMore = obj.canLoadMore || false;
      var reset = obj.reset || false;
      var handleType = obj.handleType || 1;
      var pageSize = obj.pageSize || 20;
      busyLoading = true;
      var loadmoreDom = null;
      if (canLoadMore) {
        loadmoreDom = $(dom).find('.ls-loadmore-img');
        loadmoreDom.show();
      }
      if (reset) {
        handleType == 2 ? (cartCollectionPageNo = 0) : (collectionModulePageNo = 0);
      }
      handleType == 2 ? (cartCollectionPageNo = cartCollectionPageNo + 1) : (collectionModulePageNo = collectionModulePageNo + 1);
      var params = {
        collectionId: collectionId,
        pageNo: handleType == 2 ? cartCollectionPageNo : collectionModulePageNo,
        pageSize: pageSize,
        version: 1
      };
      if (!busyLoading) return;
      LS.ajax({
        url: LS.ui.routes.getCollectionSkcList,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(params),
        observeKeys: ['data.record'],
        success: function (res) {
          if (res.hasError || res.code !== '0') return;
          var data = res.data || {};
          var pageCount = data.pageCount || 0;
          handleType == 2 ? (cartCollectionPageCount = pageCount) : (collectionModulePageCount = pageCount);
          var productList = data.record || [];
          var productListLen = productList.length;
          productListLen && collectionFn.handleCollectionData(productList);
          if (productListLen) {
            var productListHtml = LS.tmpl(LS.ui.productBlockDom, data);
            $(dom).find('.ls-featured-collection-product-list').append(productListHtml);
            LS.ui.globalListExposureHandle();
          }
          busyLoading = false;
        },
        complete: function () {
          busyLoading = false;
          canLoadMore && loadmoreDom.hide();
        },
        error: function (error) {
          busyLoading = false;
        },
      });
    },
    handleCollectionData: function(productList) {
      var productIds = [];
      var skcList = [];
      for (var i = 0, len = productList.length; i < len; i++) {
        var tagretProduct = productList[i];
        var tagretProductHandle = tagretProduct.handle;
        var targetVariantList = tagretProduct.variantList;
        var targetVariantLen = targetVariantList.length;
        var createTime = tagretProduct.createTime;
        var minPrice = tagretProduct.minPrice;
        var price = targetVariantLen && targetVariantList[0].presentmentPrice.price.amount || '';
        var comparePrice = targetVariantLen && targetVariantList[0].presentmentPrice.compareAtPrice.amount || '';
        !tagretProduct.defaultColor && (tagretProduct.defaultColor = targetVariantList[0].option1);
        var colorHandle = tagretProduct.defaultColor ? tagretProduct.defaultColor.replace(' ', '-') : '';
        tagretProduct.isNew = new Date().getTime() - createTime < 604800000;
        tagretProduct.displayPrice = minPrice ? minPrice : price;
        tagretProduct.displayComparePrice = comparePrice;
        tagretProduct.hasComparePrice = tagretProduct.displayPrice && tagretProduct.displayComparePrice && tagretProduct.displayPrice != tagretProduct.displayComparePrice;
        productIds.push(tagretProduct.productId);
        tagretProduct.defaultColorIndex = 0;
        tagretProduct.skcTitle = colorHandle ? tagretProductHandle + '-' + colorHandle : '';
        tagretProduct.skcTitle && skcList.push(tagretProduct.skcTitle);
        var targetImageList = tagretProduct.imageList;
        var lowestPrices = {};
        for (var j = 0; j < targetVariantLen; j++) {
          var colorVariantItem = targetVariantList[j];
          var colorVariantItemColor = colorVariantItem.option1;
          var colorVariantItemPrice = colorVariantItem.price;
          var colorVariantItemImageId = colorVariantItem.imageId;
          var imageObj = targetImageList.find(item => item.imageId === colorVariantItemImageId);
          var imageSrc = imageObj ? imageObj.src.replace(".jpg", "_700x.jpg").replace(".png", "_700x.png") : '';
          var selectOptImageSrc = imageObj ? imageObj.src.replace(".jpg", "_60x.jpg").replace(".png", "_60x.png") : '';
          colorVariantItem.imageSrc = imageSrc;
          colorVariantItem.selectOptImageSrc = selectOptImageSrc;

          if (colorVariantItemColor === tagretProduct.defaultColor) {
            var targetVariantItemId = tagretProduct.currentVariantId || colorVariantItem.variantId;
            tagretProduct.currentSku = colorVariantItem.sku;
            tagretProduct.imageSrc = imageSrc;
            tagretProduct.handle = tagretProductHandle + '?color=' + tagretProduct.defaultColor.replace(' ', '%20') + '&variant=' + targetVariantItemId;
          }
          // 如果当前颜色不存在或当前价格更低，则更新最低价格
          if (!lowestPrices[colorVariantItemColor] || colorVariantItemPrice < lowestPrices[colorVariantItemColor]) {
            lowestPrices[colorVariantItemColor] = colorVariantItemPrice;
          }
        }

        var filteredVariantList = targetVariantList.filter(function(item, index, arr) {
          var variantColorVal = item.option1;
          var variantPrice = item.price;
          return variantPrice === lowestPrices[variantColorVal] && arr.findIndex(function(i) {
            return i.option1 === variantColorVal;
          }) === index;
        });
        tagretProduct.filteredVariantList = filteredVariantList;
      }
      return { productIds: productIds, skcList: skcList }
    },
    getCollectionPageList: function(reset) {
      busyLoading = true;
      var loadmoreDom = $('.ls-main-collection-pagecon').find(".ls-loadmore-img");
      var containerDom = $('#collection-conatiner').find('.ls-main-collection-list');
      var shopifySubCollectionId = containerDom.attr('data-sub-collction-id') || null;
      loadmoreDom.show();
      if (firstLoadCollection) {
        curSubCollectionId = shopifySubCollectionId;
      }
      if (reset) {
        collectionPageNo = 0;
        curSubCollectionId = shopifySubCollectionId;
        containerDom.find('.ls-featured-collection-product-list').html('');
        $(window).scrollTop(0);
      }
      collectionPageNo = collectionPageNo + 1;
      var collectionPageParams = LS.getData('collectionPageParams') || {};
      var curCollctionId = $('#collection-conatiner').attr('collectionId');
      collectionPageParams.collectionId = curCollctionId;
      collectionPageParams.pageNo = collectionPageNo;
      collectionPageParams.pageSize = 20;
      collectionPageParams.version = 1;
      if (curSubCollectionId) {
        collectionPageParams.subCollectionId = curSubCollectionId;
      }
      if (!busyLoading) return;
      LS.ajax({
        url: LS.ui.routes.getCollectionSkcList,
        type: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(collectionPageParams),
        observeKeys: ['data.record'],
        success: function (res) {
          if (res.hasError || res.code !== '0') return;
          var data = res.data || {};
          collectionPageCount = data.pageCount;
          var collectionTotalCount = data.collectionTotalCount;
          var nextSubCollectionId = data.nextSubCollectionId;
          var nextSubCollectionTitle = data.nextTitle;
          // var nextSubCollectionDesc = data.nextDesc;
          var curSubCollectionTitle = data.currentTitle;
          var curSubCollectionDesc = data.currentDesc;
          if (collectionTotalCount === 0) {
            containerDom.find('.ls-featured-collection-product-list').html(LS.ui.emptyDom);
            return;
          }
          var productList = data.record || [];
          var collectionObj = collectionFn.handleCollectionData(productList);
          if (firstLoadCollection) {
            productList.splice(0, 4);
            firstLoadCollection = false
          }
          if (productList.length) {
            var productListHtml = LS.tmpl(LS.ui.productBlockDom, data);
            var productModuleStr = '';
            if (hasNextSubCollectionId || reset) {
              if (curSubCollectionTitle) {
                var colectionSubTitle = `<div class="collection-sub-title">${curSubCollectionTitle}</div>`;
                productModuleStr += colectionSubTitle;
              }
              if (curSubCollectionDesc) {
                var colectionSubDesc = `
                  <div class="collection-sub-desc">
                    <div class="collection-sub-desc_text limit-height">
                      <div class="collection-sub-desc_info">${curSubCollectionDesc}</div>
                      <div class="collection-sub-desc_show-more-btn">Read more</div>
                    </div>  
                  </div>`;
                productModuleStr += colectionSubDesc;
              }
              productModuleStr && (productModuleStr = `<div class="collection-sub-module sub-collection-desc-origin">${productModuleStr}</div>`);
              productModuleStr = productModuleStr + productListHtml;
              containerDom.find('.ls-featured-collection-product-list').append(productModuleStr);
              hasNextSubCollectionId = null;
            } else {
              containerDom.find('.ls-featured-collection-product-list').append(productListHtml);
            }
            LS.ui.globalListExposureHandle();
          }
          var hasMore = (collectionPageCount == 0 || collectionPageNo >= collectionPageCount) && nextSubCollectionId && nextSubCollectionTitle;
          if (hasMore) {
            hasNextSubCollectionId = nextSubCollectionId;
            curSubCollectionId = hasNextSubCollectionId;
            collectionPageNo = 0;
            collectionFn.getCollectionPageList();
          }
          LS.ui.batchInsertReviewsModule(collectionObj.productIds, collectionObj.skcList);
          collectionFn.handleCollectionDesc();
          busyLoading = false;
        },
        complete: function () {
          busyLoading = false;
          loadmoreDom.hide();
        },
        error: function (error) {
          busyLoading = false;
        },
      });
    },
    handleCollectionScrollPos: function() {
      window.addEventListener('DOMContentLoaded', function() {
        var sessionStorageKey = 'collection_position_data';
        // 获取存储的滚动位置，默认为0
        var scrollPositionData = sessionStorage.getItem(sessionStorageKey) || '';
        // 恢复滚动位置
        if (scrollPositionData) {
          scrollPositionData = JSON.parse(scrollPositionData) || {};
          var scrollPos = scrollPositionData.pos;
          if (scrollPos) {
            firstLoadCollection = false;
            $('#collection-conatiner .ls-featured-collection-product-list').html(scrollPositionData.html);
            collectionPageNo = scrollPositionData.collectionPageNo;
            curSubCollectionId = scrollPositionData.curSubCollectionId;
            collectionPageCount = scrollPositionData.collectionPageCount;
            setTimeout(function() {
              window.scrollTo(0, scrollPos);
              sessionStorage.removeItem(sessionStorageKey);
            }, 300);
          }
        } else {
          collectionFn.getCollectionPageList();
        }
      });
    },
    // 调用列表方法
    handleCollectAll: function () {
      // 当页面为集合页时，调用滚动加载下一页方法
      if (LS.site.page == 'collection') {
        var collectionPosDataKey = 'collection_position_data';
        if (!sessionStorage.getItem(collectionPosDataKey)) {
          collectionFn.getCollectionPageList();
        } else {
          collectionFn.handleCollectionScrollPos();
        }
        collectionFn.bindScrollType('collectionPage');
      }

      // 点击列表购物车icon，弹窗商品弹窗
      $(document).on("click", ".ls-product-cart-icon-btn", function () {
        var productInfo =
          JSON.parse(
            $(this).parents(".ls-product-info-databox").find(".js-product-json").text() || 'null'
          ) || {};
        // 判断列表的变体选项
        var variantsColor = $(this).parents(".ls-product-block-innerbox").find('.ls-variants-image-active').attr("data-value") || '';
        if (variantsColor) {
          // 赋值颜色
          productInfo.color = variantsColor;
        }
        // 调用创建弹窗方法
        var productInfoData = collectionFn.processingProductData(productInfo);
        // 获取集合名，aid
        var handle = $(this).parents('.ls-featured-collection-listing').attr('data-title');
        var listType = $(this).parents('.ls-featured-collection-product-list').attr('data-list-type');
        var aid = $(this).parents('.ls-product-block').attr('stat-module-show-aid');
        LS.ui.productPopupFn.lsCreatePopupHandle({
          // productInfoData, handle, aid
          data: productInfoData,
          handle: handle,
          listType: listType,
          aid: aid,
          dataDom: this
        });
        // 点击icon上报
        LS.ui.productPopupFn.addToBagReportExposureClickHanlde(productInfoData, LS.ui.reportType['click'], LS.ui.productReportMap['clickAddtobagIcon']);
      });

      // 列表点击variants选择商品颜色
      $(document).on("click", ".ls-product-block-innerbox .ls-variants-image-box", function() {
        var $this = $(this);
        var vairantId = $this.attr('data-variant-id');
        var $innerBox = $this.parents(".ls-product-block-innerbox");
        var $productLink = $innerBox.find(".ls-product-link");
        var $productBLock = $(this).parents('.ls-product-block');
        var activeClassName = 'ls-variants-image-active';
        var currentSku = $this.attr('data-sku');
        // 更改选中的样式
        $this.parents(".ls-product-variants-list").find(".ls-variants-image-box").removeClass(activeClassName);
        $this.addClass(activeClassName);
        // 获取选择的图片
        var variantsImg = $this.attr("data-img") || 'null';
        var shopFeaturedImgWrapper = $innerBox.find(".ls-rimage-wrapper-box");
        var shopFeaturedImgDom = shopFeaturedImgWrapper.find(".shop-featured-img");
        shopFeaturedImgDom.attr("src", variantsImg).hide();
        shopFeaturedImgWrapper.css({
          'background-image': 'none',
          'background-color': '#fff'
        });
        setTimeout(function() {
          shopFeaturedImgDom.show();
        }, 100);
        // 获取选择的颜色，并修改a链接携带选择的颜色进入详情页
        var selectColor = $this.attr("data-value") || 'null';
        selectColor = encodeURI(selectColor);
        var selectLink = $productLink.attr('href');
        selectLink = selectLink.split('?')[0];
        $productLink.attr('href', `${selectLink}?color=${selectColor}&variant=${vairantId}`);
        $productBLock.attr('stat-module-show-selected-color', currentSku);
        // 上报
        var param = {
          "products": {
            id: $productBLock.attr('data-product-id') + '',
            color: currentSku.split('-')[1],
          }
        };
        // 如果集合携带aid，则上报aid
        var aid = $productBLock.attr('stat-module-show-aid');
        var listInnerDom = $this.parents('.ls-featured-collection-product-list');
        var listType = listInnerDom.attr('data-list-type') || 'collection';
        LS.stat({
          eid: LS.ui.reportType['click'],
          aid: aid || 'empty',
          ext1: LS.ui.productReportMap['clickCollectionColor'] + listType,
          ext2: JSON.stringify(param || {})
        });
      });

      // 全局列表点击上报
      $(document).on("click", ".ls-product-block .ls-product-link", function() {
        LS.site.page === 'collection' && sessionStorage.setItem('collection_position_data', JSON.stringify({
          pos: window.pageYOffset.toString(),
          html: $('#collection-conatiner .ls-featured-collection-product-list').html(),
          collectionPageNo: collectionPageNo,
          curSubCollectionId: curSubCollectionId,
          collectionPageCount: collectionPageCount
        }));
        // 获取dom结构，判断是否为侧边栏购物车加购
        var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
        // 获取页面类型
        var pageType = cartDrawerOpen ? 'cart' : LS.site.page;
        // 判断加购类型
        var clickType = "";
        // 定义加购商品来源参数
        var addToBagProductFrom = "none";
        switch (pageType) {
          case 'index':
            clickType = LS.ui.homeReportMap['clickProductHome'];
            addToBagProductFrom = "home_collection";
            break;
          case 'search':
            clickType = LS.ui.searchReportMap['clickProductSearch'];
            addToBagProductFrom = "search";
            break;
          case 'collection':
            var listType =  $(this).parents('.ls-featured-collection-product-list').attr('data-list-type');
            if (listType == 'recently_viewed') {
              clickType = LS.ui.collectionReportMap['clickRecentlyViewedCollection'];
              addToBagProductFrom = "recently_viewed";
            } else if (listType == 'bottom_collection') {
              clickType = LS.ui.collectionReportMap['clickBottomCollection'];
              addToBagProductFrom = "bottom_collection";
            } else {
              clickType = LS.ui.collectionReportMap['clickProductCollection'];
              addToBagProductFrom = "collection";
            }
            break;
          case 'product':
            var type = $(this).parents('.ls-featured-collection-listing').attr('data-title');
            if (type === 'pair_it_with') {
              clickType = LS.ui.productReportMap['clickProductPairItWith'];
              addToBagProductFrom = "pair_it_with";
            } else {
              clickType = LS.ui.productReportMap['clickProductAlsoLike'];
              addToBagProductFrom = "also_like";
            }
            break;
          case 'cart':
            var isEmptyCart = !$('#cart-sum').text();
            if (isEmptyCart) {
              clickType = LS.ui.reportMap['visitProductDetailsByCollection'];
              addToBagProductFrom = "best_seller";
            } else {
              clickType = LS.ui.reportMap['visitProductDetailsByBoughtTother'];
              addToBagProductFrom = "bought_together";
            }
           
            break;
        }
        LS.ui.reporterCollection(clickType, this);
        // 存储加购来源
        LS.cookie.set("looksky-pagefrom", addToBagProductFrom, 24);
      });

      // 全局列表曝光方法
      LS.ui.globalListExposureHandle();
    },

    // 处理商品弹窗数据格式
    processingProductData: function (data) {
      // 如果是直出的商品数据格式
      if ( data.metafields ) {
        // 添加国家码参数
        // data.currencyCode = '';
        // 更改images数组里面的参数名
        var imagesNew = JSON.parse(JSON.stringify(data.images).replace(/id/g, "imageId"));
        data.images = imagesNew;
        // 更改variants数组里面的参数名，以及参数
        var variantsNew = [];
        data.variants.forEach(item => {
          var metafieldList = [];
          if ( data.metafields.variants ) {
            metafieldList = data.metafields.variants.filter(item2 => item2.id == item.id) || [];
          }
          variantsNew.push({
            imageId: item.featured_media ? item.featured_media.id : '',
            variantId: item.id,
            option1: item.option1,
            option2: item.option2,
            sellType: metafieldList.length > 0 ? metafieldList[0].sellType : '',
            otherCountrySellable: metafieldList.length > 0 ? metafieldList[0].otherCountrySellable : '',
            soldOutStatus: metafieldList.length > 0 ? metafieldList[0].soldOutStatus : '',
            cancelPresellDays: metafieldList.length > 0 ? metafieldList[0].cancelPresellDays : '',
            presellDays: metafieldList.length > 0 ? metafieldList[0].presellDays : '',
            presellStartTime: metafieldList.length > 0 ? metafieldList[0].presellStartTime : '',
            presellEndime: metafieldList.length > 0 ? metafieldList[0].presellEndime : '',
            sku: item.sku,
            featuredImage: item.featured_image.src,
            price: item.price,
            comparePrice: item.comparePrice,
            defaultPrice: item.defaultPrice,
          });
        });
        data.variants = variantsNew;
        return data;
        // 把元字段里面的信息加入到variants数组
      } else {
        return data;
      }
    },
    // 滚动的商品集合类型
    bindScrollType: function (type) {
      // 判断列表来源
      if (type == "drawerCart") {
        // 监听滚动
        $(".cart-drawer_container_content-wrapper").scroll(function (event) {
          if (cartCollectionPageCount <= cartCollectionPageNo) return;
          // 调用商品集合滚动方法
          collectionFn.collectionScroll(type, $(this));
        });
      } else {
        window.addEventListener("scroll", function (e) {
          if (type === 'collectionPage') {
            if (collectionPageCount <= collectionPageNo) return;
          } else if (type == 'cartPage') {
            if (cartCollectionPageCount <= cartCollectionPageNo) return;
          } else if (type == 'searchPage') { 
            isNextPage = $("body")
            .find(".ls-featured-collection-loadmore")
            .attr("next");
            if (isNextPage === 'false') {
              return;
            }
          } else {
            if (collectionModulePageCount <= collectionModulePageNo) return;
          }
          // 调用商品集合滚动方法
          collectionFn.collectionScroll(type, $("body"));
        });
      }
    },

    // 调用商品集合滚动方法
    collectionScroll: function (type, dom) {
      // 获取滚动的高度，窗体的高度
      if (type == "drawerCart") {
        // 视图滚动的高度
        var scrollH = dom.scrollTop();
        // 视图的高度
        var contentH = dom.find(".cart-drawer_container_content").height();
        // 差值（窗口滚动到这个差值的时候，加载下一页）视图高度+一半商品块的高度
        var differenceH = $(window).height() + dom.find(".cart-drawer_container_content").find('.ls-product-block').height()*4;
      } else {
        var scrollH = $(window).scrollTop();
        var contentH = dom.height();
        // 差值（窗口滚动到这个差值的时候，加载下一页）视图高度+一半商品块的高度
        // 判断是否为搜索页推荐列表
        if (type == 'tab-collection') {
          var differenceH = $(window).height() + dom.find('.current-active').find('.ls-product-block').height()*5;
        } else {
          var differenceH = $(window).height() + dom.find('.ls-product-block').height()*7;
        }
      }
      // 窗体的高度-滚动的高度
      var differH = contentH - scrollH;
      if (differH <= differenceH) {
        if (busyLoading) {
          return;
        }
        // 调用加载下一页列表的方法
        collectionFn.loadMoreCollectionPage(type, dom);
      }
    },

    // 调用加载下一页列表的方法
    loadMoreCollectionPage: function (type, dom) {
      if (LS.site.page == 'collection' && type == 'collectionPage') {
        collectionFn.getCollectionPageList();
        return;
      } else if (type == 'tab-collection') {
        var listDom = dom.find(".tab-collection-list .current-active");
        var listCollectionId = listDom.find(".ls-featured-collection-listing").attr('data-collection-id');
        collectionFn.getCollectionModule({
          dom: listDom, 
          collectionId: listCollectionId, 
          canLoadMore: true
        });
      } else if (type == 'drawerCart' || type == 'cartPage') {
        var listDom = dom.find('.ls-cart-collection .ls-featured-collection-listing');
        var listCollectionId = listDom.attr('data-collection-id');
        collectionFn.getCollectionModule({
          dom: listDom, 
          collectionId: listCollectionId, 
          canLoadMore: true,
          handleType: 2
        });
      } else if (LS.site.page == 'search' && type == 'searchPage') {
        var dom = dom.find(".ls-search-model-list");
        var totalPages = parseInt(
          dom.find(".ls-featured-collection-listing").attr("totalpage")
        );
        var currentPage = parseInt(
          dom.find(".ls-featured-collection-listing").attr("currentpage")
        );
        // 获取是否限制最大商品页数
        var maxPage = parseInt(
          dom.find(".ls-featured-collection-listing").attr("maxpage")
        );
        var nextPage = currentPage + 1;
        if (nextPage > totalPages || ( maxPage && maxPage <= currentPage )) {
          return;
        }
        var getCollectionListUrl = `${location.href}&sections=looksky-main-search&page=${nextPage}`;
        var getCollectionName = 'looksky-main-search';
        dom.find(".ls-loadmore-img").show();
        busyLoading = true;
        // 调用下一页接口
        LS.ajax({
          url: getCollectionListUrl,
          type: "GET",
          dataType: "html",
          success: function (res) {
            busyLoading = false;
            // 获取接口数据
            var responseHTML = JSON.parse(res || 'null')[getCollectionName];
            // 赋值当前页参数
            dom
              .find(".ls-featured-collection-listing")
              .attr("currentpage", nextPage);
            // 加入页面
            dom
              .find(
                ".ls-featured-collection-listing .ls-featured-collection-product-list"
              )
              .append(
                $(responseHTML)
                  .find(
                    ".ls-featured-collection-listing .ls-featured-collection-product-list"
                  )
                  .html()
              );
            // 全局列表曝光方法
            LS.ui.globalListExposureHandle();
          },
          complete: function () {
            busyLoading = false;
            dom.find(".ls-loadmore-img").hide();
            if (nextPage > totalPages) {
              dom.find(".ls-featured-collection-loadmore").hide();
            }
          },
          error: function (error) {
            busyLoading = false;
          },
        });
      }
    }
  };

  LS.ui.collectionFn = {
    handleCollectAll: collectionFn.handleCollectAll,
    processingProductData: collectionFn.processingProductData,
    bindScrollType: collectionFn.bindScrollType,
    getCollectionPageList: collectionFn.getCollectionPageList,
    getCollectionModule: collectionFn.getCollectionModule,
    handleCollectionData: collectionFn.handleCollectionData
  };
})();

/**
 * 搜索页
 */
(function () {
  var searchFn = {
    // 调用搜索页面方法
    handleSearchAll: function () {
      var type = $('.ls-search-model-list').attr('type');
      if ( type == 'empty' ) {
        LS.ui.initTabCollection();
      } else {
        LS.ui.collectionFn.bindScrollType('searchPage');
      }
      // 点击事件方法
      searchFn.bindEvent();
      // 渲染搜索模块
      searchFn.initSearchLabel();
    },
    // 渲染搜索模块
    initSearchLabel: function () {
      // 定义模块
      var searchHtml = `
        <% if ( data.recentList && data.recentList.length > 0 ) { %>
          <div class="ls-search-label-list ls-search-label-recent" type="recent">
            <div class="label-list-title">
              <p class="title"><%t('search.recent_search_title') %></p>
              <p class="ls-search-delect-all"><%t('search.delete_all_btn') %></p>
            </div>
            <div class="label-list-li">
              <% for ( var item of data.recentList ) { %>
                <div class="li-box" value="<%= item %>"><%= item %></div>
              <% } %>
            </div>
          </div>
        <% } %>
        <div class="ls-search-label-list ls-search-label-hot" type="hot">
          <div class="label-list-title">
            <p class="title"><%t('search.hot_searches_title') %></p>
          </div>
          <div class="label-list-li">
            <% for ( var item of data.hotList ) { %>
              <div class="li-box" value="<%= item.text %>"><%= item.value %></div>
            <% } %>
          </div>
        </div>
      `;
      // 获取记录用户搜索数组
      var searchLabel = localStorage.getItem("looksky-search-label");
      var listArr = searchLabel ? searchLabel.split(',') : [];
      // 定义数据
      var searchLabelInfo = {
        recentList: listArr,
        hotList: [
          {
            value: LS.$t('search.hot_searches_li1'),
            text: 'Linen Dress'
          },
          {
            value: LS.$t('search.hot_searches_li2'),
            text: 'Linen Pants'
          },
          {
            value: LS.$t('search.hot_searches_li3'),
            text: 'Linen Top'
          },
          {
            value: LS.$t('search.hot_searches_li4'),
            text: 'Linen Skirt'
          },
          {
            value: LS.$t('search.hot_searches_li5'),
            text: 'Midi Dress'
          }
        ]
      }
      // 生成模块
      var getInfoListHtmlStr = LS.tmpl(searchHtml, searchLabelInfo);
      // 添加到弹窗
      $(".ls-search-model-header .ls-search-label").html(getInfoListHtmlStr);
      // 曝光模块
      // 历史搜索模块
      LS.ui.globalModelShowHandle(document.querySelector('.ls-search-label-recent'), LS.ui.searchReportMap['showRecentSearchBlock']);
      // 搜索默认页
      LS.ui.globalModelShowHandle(document.querySelector('.ls-search-label'), LS.ui.searchReportMap['showDefaultSearch']);
      // 搜索结果页
      LS.ui.globalModelShowHandle(document.querySelector('.ls-search-model-list'), LS.ui.searchReportMap['showResultsSearch'], {ext2: $('.ls-search-model-list').attr('num') }, 0);
    },
    
    // 点击事件方法
    bindEvent: function () {
      // 点击搜索按钮储存搜索词
      $(document).on("click", ".search-header-button", function () {
        // 获取输入框内容
        var val = $('.search-header-input').val();
        // 定义数组
        var searchList = [];
        // 判断输入框是否有值
        if ( !val || val.length > 50 ) { return false };
        // 判断储存值
        if ( localStorage.getItem("looksky-search-label") ) {
          // 获取数据
          var list = localStorage.getItem("looksky-search-label").split(',');
          // 判断搜索词是否数组里已经有了
          var index = list.indexOf(val);
          // 如果已经有了，则删除，并重新拼接至头部
          if ( index > -1 ) {
            list.splice(index, 1);
            // 然后把该参数添加至头部位置
            list.unshift(val);
          } else {
            // 判断已经储存的数组长度，如果大于20，则删除最后一条
            if ( list.length >= 20 ) {
              // 删除最后一个
              list.pop();
              // 把该参数添加至头部位置
              list.unshift(val);
            } else {
              // 把该参数添加至头部位置
              list.unshift(val);
            }
          }
          // 赋值
          searchList = list;
        } else {
          // 把该参数添加至头部位置
          searchList.unshift(val);
        }
        // 存储用户搜索关键词
        localStorage.setItem("looksky-search-label", searchList);
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.searchReportMap['clickSearch'],
          ext2: val,
        });
      });

      // 删除储存的搜索词
      $(document).on("click", ".ls-search-delect-all", function () {
        // 删除缓存值
        localStorage.removeItem("looksky-search-label");
        // 去除模块
        $('.ls-search-label-recent').remove();
      });

      // 点击label搜索
      $(document).on("click", ".ls-search-label-list .li-box", function () {
        // text
        var text =  $(this).attr('value');
        // 赋值给输入框，然后调用点击事件
        $('.search-header-input').val(text);
        $('.search-header-button').click();
        // 上报
        var type = $(this).parents('.ls-search-label-list').attr('type');
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.searchReportMap[type == 'recent' ? 'clickRecentSearch' : 'clickHotSearches'],
          ext2: text,
        });
      });

      // 删除输入框的值相关事件
      $('.search-header-input').bind('input propertychange',function(){
        if ( $(this).val() != '' ) {
          $(".search-header-inp-close").show();
        } else {
          $(".search-header-inp-close").hide();
        }
      })
      $(".search-header-input").focus(function() { 
        if ( $(this).val() != '' ) {
          $(".search-header-inp-close").show();
        }
      }); 
      $(".search-header-inp-close").click(function() {
        $('.search-header-input').val('');
        $(this).hide();
      });

      // 点击切换搜索推荐商品列表
      $(document).on('click','.search-collection-header li',function() {
        LS.ui.handleCollectionTab(this);
      });
    }
  };

  LS.ui.searchFn = {
    handleSearchAll: searchFn.handleSearchAll
  };
})();

/**
 * 集合商品弹窗加购物车方法
 */
(function () {
  var popProductDataJson = ""; // 商品json
  var popProductChooiseColor = ""; // 商品颜色
  var popProductChooisesize = ""; // 商品尺码// 移动端弹窗html片段参数定义
  var productPopupHtml = `
    <div class="ls-main-popupbox-overlay"></div>
		<div class="ls-main-popupbox-con fix-pos-bot" style="max-height: 90%;">
      <img class="product-popup-header_close-btn title-close" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls_icon_close_white_2x_199b037d-e6bb-4ac2-b041-85247b544b1e.png?v=1665736507" />
      <!-- 内容区域 -->
			<div class="main-popupbox-con-model">
        <!-- 中间区域 -->
        <div class="ls-popupbox-con-model-content">
          <div class="con-model-content-skuinfo">
            <% for ( let [ index, option ] of new Map( data.options_with_values.map( ( item, index ) => [ index, item ] ) ) ) { %>
              <div class="skuinfo-option-box skuinfo-option-box-<%= option.name %>">
                <div class="option-box-titlebox">
                  <p class="option-box-title option-box-title-<%= option.name %>">
                    <% if ( option.name == 'Size' ) { %>
                      <%t('public.add_pop.label_size', '', 1) %>:
                    <% } else if ( option.name == 'Color' ) { %>
                      <%t('public.add_pop.label_color', '', 1) %>:
                    <% } %>
                    <span class="option-box-title-active"></span>
                  </p>
                  <% if ( option.name == 'Size' && data.isKindBelongClothes  ) { %>
                    <div class="titlebox-right con-model-content-sizepop">
                      <a class="looksize-text ls-look-sizeguide-btn" productId="<%= data.id %>"><%t('public.add_pop.size_guide', '', 1) %></a>
                    </div>
                  <% } %>
                </div>
                <% if ( option.name == 'Color' ) { %>
                  <div class="option-box-list-img">
                    <% for ( let [ index2, item2 ] of new Map( option.values.map( ( item, index ) => [ index, item ] ) ) ) { %>
                      <% for ( item3 of data.images ) { %>
                        <% if ( item3.imageId == data.variants[Math.floor((data.variants.length/option.values.length)*index2)].imageId ) { %>
                          <% var imgSrc = item3.src; %>
                        <% } %>
                      <% } %>
                      <div class="list-img <% if ( index2 == 0 ) { %>list-img-active<% } %>" data-value="<%= item2 %>">
                        <% if ( imgSrc ) { %>
                          <div class="imgbox-wrapper">
                            <img class="imgbox" data-value="<%= item2 %>" data-img="<%= imgSrc.replace(".jpg", "_700x.jpg").replace(".png", "_700x.png") %>" src="<%= imgSrc.replace(".jpg", "_120x.jpg").replace(".png", "_120x.png") %>" />
                          </div>
                        <% } %>
                      </div>
                    <% } %>
                  </div>
                <% } else if ( option.name == 'Size' ) { %>
                  <div class="option-box-list-li">
                    <% for ( var item of option.values ) { %>
                      <div class="list-li <% if ( option.values.length == 1 ) { %>list-li-active<% } %>" data-value="<%= item %>">
                        <p class="pbox" data-value="<%= item %>"><%= item %></p>
                      </div>
                    <% } %>
                  </div>
                <% } %>
              </div>
            <% } %>
          </div>
          <!-- 在库商品提示模块 -->
          <div class="in-stock-tip-text-wrapper"></div>
          <!-- 预售商品提示模块 -->
          <p class="preorder-tiptext"></p>
          <div class="size-inclusions-wrapper">
            <div class="size-inclusions-inner">
              <div class="size-inclusions_label">Includes:</div>
              <div class="size-inclusions_content"></div>
            </div>
          </div>
          <!-- size table模块 -->
          <div class="size-table-wrapper" id="ls-product-content-size-table">
            <img class="loading-img" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/size-pop-loading.jpg?v=1662019146" />
          </div>
        </div>
				<!-- 底部区域 -->
        <div class="ls-popupbox-con-model-footer fix-padding-bot">
          <span class="price-sale-text product-popup-price" data-default-price="<%= data.defaultPrice %>">${LS.ui.countryInfoMap[LS.site.country].symbolCode}${LS.ui.countryInfoMap[LS.site.country].symbol}<%= (data.price/100).toFixed(2) %></span>
					<div class="con-model-popupbox-footer-btn">
            <div class="popupbox-footer-btn footer-addbag-button" id="ls-popup-addbag-button" data-add-to-cart-text="Add to bag">
              <% if (!data.oldId) { %>
                <%t('public.add_pop.add_to_bag_btn') %>
              <% } else { %>
                <%t('public.add_pop.update_btn') %>
              <% } %>
            </div>
						<div class="popupbox-footer-btn footer-buyitnow-button" id="ls-popup-buyitnow-button" data-checkout-source="buy_it_now" data-add-to-cart-text="Buy it now"><%t('public.add_pop.buy_it_now_btn') %></div>
					</div>
				</div>
			</div>
		</div>
	`;

  // sizeTable模块html
  var sizeTableHtml = `
    <!-- fittype提示信息 -->
    <% if ( data.fitTips && data.isKindBelongClothes ) { %>
      <div class="ls-size-table-tipbox-fittype">
        <div class="fittype-left">
          <p class="p1"><%t('public.add_pop.fit_description') %> <span class="sp1"><%= data.fitTips %></span></p>
        </div>
        <img class="open-icon" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/20220929-170006.png?v=1664442038" />
      </div>
    <% } %>
    <% if (  data.sizeHeaderList.length ) { %>
      <div class="ls-size-table-model">
        <!-- 判断当bodysize有数据时，展示tab切换，没有数据时，只展示productsize -->
        <div class="model-sizetable-box">
          <div class="model-sizetable-box-header">
            <ul class="header-menu-tabbox">
              <% for ( var [sizeHeaderIndex, sizeHeaderItem] of data.sizeHeaderList.entries() ) { %>
                <li <% if ( sizeHeaderIndex == 0 ) { %>class="active"<% } %> type="<%= sizeHeaderItem.type %>"><%= sizeHeaderItem.label %></li>
              <% } %>
            </ul>
            <div class="model-size-guide-chooise">
              <ul class="size-chooise-tab">
                <li class="active" type="in">inch</li>
                <div class="size-chooise-btnbox size-chooise-active"></div>
                <li type="cm">cm</li>
              </ul>
            </div>
          </div>
          <ul class="model-sizetable-box-content">
            <% for ( var [sizeHeaderIndex, sizeHeaderItem] of data.sizeHeaderList.entries() ) { %>
              <li class="sizetable-box-content-li sizetable-box-content-<%= sizeHeaderItem.type %> <% if ( sizeHeaderIndex == 0 ) { %>sizetable-current<% } %>">
                <% if ( sizeHeaderItem.type == 'body' ) { %>
                  <div class="ls-size-table-tipbox">
                    <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls-product-table-icon.png?v=1660122812" />
                    <p class="p1"><%= sizeHeaderItem.bodySizeTip %></p>
                  </div>
                <% } %>
              </li>
            <% } %>
          </ul>
        </div>
      </div>
    <% } %>
    <!-- 步骤条模块 -->
    <% if ( data.isKindBelongClothes && data.propertyGroup && data.propertyGroup.propertyList.length > 0 ) { %>
      <% for ( var item of data.propertyGroup.propertyList ) { %>
        <% if ( item.propertyOptionList ) { %>
          <div class="ls-product-type-step-bar">
            <div class="step-bar-line"></div>
            <div class="step-bar-box">
              <% for ( var item2 of item.propertyOptionList.slice(0, 6) ) { %>
                <div class="step-bar-boxcon <% if (item2.propertyOptionId == item.choosePropertyOptionIdList[0]) { %> step-bar-boxcon-active <% } %>" style="width:<%= 100/item.propertyOptionList.length %>%;">
                  <div class="step-bar-boxcon-dot"></div>
                  <div class="step-bar-boxcon-text"><%= item2.propertyOption %></div>
                </div>
              <% } %>
            </div>
          </div>
        <% } %>
      <% } %>
    <% } %>
    <!-- 模特模块 -->
    <% if ( data.isKindBelongClothes && data.mannequin && JSON.stringify(data.mannequin) != "{}" ) { %>
      <div class="ls-product-model-user-info">
        <div class="userinfo-left">
          <img src="<%= data.mannequin.headImage %>" />
        </div>
        <div class="userinfo-right">
          <p class="name"><%t('public.add_pop.model_text') %> <%= data.mannequin.modelSize ? data.mannequin.modelSize : '' %></p>
          <p class="p1">
            <%t('public.add_pop.model_height') %> <span class="sp1"><%= data.mannequin.height ? Math.round(data.mannequin.height*0.3937*100)/100 : '' %>"/<%= data.mannequin.height ? data.mannequin.height : '' %>cm</span>, 
            <%t('public.add_pop.model_bust') %> <span class="sp1"><%= data.mannequin.bust ? Math.round(data.mannequin.bust*0.3937*100)/100 : '' %>"/<%= data.mannequin.bust ? data.mannequin.bust : '' %>cm</span>, 
            <%t('public.add_pop.model_waist') %> <span class="sp1"><%= data.mannequin.waist ? Math.round(data.mannequin.waist*0.3937*100)/100 : '' %>"/<%= data.mannequin.waist ? data.mannequin.waist : '' %>cm</span>, 
            <%t('public.add_pop.model_hips') %> <span class="sp1"><%= data.mannequin.hips ? Math.round(data.mannequin.hips*0.3937*100)/100 : '' %>"/<%= data.mannequin.hips ? data.mannequin.hips : '' %>cm</span>. 
          </p>
        </div>
      </div>
    <% } %>
  `;
  var sizeTableContentHtml = `
    <% if ( data.tableListData && data.tableListData.length > 0 ) { %>
      <% for ( var tmpObj of data.tableListData ) { %>
        <div class="model-size-guide-product-size-box">
          <% if ( tmpObj.headerList.length > 0 ) { %>
            <ul class="size-ul-table">
              <!-- 第一个表格 -->
              <li class="tablebox tablebox-current <% if (tmpObj.headerList.length > 3) { %>tablebox-length<% } else { %>tablebox-only<% } %>">
                <% if (tmpObj.headerList.length <= 3) { %>
                  <div class="tablebox-thead">
                    <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                      <p style="width: calc(<%= 100/(tmpObj.headerList.length-1) %>% - <%= 74/(tmpObj.headerList.length-1) %>px);"><%= item %></p>
                    <% } %>
                  </div>
                  <div class="tablebox-tbody">
                    <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                      <div class="tablebox-tbody-tr">
                        <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <!-- 判断表格类型 -->
                          <% var tableTypeIndex = data.tableType === "1" ? "1" : "2";%>
                          <p style="width: calc(<%= 100/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>% - <%= 74/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>px);">
                            <% if ( index2 < tableTypeIndex ) { %>
                              <%= item[tmpObj.headerList[index2]] %>
                            <% } else if ( index2 >= tableTypeIndex ) { %>
                              <% if ( item[tmpObj.headerList[index2]] && item[tmpObj.headerList[index2]].indexOf("-") == -1 ) { %>
                                <%= Math.round(item[tmpObj.headerList[index2]]*0.3937*100)/100 %>
                              <% } else { %>
                                <% if ( item[tmpObj.headerList[index2]] ) { %>
                                  <% for ( let [ index3, item3 ] of new Map( item[tmpObj.headerList[index2]].split("-").map( ( item, index ) => [ index, item ] ) ) ) { %>
                                    <%= Math.round(item3*0.3937*100)/100 %><% if ( index3+1 < item[tmpObj.headerList[index2]].split("-").length ) { %> - <% } %>
                                  <% } %>
                                <% } %>
                              <% } %>
                            <% } %>
                          </p>
                        <% } %>
                      </div>
                    <% } %>
                  </div>
                <% } else { %>
                  <!-- 左边区域 -->
                  <!-- 判断表格类型 -->
                  <% var tableTypeIndex = data.tableType === "1" ? "1" : "2";%>
                  <div class="tablebox-length-left <% if (!data.isKindBelongClothes) { %>wider<% } %>">
                    <div class="tablebox-thead">
                      <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                        <% if ( index < tableTypeIndex ) { %>
                          <p><%= item %></p>
                        <% } %>
                      <% } %>
                    </div>
                    <div class="tablebox-tbody">
                      <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                        <div class="tablebox-tbody-tr">
                          <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                            <% if ( index2 < tableTypeIndex ) { %>
                              <p><%= item[tmpObj.headerList[index2]] %></p>
                            <% } %>
                          <% } %>
                        </div>
                      <% } %>
                    </div>
                  </div>
                  <!-- 右边区域 -->
                  <div class="tablebox-length-right">
                    <div class="tablebox-length-right-box">
                      <div class="tablebox-thead">
                        <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <% if ( index >= tableTypeIndex ) { %>
                            <p><%= item %></p>
                          <% } %>
                        <% } %>
                      </div>
                      <div class="tablebox-tbody">
                        <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <div class="tablebox-tbody-tr">
                            <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <% if ( index2 >= tableTypeIndex ) { %>
                                <p>
                                  <% if ( item[tmpObj.headerList[index2]] && item[tmpObj.headerList[index2]].indexOf("-") == -1 ) { %>
                                    <%= Math.round(item[tmpObj.headerList[index2]]*0.3937*100)/100 %>
                                  <% } else { %>
                                    <% if ( item[tmpObj.headerList[index2]] ) { %>
                                      <% for ( let [ index3, item3 ] of new Map( item[tmpObj.headerList[index2]].split("-").map( ( item, index ) => [ index, item ] ) ) ) { %>
                                        <%= Math.round(item3*0.3937*100)/100 %><% if ( index3+1 < item[tmpObj.headerList[index2]].split("-").length ) { %> -<% } %>
                                      <% } %>
                                    <% } %>
                                  <% } %>
                                </p>
                              <% } %>
                            <% } %>
                          </div>
                        <% } %>
                      </div>
                    </div>
                  </div>
                <% } %>
              </li>
              <!-- 第二个表格 -->
              <li class="tablebox <% if (tmpObj.headerList.length > 3) { %>tablebox-length<% } else { %>tablebox-only<% } %>">
                <% if (tmpObj.headerList.length <= 3) { %>
                  <div class="tablebox-thead">
                    <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                      <p style="width: calc(<%= 100/(tmpObj.headerList.length-1) %>% - <%= 74/(tmpObj.headerList.length-1) %>px);"><%= item %></p>
                    <% } %>
                  </div>
                  <div class="tablebox-tbody">
                    <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                      <div class="tablebox-tbody-tr">
                        <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <p style="width: calc(<%= 100/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>% - <%= 74/(Object.keys(tmpObj.sizeTableRowList[0]).length-1) %>px);"><%= item[tmpObj.headerList[index2]] %></p>
                        <% } %>
                      </div>
                    <% } %>
                  </div>
                <% } else { %>
                  <!-- 左边区域 -->
                  <!-- 判断表格类型 -->
                  <% var tableTypeIndex = data.tableType === "1" ? "1" : "2";%>
                  <div class="tablebox-length-left <% if (!data.isKindBelongClothes) { %>wider<% } %>">
                    <div class="tablebox-thead">
                      <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                        <% if ( index < tableTypeIndex ) { %>
                          <p><%= item %></p>
                        <% } %>
                      <% } %>
                    </div>
                    <div class="tablebox-tbody">
                      <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                        <div class="tablebox-tbody-tr">
                          <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                            <% if ( index2 < tableTypeIndex ) { %>
                              <p><%= item[tmpObj.headerList[index2]] %></p>
                            <% } %>
                          <% } %>
                        </div>
                      <% } %>
                    </div>
                  </div>
                  <!-- 右边区域 -->
                  <div class="tablebox-length-right">
                    <div class="tablebox-length-right-box">
                      <div class="tablebox-thead">
                        <% for ( let [ index, item ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <% if ( index >= tableTypeIndex ) { %>
                            <p><%= item %></p>
                          <% } %>
                        <% } %>
                      </div>
                      <div class="tablebox-tbody">
                        <% for ( let [ index, item ] of new Map( tmpObj.sizeTableRowList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                          <div class="tablebox-tbody-tr">
                            <% for ( let [ index2, item2 ] of new Map( tmpObj.headerList.map( ( item, index ) => [ index, item ] ) ) ) { %>
                              <% if ( index2 >= tableTypeIndex ) { %>
                                <p><%= item[tmpObj.headerList[index2]] %></p>
                              <% } %>
                            <% } %>
                          </div>
                        <% } %>
                      </div>
                    </div>
                  </div>
                <% } %>
              </li>
            </ul>
          <% } %>
        </div>
      <% } %>
    <% } %>
  `;

  // sizeguide数据
  var productSizeGuideDataInfo = '';
  var currentProductKindBelongObj = {};
  var productPopupFn = {
    // 调用创建弹窗方法
    lsCreatePopupHandle: function (obj) {
      var data = obj.data || {};
      var handle = obj.handle || '';
      var listType = obj.listType || '';
      var aid = obj.aid || 'empty';
      var type = obj.type || 'addtobag';
      var productBasicSource = obj.productBasicSource || 2;
      var dataDom = obj.dataDom || '';
      // 删除之前创建的弹窗
      $(".ls-main-popupbox-product").remove();
      // 创建弹窗
      var main_popup = document.createElement("div");
      var isKindBelong = LS.ui.isKindBelong(productBasicSource, dataDom);
      currentProductKindBelongObj = isKindBelong;
      main_popup.className = "ls-main-popupbox ls-main-popupbox-product";
      main_popup.setAttribute("productId", data.id);
      main_popup.setAttribute("handle", handle || '');
      main_popup.setAttribute("listType", listType || '');
      // 添加数据aid参数
      if ( aid ) {
        main_popup.setAttribute("aid", aid);
      }
      document.body.appendChild(main_popup);
      data.isKindBelongClothes = isKindBelong.clothes;
      data.isKindBelongKitchenOrAccessories = isKindBelong.kitchenOrAccessories;
      // 生成html片段代码
      try {
        var htmlStr = LS.tmpl(productPopupHtml, data);
      } catch (error) {
        //  LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
      }

      // 添加到弹窗页面
      $(".ls-main-popupbox-product").html(htmlStr);

      // 禁止弹窗底部滚动方法
      LS.ui.popupNoScrollHandle();

      if (type === 'addtobag' || type === 'selectsize' || type === 'selectsize_soldout') {
        $('.footer-addbag-button').show();
        $('.footer-buyitnow-button').hide();
        var textBtn = data.oldId ? LS.$t('public.add_pop.update_btn', '', 1) : LS.$t('public.add_pop.add_to_bag_btn', '', 1);
        $('.ls-main-popupbox-con').attr('data-popupbox-type', textBtn);

        if (type === 'selectsize_soldout') {
          LS.ui.toastShowHandle(
            LS.$t('public.add_pop.out_of_stock_tip')
          );
        }
      } else if (type === 'exchange') {
        $('.ls-popupbox-con-model-footer').html('<div class="return-form_exchange-select-btn-wrapper"><div class="common-submit-button" id="return-form-exchange-select-btn">Save</div></div>')
      } else {
        $('.footer-addbag-button').hide();
        $('.footer-buyitnow-button').show();
        $('.ls-main-popupbox-con').attr('data-popupbox-type', LS.$t('public.add_pop.buy_it_now_btn', '', 1));
      }


      // 初始参数
      var editPop = (data.color || data.size) ? "edit" : "";
      // 根据元字段size库存样式展示方法
      productPopupFn.productSkuStyle(data, editPop ? data.color : data.variants[0].option1);
      productPopupFn.productPopParameMethod(data, editPop);

      // 调用获取商品size相关信息的方法
      productPopupFn.getProductPropertyHandle(data);
      // icon点击，弹窗曝光上报
      productPopupFn.addToBagReportExposureClickHanlde(data, LS.ui.reportType['moduleShow'], LS.ui.productReportMap['showSizeSelectPopProduct']);
    },

    // addtobag弹窗曝光、点击方法
    addToBagReportExposureClickHanlde(data, eid, reportType) {
      // 数据
      var param = {
        "products": {
          id: data.id + '',
          title: data.title,
          price: data.price/100,
        }
      };
      // 如果集合携带aid，则上报aid
      var aid = $('.ls-main-popupbox-product').attr('aid');
      LS.stat({
        eid: eid,
        aid: aid || 'empty',
        ext1: reportType,
        ext2: JSON.stringify(param),
        ext3: LS.site.page,
        ext4: $('.ls-main-popupbox-product').attr('handle'),
      });
    },
    handleClickSize: function(sizeIndex, type, self) {
      var curCountry = LS.ui.countryInfoMap[LS.site.country];
      var countrySymbolCode = curCountry.symbolCode + curCountry.symbol;
      var pageType = $('html').attr('page');
      var productPopupbox = $('.ls-main-popupbox-product');
      var productPopId = productPopupbox.attr('productid');
      var productPageId = $('.product-container').attr('data-product-id');
      var productPopupboxPriceDom = productPopupbox.find('.product-popup-price');
      var productOriginPrice = productPopupboxPriceDom.attr('data-default-price');
      var clickVariantPrice = $(self).attr('data-price');
      var clickVariantPriceStr = (clickVariantPrice/100).toFixed(2);
      var productOriginPriceStr = (productOriginPrice/100).toFixed(2);
      var productPopupboxPriceDomText = type == 1 ? clickVariantPriceStr : productOriginPriceStr;
      productPopupboxPriceDom.text(countrySymbolCode + productPopupboxPriceDomText);
      if (pageType == 'product' && productPopId == productPageId) {
        // 选择size
        $(`.product-container .size-item:eq(${sizeIndex})`).click();
        var selectedVairant = type == 1 ? {
          price: clickVariantPrice,
          comparePrice: $(self).attr('data-compare-price')
        } : '';
        LS.ui.productFn.handleSelectedVairantPrice(selectedVairant);
      }

    },
    /**
     * 商品弹窗参数方法
     */
    productPopParameMethod: function (data, type) {
      // 商品弹窗数据
      popProductDataJson = data;
      // 判断当弹窗不是编辑弹窗时，进行初始参数赋值
      if ( !type ) {
        // 商品颜色, 默认选中第一个颜色
        popProductChooiseColor = data.variants[0].option1;
        // 商品尺码, 当尺码数量为一个时，默认选中
        if (
          data.options_with_values &&
          data.options_with_values[1].values.length == 1
        ) {
          popProductChooisesize = data.options_with_values[1].values[0];
        } else {
          popProductChooisesize = "";
        }
        // 显示对应颜色
        popProductChooiseColor && $('.ls-main-popupbox-product').find(".skuinfo-option-box-Color").find(".option-box-title-active").text(popProductChooiseColor);
      } else {
        // 赋值编辑弹窗默认参数
        popProductChooiseColor = data.color || '';
        popProductChooisesize = data.size || '';
        // 判断商品尺码, 当尺码数量为一个时，默认选中
        if ( data.options_with_values && data.options_with_values[1].values.length == 1 ) {
          popProductChooisesize = data.options_with_values[1].values[0];
        }
        // 显示对应颜色
        popProductChooiseColor && $('.ls-main-popupbox-product').find(".skuinfo-option-box-Color").find(".option-box-title-active").text(popProductChooiseColor);
        // 显示对应尺码
        popProductChooisesize && $('.ls-main-popupbox-product').find(".skuinfo-option-box-Size").find(".option-box-title-active").text(popProductChooisesize);
        // 展示相关样式
        $(".option-box-list-img").find(".list-img").removeClass("list-img-active");
        // 选中边框
        $('.ls-main-popupbox-product').find(".option-box-list-img").find(".list-img[data-value='"+popProductChooiseColor+"']").addClass("list-img-active");
        $('.ls-main-popupbox-product').find(".option-box-list-li").find(".list-li[data-value='"+popProductChooisesize+"']").addClass("list-li-active");
        // 弹窗商品主图
        // 获取点击的颜色的图片替换弹窗主图
        var clickColorimg = $('.ls-main-popupbox-product').find('.list-img-active').find("img").attr("data-img");
        $('.ls-main-popupbox-product').find(".featureimage").attr("src", clickColorimg);
        // 显示表格模块
        popProductChooisesize && $(".ls-main-popupbox-product").find('#ls-product-content-size-table').show();
        // preorder展示逻辑方法
        productPopupFn.productSkuPreOrder(data, popProductChooiseColor, popProductChooisesize);
      }
      if (popProductChooisesize) {
        $('.in-stock-tip-text-wrapper').html(` <div class="in-stock-tip-text">${LS.$t('public.add_pop.text_in_stock')}</div>`);
        productPopupFn.showProductSizeInclusions(currentProductKindBelongObj, popProductChooisesize);
      } else {
        $('.in-stock-tip-text-wrapper').html('');
      }
    },
    showProductSizeInclusions: function(kindBelongObj, productSize) {
      if (kindBelongObj.clothes) return;
      var sizeInclusions = LS.ui.matchProductKindSizeInclusions(kindBelongObj, productSize);
      if (sizeInclusions !== '') {
        $('.size-inclusions-wrapper').show();
        $('.size-inclusions-wrapper .size-inclusions_content').text(sizeInclusions)
      }
    },
    clearProductSizeInclusions: function() {
      $('.size-inclusions-wrapper').hide();
      $('.size-inclusions-wrapper .size-inclusions_content').text('')
    },
    /**
     *
     * 商品弹窗事件方法
     */
    productPopBindEvent: function () {
      // 点击icon关闭弹窗
      $(document).on(
        "click",
        ".ls-main-popupbox .title-close, .popupbox-container_close-btn-outside, .popupbox-container_close-btn-inside",
        function () {
          // 恢复弹窗底部滚动方法
          LS.ui.popupRecoveryScrollHandle();
          $(this).parents(".ls-main-popupbox").hide();
          // 判断是否为商品弹窗
          var id = $(this).parents(".ls-main-popupbox").attr('productid');
          if (id) {
            LS.stat({
              eid: LS.ui.reportType['click'],
              ext1: LS.ui.reportMap['closeChangeSkuDrawer'],
            });
          }
        }
      );
      // 点击遮罩层关闭弹窗
      // $(document).on(
      //   "click",
      //   ".ls-main-popupbox .ls-main-popupbox-overlay",
      //   function () {
      //     // 恢复弹窗底部滚动方法
      //     LS.ui.popupRecoveryScrollHandle();
      //     $(this).parents(".ls-main-popupbox").hide();
      //     // 判断是否为商品弹窗
      //     var id = $(this).parents(".ls-main-popupbox").attr('productid');
      //     if (id) {
      //       LS.stat({
      //         eid: LS.ui.reportType['click'],
      //         ext1: LS.ui.reportMap['clickChangeSkuOverlay'],
      //       });
      //     }
      //   }
      // );

      // 点击选中color
      $(document).on(
        "click",
        ".ls-main-popupbox-con .option-box-list-img .list-img",
        function () {
          // 获取点击的颜色的图片替换弹窗主图
          var clickColorimg = $(this).find("img").attr("data-img");
          var colorIndex = $(this).index();
          $(this)
            .parents(".main-popupbox-con-model")
            .find(".featureimage")
            .attr("src", clickColorimg);
          // 点击添加选中样式
          $(this)
            .parents(".option-box-list-img")
            .find(".list-img")
            .removeClass("list-img-active");
          $(this).addClass("list-img-active");
          $('.ls-main-popupbox-product').find(".skuinfo-option-box-Size").find(".option-box-title-active").text('');
          // 获取选中的颜色
          popProductChooiseColor = $(this).find("img").attr("data-value");
          // 显示对应颜色
          $(this).parents(".skuinfo-option-box").find('.option-box-title-active').text(popProductChooiseColor);
          // sku库存样式展示方法
          productPopupFn.productSkuStyle(
            popProductDataJson,
            popProductChooiseColor
          );
          // preorder展示逻辑方法
          productPopupFn.productSkuPreOrder(
            popProductDataJson,
            popProductChooiseColor,
            popProductChooisesize
          );
          // 上报
          // 获取sku的颜色值
          var skuColorList = popProductDataJson.variants.filter(item => item.option1 == popProductChooiseColor);
          var skuColor = skuColorList[0].sku.split('-')[1];
          var param = {
            "products": {
              id: $('.ls-main-popupbox-product').attr('productid') + '',
              color: skuColor,
            }
          };
          // 如果集合携带aid，则上报aid
          var aid = $('.ls-main-popupbox-product').attr('aid');
          LS.stat({
            eid: LS.ui.reportType['click'],
            aid: aid || 'empty',
            ext1: LS.ui.productReportMap['clickBagPopColor'],
            ext2: JSON.stringify(param || [])
          });

          // 判断是否为详情页，并且商品为同一个，一起选中
          var pageType = $('html').attr('page');
          var productPopId = $('.ls-main-popupbox-product').attr('productid');
          var productPageId = $('.product-container').attr('data-product-id');
          if (pageType == 'product' && productPopId == productPageId) {
            // 选择color
            $(`.product-container .color-item:eq(${colorIndex})`).click();
          }
        }
      );

      // 点击选中size
      $(document).on(
        "click",
        ".ls-main-popupbox-con .option-box-list-li .list-li",
        function () {
          var sizeIndex = $(this).index();
          var selectedOptDom = $('.ls-main-popupbox-product').find(".skuinfo-option-box-Size").find(".option-box-title-active");
          $(this).parents(".option-box-list-li").find(".list-li").removeClass("list-li-active");
          selectedOptDom.text('');
          var currentSize = $(this).find("p").attr("data-value");
          // 判断是否为详情页，并且商品为同一个、不是售罄，一起选中
          if ($(this).hasClass('list-li-no-Inventory')) {
            popProductChooisesize = '';
            $('.in-stock-tip-text-wrapper').html('');
            productPopupFn.clearProductSizeInclusions();
            productPopupFn.handleClickSize(sizeIndex, 0);
            LS.ui.toastShowHandle(
              LS.$t('public.add_pop.out_of_stock_tip')
            );
            return;
          }
          // 点击添加选中样式
          $(this).addClass("list-li-active");
          var tbodyList = $(this).parents('.ls-main-popupbox-product').find('.tablebox-tbody');
          try {
            var tbodyListLength = tbodyList.length;
            if (tbodyListLength > 0) {
              for (var i = 0; i < tbodyListLength; i++) {
                var tbodyListItem = $(tbodyList[i]);
                tbodyListItem.find(`.tablebox-tbody-tr:eq(${sizeIndex})`).addClass('tablebox-tbody-tr-active').siblings().removeClass('tablebox-tbody-tr-active');
              }
            }
          } catch (error) {
          }
          // 获取选中的尺码
          popProductChooisesize = currentSize;
          selectedOptDom.text(popProductChooisesize);
          $('.in-stock-tip-text-wrapper').html(`<div class="in-stock-tip-text">${LS.$t('public.add_pop.text_in_stock')}</div>`);
          productPopupFn.showProductSizeInclusions(currentProductKindBelongObj, currentSize);
          // preorder展示逻辑方法
          productPopupFn.productSkuPreOrder(
            popProductDataJson,
            popProductChooiseColor,
            popProductChooisesize
          );
          // 显示表格模块
          $(".ls-main-popupbox-product").find('#ls-product-content-size-table').show();
          productPopupFn.handleClickSize(sizeIndex, 1, this);
          // 上报
          var param = {
            "products": {
              id: $('.ls-main-popupbox-product').attr('productid') + '',
              size: popProductChooisesize,
            }
          };
          // 如果集合携带aid，则上报aid
          var aid = $('.ls-main-popupbox-product').attr('aid');
          LS.stat({
            eid: LS.ui.reportType['click'],
            aid: aid || 'empty',
            ext1: LS.ui.productReportMap['clickSelectSize'],
            ext2: JSON.stringify(param || [])
          });
        }
      );

      // 点击弹窗加购按钮
      $(document).on("click", "#ls-popup-addbag-button", function () {
        // if ($(this).hasClass('con-model-footer-disabled')) return;
        // 判断是否选中color以及size
        if (popProductChooiseColor && popProductChooisesize) {
          // 根据选中的颜色和尺码，筛选出对应variants的id
          var variantsID = popProductDataJson.variants.filter(
            (item) =>
              item.option1 == popProductChooiseColor &&
              item.option2 == popProductChooisesize
          );
          var productData = {
            id: variantsID[0].variantId,
            quantity: popProductDataJson.quantity || 1,
            productId: popProductDataJson.id
          };
          if (popProductDataJson.oldId) {
            Object.assign(productData, { oldId: popProductDataJson.oldId, cartVariantList: popProductDataJson.cartVariantList });
          }

          var handleType = productData.oldId ? "update" : "add";
          productPopupFn.productAddToBag(productData, handleType, $(this));
        } else {
          // toast方法
          LS.ui.toastShowHandle(LS.ui.errorMsgMap.noSize);
          // 加购上报方法
          var source = LS.ui.getSourceByAddToCart();
          productPopupFn.addToBagReportHandle(popProductDataJson, 2, source);
        }
      });

      $(document).on("click", "#return-form-exchange-select-btn", function () {
        if (!popProductChooiseColor || !popProductChooisesize) {
          LS.ui.toastShowHandle('Please choose your size.');
          return;
        }
        var exchangeVariant = popProductDataJson.variants.filter(
          (item) =>
            item.option1 == popProductChooiseColor &&
            item.option2 == popProductChooisesize
        );
        LS.ui.returnFormFn.selectExchangeVariant && LS.ui.returnFormFn.selectExchangeVariant(exchangeVariant[0]);
        // $(".popupbox_return-form_exchange").hide();
        $(".ls-main-popupbox-product").hide();
        // 恢复弹窗底部滚动方法
        LS.ui.popupRecoveryScrollHandle();
      })

      
      $(document).on("click", "#ls-popup-buyitnow-button", function () {
        var that = this;
        if ($(this).hasClass('con-model-footer-disabled')) return;
        // 判断是否选中color以及size
        if (popProductChooiseColor && popProductChooisesize) {
          // 根据选中的颜色和尺码，筛选出对应variants的id
          var variantItem = popProductDataJson.variants.find(
            (item) =>
              item.option1 == popProductChooiseColor &&
              item.option2 == popProductChooisesize
          );
          if (variantItem) {
            var variantId = variantItem.variantId + '';
            var selectOpts = $("#product-select").find(
              ".product-select_option-item"
            );
            for (var i = 0, len = selectOpts.length; i < len; i++) {
              var target = $(selectOpts[i]) || null;
              // target.removeAttr("selected");
              if ($(target).attr('data-variant-id') === variantId) {
                // target.attr("selected", "selected");
                $('.original-selector').val(target.val());
                // 设置form 尺码id
                var formSkuInp = $('.product-container').parents().children('form').find('input[name="id"]') || null;
                formSkuInp && formSkuInp.val(variantId);
                LS.ui.setCheckoutSource(that);
                setTimeout(() => {
                  LS.ui.handleBuyitnowBtn();
                }, 300);
                _report(1);
              }
            }
          }
        } else {
          // toast方法
          LS.ui.toastShowHandle(LS.ui.errorMsgMap.noSize);
          _report();
        }

        function _report(status = 0) {
          var dataJson = {
            id: popProductDataJson.id + '',
            title: popProductDataJson.title,
            sku: status === 1 ? `${variantId}-${popProductChooiseColor}-${popProductChooisesize}` : 0,
            price: popProductDataJson.price / 100,
          };
          var param = {
            "products": dataJson
          }
          var ext4 = {
            total: popProductDataJson.price / 100,
            currency: LS.site.currency,
            sum: 1
          }
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.productReportMap['clickCheckoutBuyitnow'],
            ext2: JSON.stringify(param || ''),
            ext3: document.referrer ? LS.cookie.get("looksky-pagefrom") : "none",
            ext4: status === 1 ? JSON.stringify(ext4) : '',
            ext6: status === 1 ? 'op=ok' : 'op=no_size',
          });
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.productReportMap['clickBuyitnowToAddToBag'],
            ext2: JSON.stringify(param || ''),
            ext3: `total=${popProductDataJson.price / 100}`,
            ext6: status === 1 ? 'op=ok' : 'op=no_size',
          });
        }
      });

      // 点击查看sizeguide
      $(document).on("click", ".ls-main-popupbox-product .ls-look-sizeguide-btn", function () {
        // 调用sizeGuideFn方法
        LS.ui.sizeGuideFn && LS.ui.sizeGuideFn.productSizeGuideDataInfoHandle(productSizeGuideDataInfo, $(this));
      });

      // size table尺寸类型tab切换
      $(document).on('click','.size-chooise-tab',function(){
        var sizeType = $(this).find('.active').attr('type');
        // tab样式切换
        if ( sizeType == 'in' ) {
          // 样式修改
          $('.size-chooise-tab').find('.size-chooise-btnbox').removeClass('size-chooise-active');
          $('.size-chooise-tab').find("li:eq(0)").removeClass('active');
          $('.size-chooise-tab').find("li:eq(1)").addClass('active');
          // 表格切换
          $('.ls-size-table-model .model-size-guide-product-size-box').find('.size-ul-table').children('li').removeClass('tablebox-current');
          $('.ls-size-table-model .model-size-guide-product-size-box').find('.size-ul-table li:eq(1)').addClass('tablebox-current');
        } else {
          // 样式修改
          $('.size-chooise-tab').find('.size-chooise-btnbox').addClass('size-chooise-active');
          $('.size-chooise-tab').find("li:eq(0)").addClass('active');
          $('.size-chooise-tab').find("li:eq(1)").removeClass('active');
          // 表格切换
          $('.ls-size-table-model .model-size-guide-product-size-box').find('.size-ul-table').children('li').removeClass('tablebox-current');
          $('.ls-size-table-model .model-size-guide-product-size-box').find('.size-ul-table li:eq(0)').addClass('tablebox-current');
        }
        // 上报
        var param = {
          "products": {
            id: $(this).parents('.ls-main-popupbox-product').length > 0 ? $(this).parents('.ls-main-popupbox-product').attr('productid') + '' : $(this).parents('.product-container').attr('data-product-id') + '',
          }
        };
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.productReportMap[`${sizeType == 'in' ? 'clickSizeUnitCm' : 'clickSizeUnitInch'}`],
          ext2: JSON.stringify(param || [])
        });
      });

      // productsize和bodysize表格切换
      $(document).on('click','.model-sizetable-box-header .header-menu-tabbox li',function(){
        var tabIndex = $(this).index();
        var tabType = $(this).attr('type');
        // tab样式切换
        $(this).addClass('active').siblings().removeClass('active');
        // table内容切换
        $(this).parents('.ls-size-table-model').find('.model-sizetable-box-content .sizetable-box-content-li').removeClass('sizetable-current');
        $(this).parents('.ls-size-table-model').find(".model-sizetable-box-content .sizetable-box-content-li:eq(" + tabIndex +")").addClass('sizetable-current');
        // 上报
        var param = {
          "products": {
            id: $(this).parents('.ls-main-popupbox-product').length > 0 ? $(this).parents('.ls-main-popupbox-product').attr('productid') + '' : $(this).parents('.product-container').attr('data-product-id') + '',
          }
        };
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.productReportMap[`${tabType == 'product' ? 'clickProductSizeAbt' : 'clickBodySizeAbt'}`],
          ext2: JSON.stringify(param || [])
        });
      });

      // 点击展开fit type文案
      $(document).on('click', '.ls-main-popupbox-product .ls-size-table-tipbox-fittype', function() {
        // 判断模块显示状态
				if ($(this).find('.open-icon').hasClass('close-icon')) {
					// 隐藏模块
          $(this).find('.open-icon').removeClass('close-icon');
          $(this).find('.fittype-left').removeClass('fittype-left-show');
				} else {
					// 显示模块
          $(this).find('.open-icon').addClass('close-icon');
          $(this).find('.fittype-left').addClass('fittype-left-show');
				}
      });
    },

    /**
     * 加购下拉抽屉
     * @param {*} data
     * @param {*} type add添加、update购物车更新尺码
     */
    productAddToBag: function (data, type = "add", dom) {
      var requestUrl, params;
      var curId = data.id;
      var curQuantity = data.quantity;
      var oldId = data.oldId || '';
      if (type === "update") {
        var cartVariantList = data.cartVariantList || [];
        var cartVariantListLen = cartVariantList.length;
        if (cartVariantListLen) {
          for (var i = 0; i < cartVariantListLen; i++) {
            var cartVariantData = cartVariantList[i];
            // 变更的variantId已存在购物车列表中，需进行累加
            if (cartVariantData.variantId == curId) {
              curQuantity = Number(cartVariantData.quantity) + Number(curQuantity);
            }
          }
        }
        requestUrl = LS.ui.routes.updateCartItemUrl;
        params = {
          updates: {
            [oldId]: 0,
            [curId]: curQuantity,
          },
        };
      } else {
        requestUrl = LS.ui.routes.addCartItemUrl;
        params = {
          id: curId,
          quantity: curQuantity,
        };
      }
      LS.ajax({
        url: requestUrl,
        type: "POST",
        data: params,
        success: function (res) {
          var source = LS.ui.getSourceByAddToCart();
          // toast方法
          LS.ui.toastShowHandle(
            oldId ? LS.$t('public.toast.update_succ_toast') : LS.$t('public.toast.add_succ_toast')
          );
          // 保存该商品id
          LS.ui.saveLastProductByAddCart(data.productId);
          if (source === 'clickAddtobagBoughtTogether') {
            LS.ui.cartFn.request && LS.ui.cartFn.request(false, 1);
          } else {
            LS.ui.cartFn.getCartDataInfo && LS.ui.cartFn.getCartDataInfo(2, 1);
          }
          
          // 购物车内容置顶
          $('.cart-drawer_container_content-wrapper').animate({
            scrollTop: 0
          }, 500);
          // 隐藏弹窗
          $(".ls-main-popupbox-product").hide();
          // 恢复弹窗底部滚动方法
          LS.ui.popupRecoveryScrollHandle();
          if (res && type === "update") {
            var cartItem = res.items && res.items.length > 0 ? res.items[0] : [];
            var ext2 = JSON.stringify([{ id: cartItem.product_id, sku: cartItem.sku }]);
            LS.stat({
              eid: LS.ui.reportType['click'],
              ext1: LS.ui.reportMap['updateCartItem'],
              ext2
            });
          } else if (res && type === "add") {
            // 加购上报方法
            productPopupFn.addToBagReportHandle(res, 1, source);
            LS.ui.pintrkFn.addToCart && LS.ui.pintrkFn.addToCart(res.product_id);
            LS.ui.bingFn.eventReport && LS.ui.bingFn.eventReport('add_to_cart', res.final_price);
          }
          type === 'add' && LS.ui.setAddCartAnimation($('.list-img-active .imgbox').attr('src'));
          // 判断当为详情页加购物车时，滚动到alsolike区域
          if (LS.site.page === 'product' && type === 'add') {
            setTimeout(function() {
              LS.ui.productFn.alsoLikeScrollToHandle();
            }, 1500);
          }
        },
        error: function (error) {
           LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },

    // 加购上报方法
    addToBagReportHandle(dataInfo, type, addType) {
      // 判断加购类型，如果加购成功取接口返回数据，没有加购成功取弹窗商品信息
      if ( type == 1 ) {
        var param = {
          "products": {
            id: dataInfo.product_id + '',
            sku: dataInfo.sku,
            title: dataInfo.product_title,
            price: dataInfo.price/100
          }
        }
      } else if ( type == 2 ) {
        var param = {
          "products": {
            id: dataInfo.id + '',
            sku: '0',
            title: dataInfo.title,
            price: dataInfo.price/100
          }
        }
      }
      var ext2 = JSON.stringify(param);
      // 获取dom结构，判断是否为侧边栏购物车加购
      var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
      // 获取页面类型
      var pageType = cartDrawerOpen ? 'cart' : LS.site.page;
      // 判断加购类型
      // 定义加购商品来源
      var addToBagProductFrom = "none";
      pageType === 'product' && (addToBagProductFrom = ($('.ls-main-popupbox-product').attr('handle') || !document.referrer ) ? "none" : LS.cookie.get("looksky-pagefrom"));
      // 如果集合携带aid，则上报aid
      var aid = $('.ls-main-popupbox-product').attr('aid');
      // 上报
      LS.stat({
        eid: LS.ui.reportType['click'],
        aid: aid || 'empty',
        ext1: LS.ui.productReportMap[addType],
        ext2: ext2,
        ext3: addToBagProductFrom,
        ext4: $('.ls-main-popupbox-product').attr('handle'),
        ext6: `op=${type == 1 ? 'ok' : 'no_size'}`
      });
    },

    // 加载弹窗时根据元字段metafields进行sku区域样式展示方法
    productSkuStyle: function (data, color) {
      // 判断是否有元字段信息
      if ( !data.variants || !data.variants[0].sellType || !data.variants[0].soldOutStatus ) {
        return;
      }
      // 根据选中的颜色，获取变体中符合的颜色列表
      var filterColorArr = data.variants.filter(
        (item) => item.option1 == color
      );
      // 根据商品sku的售磬状态判断样式
      for (let i = 0; i < filterColorArr.length; i++) {
        var targetItem = filterColorArr[i];
        var targetLi = $(
          ".ls-popupbox-con-model-content .option-box-list-li .list-li:eq(" +
            i +
            ")"
        );
        targetLi.attr('data-price', targetItem.price);
        targetLi.attr('data-compare-price', targetItem.comparePrice);
        if (
          targetItem.soldOutStatus == 1 &&
          targetItem.sellType == 1
        ) {
          targetLi.addClass("list-li-no-Inventory");
        } else {
          if (LS.ui.isOtherCountrySoldout(targetItem.otherCountrySellable)) {
            targetLi.addClass("list-li-no-Inventory");
          } else { 
            targetLi.removeClass("list-li-no-Inventory");
          }
        }
      }
    },

    handleSoltoutStyle: function() {
      $('.ls-main-popupbox-product').find(".option-box-list-li").find(".list-li[data-value='"+popProductChooisesize+"']").removeClass("list-li-active");
      popProductChooisesize = '';
      $('.ls-main-popupbox-product').find(".skuinfo-option-box-Size").find(".option-box-title-active").text('');
      // toast方法
      LS.ui.toastShowHandle(
        LS.$t('public.add_pop.out_of_stock_tip')
      );
    },

    // 加载弹窗时根据元字段metafields进行preorder展示方法
    productSkuPreOrder: function (data, color, size) {
      // 判断是否有元字段信息
      if ( !data.variants || !data.variants[0].sellType || !data.variants[0].soldOutStatus ) {
        return;
      }
      // 判断是否选中color以及size
      if (color && size) {
        // 根据选中的颜色和尺码，筛选出对应variants的id
        var variantsData = data.variants.filter(
          (item) => item.option1 == color && item.option2 == size
        );
        // 获取当前选中的变体
        var skuMetafieldsList = variantsData;
        // 获取preoder的dom
        var $preorder = $(".ls-main-popupbox-product").find(
          ".preorder-tiptext"
        );
        // var btnTypeText = $(".ls-main-popupbox-con").attr('data-popupbox-type');
        // 获取元字段数据
        // 判断商品售卖类型sellType 1:售完即下架; 2:售完转预售 3:售完转正常 4:上线即预售
        // 售磬状态soldOutStatus 1:售磬 2:未售磬
        // presellTip: 预售提示
        // presellTime: 预售时间
        // 判断是否有数据
        if (skuMetafieldsList.length > 0) {
          // 判断售卖类型
          if (skuMetafieldsList[0].sellType == 1) {
            if (
              skuMetafieldsList[0].soldOutStatus == 1
            ) {
              LS.ui.productPopupFn.handleSoltoutStyle();
            } else {
              if (LS.ui.isOtherCountrySoldout(skuMetafieldsList[0].otherCountrySellable)) {
                LS.ui.productPopupFn.handleSoltoutStyle();
              }
            }
            // 隐藏去除预售文案
            $preorder.hide();
            $preorder.html('');
          } else {
            if (LS.ui.isOtherCountrySoldout(skuMetafieldsList[0].otherCountrySellable)) {
              LS.ui.productPopupFn.handleSoltoutStyle();
            } else {
              // 判断预售tip提示显示状态
              if (
                (skuMetafieldsList[0].soldOutStatus == 1 &&
                  skuMetafieldsList[0].sellType == 2) ||
                skuMetafieldsList[0].sellType == 4
              ) {
                // 获取preorder预售文案方法
                productPopupFn.getProductPreOrderText(skuMetafieldsList[0], $preorder);
                $preorder.show();
                // 隐藏在库提示
                $('.in-stock-tip-text-wrapper').hide();
              } else {
                // 隐藏去除预售文案
                $preorder.hide();
                $preorder.html('');
                // 显示在库提示
                $('.in-stock-tip-text-wrapper').show();
              }
            }
          }
        }
      }
    },

    // 获取preorder预售文案方法
    getProductPreOrderText: function(data, dom, noInsert) {
      var res = '';
      // 判断是转码预售（没有固定时间，当前时间+20天），缺货预售（有固定发货时间段）
      if ( data.presellDays > 0 ) {
        // 获取当前时间时间搓
        var timestampNow = new Date().getTime();
        // 当前时间搓 + 预售天数
        var addTime = timestampNow + data.presellDays*24*60*60*1000;
        // 获取时间格式
        // var timeFormat = LS.ui.singleDayDateFormat(addTime);
        var timeFormat = LS.i18n.fmtTime(addTime);
        res = LS.$t('product.details.pre_order_text1', { time: timeFormat });
        !noInsert && $(dom).html(res);
      } else {
        // 当开始时间和结束时间相同时，取开始时间
        if ( data.presellStartTime == data.presellEndime ) {
          data.presellEndime = data.presellEndime + 432000000; // 默认加5天
        }
        // 获取时间格式
        var presellStartTime = LS.i18n.fmtTime(data.presellStartTime);
        var presellEndime = LS.i18n.fmtTime(data.presellEndime);
        presellStartTime = LS.ui.formatMonthToEnglish(presellStartTime);
        presellEndime = LS.ui.formatMonthToEnglish(presellEndime);
        res = LS.$t('product.details.pre_order_text2', { time: presellStartTime + ' - ' + presellEndime });
        !noInsert && $(dom).html(res);
      }
      return res;
    },

    // 调用获取商品size相关信息的方法
    getProductPropertyHandle: function (data) {
      LS.ajax({
        url: LS.ui.routes.getQueryProductPropertyInfoApi,
        type: "GET",
        data: {
          productId: data.id,
        },
        success: function (response) {
          // 判断接口状态
          if (!response.hasError && response.code == "0") {
            // 获取接口数据
            var getProductPropertyInfo = response.data;
            // 当商品size guide有size数据时，显示入口
            if ( getProductPropertyInfo.productDetailSizeTablePropertyList && getProductPropertyInfo.productDetailSizeTablePropertyList.length > 0 ) {
              $('.ls-main-popupbox-product').find('.con-model-content-sizepop').show();
              // 调用全局获取sizeguide数据方法
              LS.ui.getSizeGuideDataHandle(data.id, function(sizeData){
                sizeData.isKindBelongClothes = data.isKindBelongClothes;
                sizeData.isKindBelongKitchenOrAccessories = data.isKindBelongKitchenOrAccessories;
                // 赋值
                productSizeGuideDataInfo = sizeData;
                // 创建size表格
                LS.ui.productPopupFn.createSizeTable(sizeData, $("#ls-product-content-size-table"));
              })
            } else {
              $('#ls-product-content-size-table').remove();
            }
          }
        },
        error: function (error) {
          $('#ls-product-content-size-table').remove();
        },
      });
    },

    // 创建商品表格方法
    createSizeTable: function (tableData, dom) {
      // 判断有无size维度
      if (tableData.sizeTables && tableData.sizeTables.length != 0) {
        var popupProductId = $('.ls-main-popupbox-product').attr('productid');
        var sizeHeaderList = [];
        var bodySizeList = tableData.bodySizeList;
        var hiddenSizeTable = tableData.hiddenSizeTable || false;
        if (!tableData.isKindBelongKitchenOrAccessories && popupProductId && !hiddenSizeTable) {
          sizeHeaderList.push({
            label: 'Product Size',
            type: 'product'
          });
        }
        if (tableData.isKindBelongClothes && bodySizeList && bodySizeList[0].headerList && bodySizeList[0].headerList.length) {
          var bodySizeTip = sizeHeaderList.length > 0 ? 'Check the body and product size, and the fit guide for best fit.' : 'Check the body size and the fit guide for best fit.';
          sizeHeaderList.push({
            label: 'Body Size',
            type: 'body',
            bodySizeTip: bodySizeTip
          });
        }
        // 创建模块添加进页面
        tableData.sizeHeaderList = sizeHeaderList;
        var htmlStr = LS.tmpl(sizeTableHtml, tableData);
        if ( htmlStr ) {
          // 添加到详情页面
          $(dom).html(htmlStr);
          // 判断当文案高度小于或者等于盒子高度时，不展示下拉箭头
          var fitTextHeight = $(dom).find('.ls-size-table-tipbox-fittype .sp1').height();
          var fitboxHeight = $(dom).find('.ls-size-table-tipbox-fittype .p1').height();
          if (fitTextHeight <= fitboxHeight) {
            $(dom).find('.ls-size-table-tipbox-fittype .open-icon').attr('style', 'display: none;');
          }
          // 创建size表格
          // productsize数据
          var productSizeDataInfo = JSON.parse(JSON.stringify(tableData));
          productSizeDataInfo.tableListData = productSizeDataInfo.sizeTables;
          productSizeDataInfo.tableType = tableData.isKindBelongClothes ? '2' : '1';
          var htmlProductSizeStr = LS.tmpl(sizeTableContentHtml, productSizeDataInfo);

          // bodysize数据
          var bodySizeDataInfo = JSON.parse(JSON.stringify(tableData));
          bodySizeDataInfo.tableListData = bodySizeDataInfo.bodySizeList;
          bodySizeDataInfo.tableType = '2';
          var htmlBodySizeStr = LS.tmpl(sizeTableContentHtml, bodySizeDataInfo);

          // 添加到详情页面
          $(dom).find(".sizetable-box-content-product").prepend(htmlProductSizeStr);
          $(dom).find(".sizetable-box-content-body").prepend(htmlBodySizeStr);

          // 当购物车编辑商品时，弹窗内得在生成sizetable时，选中对应的尺码项
          // 获取点击的位置
          // 弹窗
          var sizeIndex = $(dom).parents('.ls-main-popupbox-product').find('.option-box-list-li .list-li-active').index();
          var tbodyList = $(dom).parents('.ls-main-popupbox-product').find('.tablebox-tbody');
          var tbodyListLen = tbodyList.length;
          // 判断
          if ( sizeIndex >= 0 && tbodyListLen > 0 ) {
            for (var i = 0; i < tbodyListLen; i++) {
              var tbodyItem = $(tbodyList[i]);
              tbodyItem.find(`.tablebox-tbody-tr:eq(${sizeIndex})`).addClass('tablebox-tbody-tr-active').siblings().removeClass('tablebox-tbody-tr-active');
            }
          }
          // 详情页
          if (LS.site.page === 'product') {
            var productSizeIndex = $(dom).parents('.product-sku-wrapper').find('.size-wrapper .sku-box .selected').index();
            var productTbodyList = $(dom).parents('.product-sku-wrapper').find('.tablebox-tbody');
            var productTbodyListLen = productTbodyList.length;
            if ( productSizeIndex >= 0 && productTbodyListLen > 0 ) {
              for (var i = 0; i < productTbodyListLen; i++) {
                var productTbodyItem = $(productTbodyList[i]);
                productTbodyItem.find(`.tablebox-tbody-tr:eq(${productSizeIndex})`).addClass('tablebox-tbody-tr-active').siblings().removeClass('tablebox-tbody-tr-active');
              }
            }
          }

          // 上报
          var param = {
            "products": {
              id: $(dom).parents('.ls-main-popupbox-product').length > 0 ? $(dom).parents('.ls-main-popupbox-product').attr('productid') + '' : $(dom).parents('.product-container').attr('data-product-id') + '',
            }
          };
          // 监听productsize
          LS.ui.globalModelShowHandle(document.querySelector('.ls-main-popupbox-product .sizetable-box-content-product'), LS.ui.productReportMap['showSizeSelectPopProductsize'], {ext2: JSON.stringify(param || [])});
          // 监听bodysize
          LS.ui.globalModelShowHandle(document.querySelector('.ls-main-popupbox-product .sizetable-box-content-body'), LS.ui.productReportMap['showSizeSelectPopBodysize'], {ext2: JSON.stringify(param || [])});
          // 监听合身度标签
          LS.ui.globalModelShowHandle(document.querySelector('.ls-main-popupbox-product .ls-product-type-step-bar'), LS.ui.productReportMap['showSizeSelectPopFittag'], {ext2: JSON.stringify(param || [])});
          // 监听模特信息模块
          LS.ui.globalModelShowHandle(document.querySelector('.ls-main-popupbox-product .ls-product-model-user-info'), LS.ui.productReportMap['showSizeSelectPopModelsize'], {ext2: JSON.stringify(param || [])});

        }
      }
    }

  };

  LS.ui.productPopupFn = {
    lsCreatePopupHandle: productPopupFn.lsCreatePopupHandle,
    productPopParameMethod: productPopupFn.productPopParameMethod,
    productPopBindEvent: productPopupFn.productPopBindEvent,
    getProductPreOrderText: productPopupFn.getProductPreOrderText,
    addToBagReportExposureClickHanlde: productPopupFn.addToBagReportExposureClickHanlde,
    createSizeTable: productPopupFn.createSizeTable,
    handleSoltoutStyle: productPopupFn.handleSoltoutStyle
  };
})();

/**
 * 首页相关方法
 */
(function () {
  var homePageFn = {
    insertCollectionModule: function() {
      // 当页面为首页时，动态插入集合内容
      var collectionModel = Array.from($('.ls-featured-collection').find('.ls-featured-collection-listing'));
      try {
        collectionModel && collectionModel.length > 0 && collectionModel.forEach(item => {
          // 调用动态插入首页集合内容方法
          LS.ui.collectionFn.getCollectionModule({
            dom: item, 
            collectionId: $(item).attr('data-collection-id'),
            reset: true
          });
        })
      } catch (e) {
        console.log(e);
      }
    },
    // 首页调用方法
    homepageHandleAll: function () {
      // 首页组件曝光
      if ( LS.site.page == 'index' ) {

        // 获取banner的长度
        // var bannerLength = $('.looksky-slideshow .looksky-slideshow-model').attr('slide-length');
        var bannerLength = $('.looksky-slideshow .looksky-slideshow-model .ls-slideshow-imagebox-link').length;
        if (bannerLength > 1) {
          // 显示icon
          $('.looksky-slideshow .slide-status-btn-icon').attr('style', 'display: flex;');

          // 首屏banner滚动方法
          sideSlider = new LS.Slider({
            container: ".looksky-slideshow",
            wrapper: ".looksky-slideshow-model",
            slide: ".ls-slideshow-imagebox-link",
            direction: 'x',
            isLoop: true,
            isAuto: true,
            slideSpeed: 600,
            autoInter: 6000,
            endCallback: function(index) {
              $('.looksky-slideshow .slide-index-item').eq(index).addClass('active').siblings().removeClass('active');
            }
          });

          // 点击圆点
          $(document).on("click", ".looksky-slideshow .slide-index-item",function () {
            var sideIndex = $(this).index();
            $(this).addClass('active').siblings().removeClass('active');
            sideSlider.slideTo(sideIndex, 300);
          });
        }

        // 获取首页集合图片slide的长度
        var slideBlockLength = Number($('.looksky-slide-collection-images').attr('length'));
        if (slideBlockLength > 1) {

          // 滚动方法
          collectionSlider = new LS.Slider({
            container: ".looksky-slide-images",
            wrapper: ".looksky-slide-images_list",
            slide: ".images-list-box",
            direction: 'x',
            isLoop: true,
            isAuto: true,
            slideSpeed: 600,
            autoInter: 6000,
            endCallback: function(index) {
              // 圆点
              $('.looksky-slide-images .slide-images-index-item').eq(index).addClass('active').siblings().removeClass('active');
            }
          });

        // 点击圆点
        $(document).on("click", ".looksky-slide-images .slide-images-index-item",function () {
          var sideIndex = $(this).index();
          $(this).addClass('active').siblings().removeClass('active');
          collectionSlider.slideTo(sideIndex, 300);
        });
      }

        let obTargets = Array.from($("body").children('.shopify-section'));
        // 开始观察
        try {
          obTargets && obTargets.length > 0 && obTargets.forEach((item, index) => {
            if ($(item).find('.looksky-report-pos-list').length > 0) {
              // 首页模块，内容坑位曝光
              var legoList = $('.looksky-report-pos-list .pos-li');
              // 开始观察
              try {
                legoList && legoList.length > 0 && legoList.forEach((item2, index2) => {
                  homePageFn.modelShowHandle(item2, LS.ui.homeReportMap['showHomeSection'], index, {ext3: `pos=${index2+1}`});
                })
              } catch (e) {
              }
            } else {
              homePageFn.modelShowHandle(item, LS.ui.homeReportMap['showHomeSection'], index);
            }
          })
        } catch (e) {
          console.log('showSkuPopView error => ', e);
        }

        homePageFn.insertCollectionModule();

        $(document).on("click", ".ls-featured-collection-sliderbox .viewmore-link, .looksky-img-link-wrapper", function () {
          sessionStorage.removeItem('collection_position_data');
        });

        // 首页OUR PHILOSOPHY模块点击
        $(document).on("click", ".ls-our-philosophy-li", function () {
          // 获取索引index
          var index = $(this).index();
          // 定义数据
          var philosophyList = [
            {
              img: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_home_Premium_Quality_m_3x_9798807d-a809-44ea-aaca-97e4689e4a48_800x.png?v=1664444378',
              title: LS.$t('index.model1_li1_label'),
              type: '1',
              url: '/pages/about-us'
            },
            {
              img: 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_home_Sustainably_Crafted_m_3x_0bb85388-9063-47d6-a511-a88663eb8221_800x.png?v=1664444378',
              title: LS.$t('index.model1_li2_label'),
              type: '2',
              url: '/pages/about-us'
            },
            {
              img: LS.$t('index.model1_li3_image_m'),
              title: LS.$t('index.model1_li3_label'),
              type: '3',
              url: '/pages/about-us'
            }
          ];
          // 申明弹窗
          var affirmationPopHtml = `
            <!-- 申明弹窗 -->
            <div class="ls-vertical-popupbox ls-vertical-popupbox-affirmation">
              <div class="ls-vertical-popupbox-overlay"></div>
              <div class="ls-vertical-popupbox-con">
                <!-- 内容区域 -->
                <div class="con-modelbox">
                  <div class="banner-box banner-box-<%= data.type %> js-lazyload-img">
                    <img src="<%= data.img %>" />
                  </div>
                  <p class="title"><%= data.title %></p>
                  <% if (data.type == '1') { %>
                    <p class="p1">${LS.$t('index.model1_li1_pop_info')}</p>
                  <% } else if (data.type == '2') { %>
                    <p class="p1">${LS.$t('index.model1_li2_pop_info')}</p>
                  <% } else if (data.type == '3') { %>
                    <p class="p1">${LS.$t('index.model1_li3_pop_info')}</p>
                  <% } %>
                  <a class="read-more" href="${LS.site.dir}<%= data.url %>?moduleType=<%= data.type %>">${LS.$t('index.model1_read_more')}</a>
                </div>
                <!-- 删除区域 -->
                <div class="con-close-btn">
                  <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic__close_2x_76dbb0f5-a8cd-48e1-b4b1-ceea4fa659f1.png?v=1658907695" />
                </div>
              </div>
            </div>
          `;
          // 创建弹窗
          var htmlStr = LS.tmpl(affirmationPopHtml, philosophyList[index]);
          // 显示弹窗
          $('body').append(htmlStr);
          // 禁止弹窗底部滚动方法
          LS.ui.popupNoScrollHandle();
        })

        // 当地址栏带状态为投票参数时，展示弹窗
        // 获取是否携带投票类型
        var voteType = LS.getParam('type');
        if ( voteType === 'vote' && !LS.cookie.get('graecove_vote')) {
          // 网站退出投票提醒弹窗
          var vote_reminder_pop = `
            <div class="ls-main-center-pop ls-main-center-pop-vote">
              <div class="ls-main-center-pop-overlay"></div>
              <div class="ls-main-center-pop-con">
                <a href="https://forms.gle/aPFRF6wR7Y4xcS5x9" class="ls-goto-vote-page js-lazyload-img">
                  <img class="ls-vote-reminder-pop-bg" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/brand_partner_b_700x.jpg?v=1691486208" />
                </a>
                <!-- closepop -->
                <img class="ls-center-pop-closebtn" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/ls_vote_pop_close.png?v=1654681225" />
              </div>
            </div>
          `;
          // 添加弹窗进页面
          $('body').append(vote_reminder_pop);
          // 上报
          LS.stat({
            eid: LS.ui.reportType['moduleShow'],
            ext1: LS.ui.voteReportMap['showGetStartedSurvey'],
            ext2: 'pop'
          });

          // 投票提醒弹窗点击隐藏
          $(document).on("click", ".ls-main-center-pop-vote .ls-center-pop-closebtn,.ls-main-center-pop-vote .ls-main-center-pop-overlay", function () {
            // 删除模块
            $(this).parents('.ls-main-center-pop').remove();
          })
          // 投票点击进入
          $(document).on("click", ".ls-main-center-pop-vote .ls-goto-vote-page", function () {
            // 上报
            LS.stat({
              eid: LS.ui.reportType['click'],
              ext1: LS.ui.voteReportMap['clickGetStartedSurvey'],
              ext2: 'pop'
            });
            // 储存更改投票状态
            LS.cookie.set('graecove_vote', 1, 24*30);
          })
        }
      }

      // 点击icon关闭弹窗
      $(document).on("click", ".ls-vertical-popupbox .con-close-btn,.ls-vertical-popupbox-overlay",function () {
        var noHidePopup = $(this).attr('data-no-hide-popup');
        if (noHidePopup) return;
        LS.ui.hidePopupBox(this);
      });

      // ------首页组件点击------
      $(document).on("click", ".looksky-slideshow-model .ls-slideshow-imagebox-link", function () {
        sessionStorage.removeItem('collection_position_data');
        // 上报方法
        var bannerLength = $('.looksky-slideshow .looksky-slideshow-model .ls-slideshow-imagebox-link').length;
        homePageFn.homeComponentClickExposure(JSON.stringify({
          url: $(this).attr('href'),
        }), this, bannerLength > 1 ? '1' : '');
      })
      $(document).on("click", ".looksky-text-img-block .ls-container-list-box", function () {
        // 上报方法
        _homeClickReport(this);
      })
      $(document).on("click", ".looksky-lego-images_list .images-list-box", function () {
        // 上报方法
        _homeClickReport(this);
      })
      $(document).on("click", ".looksky-columns-more-img .ls-listone-li", function () {
        // 上报方法
        _homeClickReport(this);
      })
      $(document).on("click", ".looksky-reviews-block .reviews-item", function () {
        // 上报方法
        _homeClickReport(this);
      })
      $(document).on("click", ".looksky-img-link-block", function () {
        // 上报方法
        _homeClickReport(this);
      })
        

      // 首页点击上报
      function _homeClickReport(that) {
        // 上报方法
        homePageFn.homeComponentClickExposure(JSON.stringify({
          url: $(that).find('a').attr('href'),
        }), that);
      }

      // -------------全局埋点-------------
      // 全站品牌logo点击
      $(document).on("click", ".header-modelcon-content a", function () {
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.globalReportMap['clickLogo'],
          ext2: document.referrer,
        });
      })

      $(document).on("click", ".looksky-header-menu-wrapper .nav-children-li-item-link", function () {
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.globalReportMap['clickMenu'],
          ext2: document.referrer,
        });
      })

      // 全站汉堡菜单集合点击
      $(document).on("click", "#looksky-header-model-menubox a", function () {
        sessionStorage.removeItem('collection_position_data');
        // 上报
        var param = {
          page: $(this).text(),
          url: $(this).attr('href'),
        }
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.globalReportMap['clickMenuLink'],
          ext2: JSON.stringify(param),
        });
      })


      // 全站搜索入口点击
      $(document).on("click", ".header-modelcon-right .right-search-link", function () {
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.globalReportMap['clickSearch'],
          ext2: document.referrer,
        });
      })

      // 全站右上角bag入口点击
      $(document).on("click", ".header-modelcon-right .right-cart-link", function () {
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.globalReportMap['clickBag'],
          ext2: document.referrer,
        });
      })

      // 全站footer refer earn点击
      $(document).on("click", ".ls-footer-refer-friend-box .js-refer-click-btn", function () {
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.globalReportMap['clickGiveGet'],
          ext2: document.referrer,
        });
      })

      // 全站footer page点击
      $(document).on("click", ".ls-footer-model .con-menu a", function () {
        // 上报
        var param = {
          page: $(this).text(),
          url: $(this).attr('href'),
        }
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.globalReportMap['clickFooterLink'],
          ext2: JSON.stringify(param),
        });
      })
    },

    // 模块曝光方法
    modelShowHandle: function (dom, reportType, index, data) {
      var threshold = $(dom).find('.ls-featured-collection-listbox').length > 0 ? 0.1 : 0.5;
      var config = {
        threshold: [threshold]
      }
      LS.observe.intersection(dom, function(entries, observer) {
        for (let i = 0, len = entries.length; i < len; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            // 上报(头部两块不用上报)
            if (index > 1) {
              homePageFn.modelShowExposure(reportType, index-1, data);
            }
          }
        }
      }, config)
    },

    // 首页模块可见曝光方法上报
    modelShowExposure: function (reportType, index, data) {
      // 上报
      LS.stat({
        eid: LS.ui.reportType['moduleShow'],
        ext1: reportType,
        ext2: index ? `pos=${index}` : '',
        ...data
      });
    },

    // 首页组件点击曝光方法
    homeComponentClickExposure: function (param, dom, type = '') {
      // 获取点击的坑位和组件的坑位
      var clickIndex = $(dom).index();
      if (type) {
        clickIndex--;
      }
      var componentIndex = 0;
      // 遍历
      let sectionList = $("body").children('.shopify-section');
      sectionList.forEach((item, index) => {
        if ($(dom).parents('.shopify-section')[0] === item) {
          componentIndex = index;
        }
      })
      // 上报
      LS.stat({
        eid: LS.ui.reportType['click'],
        ext1: LS.ui.homeReportMap['clickHomeSection'],
        ext2: param,
        ext3: `pos=${componentIndex-1}`,
        ext4: `pos=${clickIndex+1}`,
      });
    },

  };

  LS.ui.homePageFn = {
    homepageHandleAll: homePageFn.homepageHandleAll,
    modelShowHandle: homePageFn.modelShowHandle,
    homeComponentClickExposure: homePageFn.homeComponentClickExposure
  };
})();

/**
 * 公共方法集合
 * 下拉抽屉 renderBottomDrawer
 * 确认框 genDialogConfirm
 * toast
 */
(function () {
  var toastTimer = '';
  var cartBagRect = $('#looksky-cart-bag').length && $('#looksky-cart-bag')[0].getBoundingClientRect();
  /**
   * 下拉抽屉
   */
  function renderBottomDrawer(opts = { title: "", slot: "" }, handleType) {
    var drawer = `
        <div class="bottom-drawer" id="bottom-drawer">
        <div class="bottom-drawer_mask" id="bottom-drawer_mask"></div>
          <div class="bottom-drawer_container">
            <div class="bottom-drawer_header">
              <p class="title">${opts.title}</p>
              <img class="close-btn" id="bottom-drawer_close-btn" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/looksky_popup_close_phone2.png?v=1661931061" />
            </div>
            <div class="slot-wrapper">${opts.slot}</div>
          </div>
        </div>
    `;
    $('body').append(drawer);
    $('#bottom-drawer_close-btn').on("click", function () {
      $("#bottom-drawer").remove();
      if (handleType === 'checkout') {
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.reportMap['closeSoldoutDrawer'],
          ext3
        });
      }
    });
    $('#bottom-drawer_mask').on("click", function () {
      $("#bottom-drawer").remove();
      if (handleType === 'checkout') {
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.reportMap['clickSoldOoutOverlay'],
          ext3
        });
      }
    });


    if (handleType === 'checkout') {
      LS.ui.reporterMuti(3, LS.ui.reportMap['checkoutSoldout'], LS.ui.reportType['moduleShow']);
    }
  }

  function genDialogConfirm(opts) {
    opts = {
      // ...opts,
      confirmCallback: opts.confirmCallback || function() {},
      cancelCallback: opts.cancelCallback || function() {},
      showCancelBtn: opts.showCancelBtn != undefined ? opts.showCancelBtn : true,
      title: opts.title || "",
      text: opts.text || "",
      cancelBtnText: opts.cancelBtnText || LS.$t('bag.pop_cancel_btn', '', 1),
      confirmBtnText: opts.confirmBtnText || LS.$t('bag.pop_remove_btn', '', 1),
    };
    _genConfirm(opts);
   
    function _genConfirm(opts) {
      var dom = `
            <div class="dialog-comfirm_wrapper" id="comfirm-wrapper">
              <div class="confirm-box">
                <div class="content-box">
                  ${opts.title ? ` <div class="content-title">${opts.title}</div>` : ''}
                  <div class="content-text">${opts.text}</div>
                </div>
                <div class="bottom-wrapper">
                  ${opts.showCancelBtn ? `<div class="dialog-confirm_btn cancel-btn" id="cancel-btn">${opts.cancelBtnText}</div>` : ''}
                  <div class="dialog-confirm_btn confirm-btn" id="confirm-btn">${opts.confirmBtnText}</div>
                </div>
              </div>
            </div>
        `;
      $("body").append(dom);
      _bindConfirmEvent(opts);
    }

    function _bindConfirmEvent(opts) {
      $("#cancel-btn").on("click", async function () {
        if (
          opts.cancelCallback &&
          typeof opts.cancelCallback === "function"
        ) {
          await opts.cancelCallback(2);
        }
        $("#comfirm-wrapper").fadeOut();
        $("#comfirm-wrapper").remove();
      });
      $("#confirm-btn").on("click", async function () {
        if (
          opts.confirmCallback &&
          typeof opts.confirmCallback === "function"
        ) {
          await opts.confirmCallback(1);
        }
        $("#comfirm-wrapper").fadeOut();
        $("#comfirm-wrapper").remove();
      });
    }
  }

  function createPopup(className, innerHtml) {
    var popup = `
      <div class="ls-main-popupbox popupbox_${className}">
        <div class="ls-main-popupbox-overlay"></div>
        <div class="ls-main-popupbox-con common-popup-container popupbox-container_${className}">
          <img class="common-popup-close title-close popupbox-${className}_close" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls_icon_close_white_2x_199b037d-e6bb-4ac2-b041-85247b544b1e.png?v=1665736507"/>
          <div class="popupbox-inner_${className}">
            ${innerHtml}
          </div>
        </div>
      </div>
    `;
    return popup;
  }

  // toast方法
  function toastShowHandle(text, time = 2000) {
    if (toastTimer) {
      clearTimeout(toastTimer);
      $(".ls-main-toast-tip-popup").remove();
    }
    var main_toast = document.createElement("div");
    main_toast.className = "ls-main-toast-tip-popup";
    main_toast.innerHTML = text;
    document.body.appendChild(main_toast);
    $(".ls-main-toast-tip-popup").show();
    toastTimer = setTimeout(() => {
      $(".ls-main-toast-tip-popup").remove();
    }, time);
  }

  // loading打开方法
  function loadingPopShow() {
    // 插入loading
    if (!$('.ls-main-loading-img-popup').length) {
      var loadingHtml = `
        <div class="ls-main-loading-img-popup">
          <div class="loading-img-popup-con">
            <img class="loading-img" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/loading_icon_7dd2a7ef-5afa-4247-8950-6f4ac9675978.png?v=1657537287" />
          </div>
        </div>
      `;
      $("body").append(loadingHtml);
    } else {
      $('.ls-main-loading-img-popup').show();
    }
  }

  // loading隐藏方法
  function loadingPopHide() {
    // 删除loading
    $(".ls-main-loading-img-popup").hide();
  }

  // 按钮loading添加方法
  function loadingBtnShow(dom, type = 1) {
    // type: 1:往按钮里面添加load图片，2:load图片替换按钮内容
    if (dom.find('.main-button-loading').length) return;
    var load = `<img class="main-button-loading" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/button_loading.png?v=1660287889">`;
    if (type === 1) {
      // 尾部添加
      $(dom).append(load);
      // 添加距离样式
      $('.main-button-loading').attr('style', 'margin-left: 8px;');
    } else {
      // 整体替换
      $(dom).html(load);
    }
  }

  // 按钮loading去除方法
  function loadingBtnHide(dom, oldDom) {
    var loadingDom = $(dom).find('.main-button-loading');
    loadingDom && loadingDom.remove();
    // 判断如果要还原成原来的dom
    if (oldDom) {
      $(dom).html(oldDom);
    }
  }

  // copy方法
  function copyToClip(content, toast = '') {
    var copy = document.createElement("input");
    copy.setAttribute("value", content);
    copy.setAttribute('style', 'position: fixed;left: 0px;bottom: 0px;transform: translateX(-1000px);');
    document.body.appendChild(copy);
    copy.select();
    document.execCommand("copy");
    document.body.removeChild(copy);
    // 复制成功toast方法
    if (toast) {
      toastShowHandle(toast);
    } else {
      toastShowHandle(LS.$t('public.toast.copied_successfully'));
    }
  }

  // time操作方法
  /**
   * 获取单天日期日期格式 例如：Apr.29,2022
   * @param {Number} timestamp 时间搓
   * @example
   * LS.ui.singleDayDateFormat(1651219815005);
   */
  function singleDayDateFormat(timestamp, status = true) {
    // 传值取传值的时间搓，没有传值取当前时间搓
    var getTimestamp = timestamp || new Date().getTime();
    // 获取对应时间参数
    var time = new Date(getTimestamp);
    var year = time.getFullYear();
    var month = getEnMonth(time.getMonth());
    var monthNum = time.getMonth()+1 < 10 ? `0${time.getMonth()+1}` : time.getMonth()+1;
    var day = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
    if (status) {
      return month + '.' + day + ',' + year;
    } else {
      return monthNum + '/' + day + '/' + year;
    }
  }

  /**
   * 获取范围日期格式
   * 同年同月份日期范围 例如：Feb.20-22,2022
   * 同年不同月日期范围 例如：Feb.22-Mar.02,2022
   * 不同年日期范围 例如：Dec.30,2021-Jan.01,2022
   * @param {Number} start 时间搓
   * * @param {Number} end 时间搓
   * @example
   * 同年同月份日期范围 LS.ui.scopeDayDateFormat(1649493851965, 1651221851965);
   * 同年不同月日期范围 LS.ui.scopeDayDateFormat(1649493851965, 1661221851965);
   * 不同年日期范围 LS.ui.scopeDayDateFormat(1649493851965, 1761221851965);
   */
  function scopeDayDateFormat(start, end) {
    if (start && end) {
      // 获取对应开始和结束时间的对应参数
      // 开始
      var startTime = new Date(start);
      var startYear = startTime.getFullYear();
      var startMonth = getEnMonth(startTime.getMonth());
      var startDay = startTime.getDate() < 10 ? '0' + startTime.getDate() : startTime.getDate();
      // 结束
      var endTime = new Date(end);
      var endYear = endTime.getFullYear();
      var endMonth = getEnMonth(endTime.getMonth());
      var endDay = endTime.getDate() < 10 ? '0' + endTime.getDate() : endTime.getDate();
      // 判断范围状态
      if (startYear == endYear && startMonth == endMonth) {
        return startMonth + '.' + startDay + '-' + endDay + ',' + startYear;
      } else if (startYear == endYear && startMonth != endMonth) {
        return startMonth + '.' + startDay + '-' + endMonth + '.' + endDay + ',' + startYear;
      } else if (startYear != endYear && startMonth != endMonth) {
        return startMonth + '.' + startDay + ',' + startYear + '-' + endMonth + '.' + endDay + ',' + endYear;
      }
    }
  }

  /**
   * 获取英文月份
   * @param {Number} month 月份
   * @example
   * LS.time.getEnMonth(3); // 获取英文月份
   */
  function getEnMonth(month) {
    if (month) {
      var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return monthList[month];
    }
  }
 
  /**
   * 上报数据
   * 多条商品数据上报 
   * @param {*} status 1在售商品 2售罄商品 3checout弹窗校验商品状态-售罄、不够库存 4购物车点击bought together
   * @param {*} opts 
   */
  function reporterMuti(status, ext1, reportType, getCode = '', extInfo = '') {
    var params = {};
    if (status === 1) {
      var arr = LS.ui.getOnSellItems() || [];
      params.ext2 = JSON.stringify({ products: arr });
      params.ext3 = JSON.stringify(LS.ui.getCartInfo() || {});
      params.ext4 = getCode;
      params.ext5 = extInfo;
    } else if (status === 2) {
      var arr = LS.ui.getSoldoutItems() || [];
      params.ext2 = JSON.stringify({ products: arr });
    } else if (status === 3) {
      var arr = LS.ui.getSoldoutCheckout() || [];
      params.ext2 = JSON.stringify({ products: arr });
    } else if (status === 4) {
      var arr = LS.ui.getOnSellItems() || [];
      params.ext2 = JSON.stringify({ products: arr });
      params.ext3 = getCode;
      params.ext4 = extInfo;
    }
    var onSellItems = getOnSellItems();
    var soldoutItems = getSoldoutItems();
    var onSellLen = onSellItems.length;
    var soldoutLen = soldoutItems.length;
    if (onSellLen && !soldoutLen) {
      params.ext6 = 'bag=normal';
    }
    if (onSellLen && soldoutLen) {
      params.ext6 = 'bag=has_sold_out';
    }
    if (!onSellLen && soldoutLen) {
      params.ext6 = 'bag=only_sold_out';
    }
    LS.stat({
      eid: reportType,
      ext1,
      ...params
    });
  }

  /**
   * 上报类型
   * 单条商品数据上报
   * isSoldout 区分在售和售罄上报字段
   */
  function reporterSingle(ext1, self) {
    var { isSoldout, quantity, price, ...rest } = LS.ui.getCartItem(self) || {};
    var params = {
      ...rest
    };
    switch(ext1) {
      case LS.ui.reportMap['changeSku']:
        ext1 = isSoldout ? LS.ui.reportMap['changeSkuBySoldout'] : LS.ui.reportMap['changeSkuByOnSell'];
        break;
      case LS.ui.reportMap['increaseCartItemQuantity']:
      case LS.ui.reportMap['minusCartItemQuantity']:
        params.quantity = quantity;
        break;  
      case LS.ui.reportMap['delCartItem']:
        ext1 = isSoldout ? LS.ui.reportMap['delCartItemBySoldout'] : LS.ui.reportMap['delCartItemByOnSell'];
        break;
      case LS.ui.reportMap['visitProductDetails']:
        ext1 = isSoldout ? LS.ui.reportMap['visitProductDetailsBySoldout'] : LS.ui.reportMap['visitProductDetailsByOnSell'];
        params.quantity = quantity;
        params.price = price;
        break;      
      default:
        break;  
    }
    var productJson = {
      "products": params
    }
    LS.stat( {
      eid: LS.ui.reportType['click'],
      ext1,
      ext2: JSON.stringify(productJson)
    });
  }

  /**
   * 商品集合点击全局上报
   */
  function reporterCollection(ext1, self) {
    var moduleType = $(self).parents('.ls-featured-collection-listing').attr('data-title');
    var curProductBlock = $(self).parents('.ls-product-block');
    var index = curProductBlock.attr('stat-index');
    // 商品信息
    // 处理sku里面的颜色
    var itemSku = curProductBlock.attr('stat-module-show-color');
    var itemCurSku = curProductBlock.attr('stat-module-show-selected-color');
    var color = itemCurSku != undefined && itemCurSku != 'undefined' ? itemCurSku.split('-')[1] : itemSku.split('-')[1];
    var param = {
      "products": {
        id: curProductBlock.attr('stat-module-show-id') + '',
        title: curProductBlock.attr('stat-module-show-title'),
        price: curProductBlock.attr('stat-module-show-price')/100,
        color: color,
      }
    };
    // 如果集合携带aid，则上报aid
    var aid = curProductBlock.attr('stat-module-show-aid');
    LS.stat({
      eid: LS.ui.reportType['click'],
      aid: aid || 'empty',
      ext1,
      ext2: JSON.stringify(param || []),
      ext3: `pos=${index}`,
      ext4: moduleType
    });
  }

  /**
   * 全局列表集合曝光
   */
  function globalListExposureHandle() {
    LS.ui.initElementExposure('[stat-module-show]', {
      id: 'module-show-id',
      aid: 'module-show-aid',
      index: 'index',
      title: 'module-show-title',
      price: 'module-show-price',
      color: 'module-show-color',
      currentColor: 'module-show-selected-color'
    }, function(data) {
      if (!data.length) return;
      // 购物车数量
      var isEmptyCart = !$('#cart-sum').text();
      // 获取dom结构，判断是否为侧边栏购物车加购
      var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
      // 获取页面类型
      var pageType = cartDrawerOpen ? 'cart' : LS.site.page;
      // 判断加购类型
      var showType = "";
      var collectionTitle = $(data[0].htmlDom).parents('.ls-featured-collection-listing').attr('data-title');
      switch (pageType) {
        case 'index':
          showType = LS.ui.homeReportMap['showProductHome'];
          break;
        case 'search':
          showType = LS.ui.searchReportMap['showProductSearch'];
          break;
        case 'collection':
          // 集合页判断类型
          if ($(data[0].htmlDom).parents('.box-recently-viewed').length > 0) {
            showType = LS.ui.collectionReportMap['showRecentlyViewedCollection'];
          } else if ($(data[0].htmlDom).parents('.box-collection-list').length > 0) {
            showType = LS.ui.collectionReportMap['showBottomProductCollection'];
          } else {
            showType = LS.ui.collectionReportMap['showProductCollection'];
          }
          break;
        case 'product':
          var type = $(data[0].htmlDom).parents('.ls-featured-collection-listing').attr('data-title');
          if (type === 'pair_it_with') {
            showType = LS.ui.productReportMap['showProductPairItWith'];
          } else {
            showType = LS.ui.productReportMap['showProductAlsoLike'];
          }
          break;
        case 'cart':
          showType = isEmptyCart ? LS.ui.reportMap['showBestTogether'] : LS.ui.reportMap['showBoughtTogether'];
          collectionTitle = $('.cart-drawer_container').find('.ls-featured-collection-listing').attr('data-title');
          break;
      }
      var list = data.map(item => {
        var colorText = item.currentColor != undefined && item.currentColor != 'undefined' ? item.currentColor.split('-')[1] : item.color.split('-')[1];
        var param = {
          "products": {
            id: item.id + '',
            title: item.title,
            price: item.price/100,
            color: colorText,
          }
        }
        return {
          eid: LS.ui.reportType['moduleShow'],
          aid: item.aid || 'empty',
          ext1: showType,
          ext2: JSON.stringify(param),
          ext3: `pos=${item.index}`,
          ext4: collectionTitle
        }
      });
      LS.stat(list);
    });
  }

  /**
   * 初始化曝光元素
   * @param {*} dom 
   */
  function initElementExposure(obTarget, opts, callback, root = '') {
    var config = {
      // threshold属性决定了什么时候触发回调函数。它是一个数组，每个成员都是一个门槛值，默认为[0]，即交叉比例（intersectionRatio）达到0时触发回调函数,目标元素50% 可见时，会触发callback回调。
      threshold: [0.5],
      // rootMargin: "900px 0px 0px 0px" 
    }
    // var cacheList = JSON.parse(sessionStorage.getItem('_productExposureList_') || 'null') || [];
    var reportList = [];
    // root属性指定目标元素所在的容器节点（即根元素）。注意，容器元素必须是目标元素的祖先节点。
    if (root) {
      config.root = root;
    }
    function _callback (entries, observer) {
      for (let i = 0, len = entries.length; i < len; i++) {
        var entry = entries[i];
        var id = $(entry.target).attr('stat-module-show-id');
        var optsData = {};
        for (let i in opts) {
          optsData[i] = $(entry.target).attr(`stat-${opts[i]}`);
        }
        optsData.htmlDom = $(entry.target);
        // 存在stat-comlete或者cacheList不重复曝光
        if (entry.target.classList.contains("stat-complete")) return;
        // 回调会触发2次，一次是目标刚进入视口，一次是完成离开视口，IntersectionObserverEntry对象的isIntersecting属性解决，通过这个属性判断是否是开始可见。 
        if (entry.isIntersecting) {
          entry.target.classList.add("stat-complete");
          reportList.push(optsData);
          observer.unobserve(entry.target);
        }
      }
      if (reportList.length >= 10) {
        _handleReport();
        return;
      }

      setTimeout(() => {
        _handleReport();
      }, 500);

      function _handleReport() {
        callback && typeof callback === "function" && callback(reportList);
        // var arr = Array.from(new Set(cacheList.concat(reportList.map(item => item.id))));
        // sessionStorage.setItem('_productExposureList_', JSON.stringify(arr));
        reportList = [];
      }
    };

    let collectionAll = $('.ls-featured-collection-listing') || [];
    try {
      collectionAll.length > 0 && collectionAll.forEach((item, index) => {
        let obTargets = item.querySelectorAll(obTarget);
        // 开始观察
        obTargets.length > 0 && obTargets.forEach((item2, index2) => {
          $(item2).attr('stat-index', index2+1);
          if (!$(item2).hasClass('stat-complete')) {
            // io.observe(item);
            LS.observe.intersection(item2, _callback, config)
          }
        })
      })
    } catch (error) {
      
    }
  }

  // 图片懒加载公共方法
  function initImgLazyloadHandle() {
    var page = LS.site.page;
    var rootMarginBottom = '150px';
    var rootMarginRight = '0px';
    switch (page) {
      case 'index': 
        rootMarginBottom = '0px';
        break;
      // 商详页大图提前420px加载下一张  
      case 'product':
        rootMarginRight = '420px';  
    }
    var config = {
      // threshold属性决定了什么时候触发回调函数。它是一个数组，每个成员都是一个门槛值，默认为[0]，即交叉比例（intersectionRatio）达到0时触发回调函数,目标元素50% 可见时，会触发callback回调。
      threshold: [0],
      rootMargin: `0px 0px ${rootMarginBottom} ${rootMarginRight}`
    }

    // 获取所有拥有data-lazyload-src属性的img元素
    let lazyImages = document.querySelectorAll('img[data-lazyload-src]');
    // 开始观察
    lazyImages.length > 0 && lazyImages.forEach((item) => {
      LS.observe.intersection(item, _callback, config)
    })  

    function _callback (entries, observer) {
      for (let i = 0, len = entries.length; i < len; i++) {
        var entry = entries[i];
        // 存在stat-comlete或者cacheList不重复曝光
        if (entry.target.classList.contains("img-lazyload-complete")) return;
        // 回调会触发2次，一次是目标刚进入视口，一次是完成离开视口，IntersectionObserverEntry对象的isIntersecting属性解决，通过这个属性判断是否是开始可见。 
        if (entry.isIntersecting) {
          entry.target.classList.add("img-lazyload-complete");
          observer.unobserve(entry.target);
          // target属性为被观察的目标元素
          _imageLoad(entry.target);
        }
      }
    };

    // 定义img元素的src属性赋值方法，实现显示正确图片
    function _imageLoad (image) {
      // 将img元素的data-lazyload-src属性值设置给src属性
      image.setAttribute('src', image.getAttribute('data-lazyload-src'));
      // 监听图片加载事件
      image.addEventListener('load', function() {
        // 删除已加载img元素的data-lazyload-src属性
        image.removeAttribute("data-lazyload-src");
      })
    }
  }

  function setFirstView() {
    var img = document.querySelector(".cart-image_wrapper .cart-image") || null; 
    if (img) {
      if (img.complete) {
        _report();
      } else {
        img.onload = img.onerror = function() {
          img.onerror = img.onload = null;
          _report();
        };
      }
    } 
    function _report() {
      if (window.imgReport && window.performance) {
        window.imgReport({
          eid: "load_time",
          ext2: (Date.now() - window.performance.timing.navigationStart) + ''
        });
      }
    }
  }
  function setInteractive() {
    if (window.imgReport && window.performance) {
      window.imgReport({
        eid: "load_time",
        ext3: (Date.now() - window.performance.timing.navigationStart) + ''
      });
    }
  }
  /**
   * 处理app页面，去除头部底部
   */
  function handleAppPages() { 
    if (LS.site.page === 'page' 
      || location.href.indexOf("/policies/privacy-policy") >= 0 
      || location.href.indexOf("/policies/terms-of-service") >= 0 ) {
        $('#shopify-section-looksky-announcement-bar').hide();
        $('#shopify-section-looksky-header').hide();
        $('#section-looksky-footer').hide();
      }
  }

  /**
   * 加购动画
   */
  function setAddCartAnimation(productImg, callback) {
    var flyDom = '.add-cart-flyer';
    $(flyDom).length && $(flyDom).remove(); // 移除上一个
    var imgBox = 
      $('<img class="add-cart-flyer" src=' + productImg + '/>');
    var screen = window.screen;
    var imgLeft = screen.width/2.0 - 25;
    var imgTop = screen.height/2.0;
    imgBox.css({
      'left': imgLeft,
      'top': imgTop,
    });
    $('body').append(imgBox);
    var imgRect = $('.add-cart-flyer')[0].getBoundingClientRect();
    imgRect.height = imgRect.height ? imgRect.height : 65;
    var x = cartBagRect.left + cartBagRect.width - (imgRect.left + imgRect.width);
    var y = imgRect.top  - cartBagRect.top;
    function setAni() {
      imgBox.css({
        'transform': 'translate3d(' + x + 'px,-'+ y + 'px, 0px)',
        'transition':  'all 1.5s ease',
      })
      setTimeout(function() {
        typeof callback == 'function' && callback();
        $(flyDom).length && $(flyDom).remove();
      }, 1000);
    }
    window.requestAnimationFrame(setAni);
  } 
  /**
   * checkout ajax
   */
  function handleCheckout(variantId) {
    var productVariantId = 'gid://shopify/ProductVariant/' + variantId;
    LS.ajax({
      url: `${location.origin}/api/2022-04/graphql.json`, 
      type : 'post', 
      headers:{ 'Content-Type': 'application/graphql','X-Shopify-Storefront-Access-Token': '45538629c7129ec3d2a867c6da691a1e' }, 
      data:`
        mutation {
          checkoutCreate(input: {
            lineItems: [{ variantId: "${window.btoa(productVariantId)}", quantity: 1 }],
            buyerIdentity: {
              countryCode: ${LS.site.country}
            }
          }) {
          checkout {
            id
            webUrl
          }
          }
        }
      `,
      success: function(res) {
        var url = res.data.checkoutCreate.checkout.webUrl || '';
        if (url) {
          location.href = url;
        } else {
          LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        }
      },
      error: function (e) {
        LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
      },
    })
  }

  function getCartItem(self) {
    var target = $(self).parents('.cart-item_container');
    var itemData =
    JSON.parse(target.find('.js-product-json').text() || 'null') || {};
    return {
      id: itemData.productId + '',  
      sku: itemData.sku, 
      isSoldout: itemData.isSoldout,
      quantity: itemData.quantity,
      price: itemData.price,
      color: itemData.sku.split('-')[1],
    };
  }

  function getSoldoutCheckout() {
    var soldoutItemsCheckout = $("#cart-slot").find(".cart-item_container");
    var len = soldoutItemsCheckout.length;
    var arr = [];
    if (len > 0) {
      for (var i = 0; i < len; i++) {
        var itemData =
        JSON.parse($(soldoutItemsCheckout[i]).find('.js-product-json').text() || 'null') || {};
        arr.push({
          id: itemData.productId,
          sku: itemData.sku,
          quantity: itemData.quantity
        });
      }
    }
    return arr;
  }

  function getOnSellItems() {
    var onSellItems = $("#on-sell-items").find(".cart-item_container");
    var onSellItemsLen = onSellItems.length;
    var arr = [];
    if (onSellItemsLen > 0) {
      for (var i = 0; i < onSellItemsLen; i++) {
        var onSellItemData =
        JSON.parse($(onSellItems[i]).find('.js-product-json').text() || 'null') || {};
        arr.push({
          id: onSellItemData.productId,
          sku: onSellItemData.sku,
          price: onSellItemData.price,
          num: onSellItemData.quantity,
        });
      }
    }
    return arr;
  }

  /**
		 * 获取购物车checkout
		 */
   function getCartInfo() {
    var currency = $('#cart-currency').text();
    var total = $('#cart-total').text();
    var sum = $('#cart-sum').text();
    return {
      currency,
      total,
      sum
    }
  }

  function getSoldoutItems() {
    var soldoutItems = $("#sold-out-items").find(".cart-item_container");
    var soldoutLen = soldoutItems.length;
    var arr = [];
    if (soldoutLen > 0) {
      for (var i = 0; i < soldoutLen; i++) {
        var soldoutItemData =
        JSON.parse($(soldoutItems[i]).find('.js-product-json').text() || 'null') || {};
        arr.push({
          id: soldoutItemData.id,
          sku: soldoutItemData.sku
        });
      }
    }
    return arr;
  }

  function getSourceByAddToCart() {
    // 获取dom结构，判断是否为侧边栏购物车加购
    var cartDrawerOpen = $('.cart-drawer_container').hasClass('is-active');
    var listType = $('.ls-main-popupbox-product').attr('listType');
    // 获取页面类型
    var pageType = cartDrawerOpen ? 'cart' : LS.site.page;
    // 判断加购类型
    var addType = "";
    // 定义加购商品来源
    switch (pageType) {
      case 'index':
        addType = 'clickAddtobagHomeCollection';
        break;
      case 'search':
        addType = 'clickAddtobagSearch';
        break;
      case 'collection':
        if (listType == 'recently_viewed') {
          addType = 'clickAddtobagRecentlyViewed';
        } else if (listType == 'bottom_collection') {
          addType = 'clickAddtobagBottomCollection';
        } else {
          addType = 'clickAddtobagCollection';
        }
        break;
      case 'product':
        addType = $('.ls-main-popupbox-product').attr('handle') ? 'clickAddtobagAlsoLike' : 'clickAddtobagProductPop';
        break;
      case 'cart':
        addType = 'clickAddtobagBoughtTogether';
        break;
    }
    return addType;
  }

  function reporterCartState() {
    var onSellItems = getOnSellItems();
    var soldoutItems = getSoldoutItems();
    var onSellLen = onSellItems.length;
    var soldoutLen = soldoutItems.length;
    var reportType = LS.ui.reportMap['cartStateError'];
    if (!onSellLen && !soldoutLen) {
      reportType = LS.ui.reportMap['cartStateEmpty'];
    }
    if (onSellLen && !soldoutLen) {
      reportType = LS.ui.reportMap['cartStateNormal'];
    }
    if (onSellLen && soldoutLen) {
      reportType = LS.ui.reportMap['cartStateHasSoldOut'];
    }
    if (!onSellLen && soldoutLen) {
      reportType = LS.ui.reportMap['cartStateOnlySoldOut'];
    }

    LS.stat({
      eid: LS.ui.reportType['custom'],
      ext1: reportType
    })
  }

  function handleBuyitnowBtn() {
    if ($('.shopify-payment-button__more-options')) {
      $('.shopify-payment-button__more-options').click();
    } else if ($('.shopify-payment-button__button').html() === 'Buy it now') {
      $('.shopify-payment-button__button').click();
    } else {
      $('.shopify-cleanslate div').click();
    }
  }

  function loadResourceAsync() {
    var cssList = $('#site-async-css-resource').text();
    var jsList = $('#site-async-js-resource').text();
    cssList = cssList.split(',');
    jsList = jsList.split(',');
    for (var i = 0, len = cssList.length; i < len; i++) {
      var url = cssList[i];
      if (url) {
        LS.loadUrl(url, '');
      }
    }
    for (var i = 0, len = jsList.length; i < len; i++) {
      var url = jsList[i];
      if (url) {
        LS.loadUrl(url, '', true, 'async');
      }
    }
  }
  
  // 触发弹窗底部页面禁止滑动
  function popupNoScrollHandle() {
    $('body').css('overflow', 'hidden');
    // 因为设置overflow后，顶部吸顶的头部sticky会被隐藏，所以更改为fixed
    var headerDom = $('#shopify-section-looksky-header').find('.looksky-header-model-con');
    LS.setData('isHeaderFixedTop', headerDom.hasClass('white-bg-header') ? 1 : 0);
    headerDom.addClass('white-bg-header');
  }

  // 关闭弹窗底部页面恢复滑动
  function popupRecoveryScrollHandle(removeHeadStyle) {
    $('body').css('overflow', 'auto');
    document.body.style.overflow = '';
    var headerDom = $('#shopify-section-looksky-header').find('.looksky-header-model-con');
    var isHeaderFixedTop = LS.getData('isHeaderFixedTop') || 0;
    if (isHeaderFixedTop) {
      headerDom.addClass('white-bg-header')
    } else {
      // 这2个页面有header滑动效果才需要移除样式, 特殊处理汉堡页内弹窗的场景
      if (LS.site.page === 'index' || location.href.indexOf("pages/about-us") > 0) {
        if (removeHeadStyle) {
          headerDom.removeClass('white-bg-header');
          return;
        }
        var isMenuDarwerShow = $('#looksky-header-menu-drawer').css('display') === 'block';
        !isMenuDarwerShow && headerDom.removeClass('white-bg-header');
      }
    }
  }

  /**
   * 
   * @param {*} tests String、Object、Array
   * 多个，array: LS.ui.initAbt(['aatest']);
   * 单个，string: LS.ui.initAbt('aatest');
   * 多个，object: 
   * LS.ui.initAbt({
      'also-like': {
        'a': 0.5,
        'b': 0.5
      },
      'buy-it-now': {
        'a': 10,
        'b': 30,
        'c': 20
      },
      'custom': {
        'a': 0.1,
        'b': 0.2,
        'c': 0.3,
        'd': 0.4
      }
    });
   */
  function initAbt(tests) {
    var abtKey = {};
    var plan = {
      'a': 0.5,
      'b': 0.5
    }
    if (Object.prototype.toString.call(tests) === '[object Object]') {
      for (var t in tests) {
        abtKey[LS.ui.abtMap[t]] = tests[t];
      }
    } else if (Object.prototype.toString.call(tests) === '[object Array]') {
      for (var i = 0, len = tests.length; i < len; i++) {
        abtKey[LS.ui.abtMap[tests[i]]] = plan;
      }
    } else {
      abtKey[LS.ui.abtMap[tests]] = plan;
    }
    LS.abt.shunt && LS.abt.shunt(abtKey);
  }

  // 公共调用接口获取sizeguide数据的方法
  function getSizeGuideDataHandle(productId, callback) {
    // 调用接口
    LS.ajax({
      url: LS.ui.routes.getProductSizeGuideInfo,
      type: "GET",
      data: {
        productId: productId,
      },
      success: function (response) {
        if (!response.hasError && response.code == '0') {
          callback && typeof callback === "function" && callback(response.data);
        }
      },
      error: function (error) {
        //  LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
      },
    });
  }

  /**
   * 保存checkout来源
   */
  function setCheckoutSource(self) {
    var source = $(self).attr('data-checkout-source') || '';
    if (source === 'bag') {
      source = LS.site.page === 'cart' ? `${source}_web` : `${source}_drawer`;
    }
    LS.cookie.set('looksky-checkout-source', source, 24);
    LS.cookie.set('looksky-checkout-source-url', location.href, 24);
  }

  function getCheckoutStep() {
    var checkoutStep = '';
    if (typeof Shopify !== undefined && Shopify.Checkout.step) {
      checkoutStep = Shopify.Checkout.step;
    } else if (location.href.indexOf('orders') >=0) {
      checkoutStep = 'order';
    }
    return checkoutStep;
  }

  // 全局模块曝光方法
  function globalModelShowHandle (dom, reportType, data, threshold = 1) {
    if ($(dom).length == 0) {
      return false;
    }
    var config = {
      threshold: [threshold]
    }
    LS.observe.intersection(dom, function(entries, observer) {
      for (let i = 0, len = entries.length; i < len; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          // 上报
          LS.stat({
            eid: LS.ui.reportType['moduleShow'],
            ext1: reportType,
            ...data
          });
        }
      }
    }, config)
  }

  /**
   * 
   * @param {number} score 评分：1-5
   * @param {string} wrapper 容器类名：会查找该容器下类名为reviews-star-wrapper的元素插入节点
   * @param {string} color star颜色: yellow、brown
   * @param {string} size star大小: large、small
   */
  function genReviewsStar(score = 5, wrapper, color = 'yellow', size = 'large', isShowReviewNum = true) {
    var fullScore = 5;
    var full = Math.floor(score);
    var empty = Math.floor(fullScore - score);
    var half = fullScore - full - empty;
    var fullStarDom = `<div class="reviews-star ${color}-full-star ${size}"></div>`;
    var halfStarDom = `<div class="reviews-star ${color}-half-star ${size}"></div>`;
    var emptyStarDom = `<div class="reviews-star ${color}-empty-star ${size}"></div>`;
    var innerText = '';
    if (full > 0) {
      for (var i = 0; i < full; i++) {
        innerText += fullStarDom;
      }
    }
    if (half > 0) {
      for (var i = 0; i < half; i++) {
        innerText += halfStarDom;
      }
    }
    if (empty > 0) {
      for (var i = 0; i < empty; i++) {
        innerText += emptyStarDom;
      }
    }
    var starHtml = `<div class="reviews-star-wrapper">${innerText}</div>`
    var starWrapper = `
      <div class="reviews-item_score-wrapper">
        ${starHtml}
        <div class="reviews-item_score-num" style="${!isShowReviewNum ? 'display: none;' : ''}">${Number(score).toFixed(1) + '/' + fullScore.toFixed(1) }</div>
      </div>
    `
    $(wrapper).find('.reviews-star-box').append(starWrapper);
  }

  /**
   * 批量获取并插入商品评分模块
   */
  function batchInsertReviewsModule(arr, skcTitleList) {
    if (!arr.length) return;
    LS.ajax({
      url: LS.ui.routes.batchGetProductRating,
      type: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify({
        productIds: arr
      }),
      success: function (res) {
        for (var i = 0, len = skcTitleList.length; i < len; i++) {
          var score = res.data[i];
          var skcTitle = skcTitleList[i];
          var target = $('#collection-conatiner').find(`.ls-product-block[data-skc-title="${skcTitle}"]`);
          if (!$(target).find('.reviews-item_score-wrapper').length) {
            LS.ui.genReviewsStar(score, target, 'yellow', 'small');
          }
        }
      },
      error: function (error) {
      },
    });
  }

  function handleHeaderBar(callback, showTitle = '') {
    $('.header-left-icon_search').hide();
    $('.header-drawer-close').show();

    if (showTitle) {
      $('.looksky-header-model').find('.header-modelcon-content_icon').hide();
      $('.looksky-header-model').find('.header-modelcon-content_title').text(showTitle);
    }

    $('#header-drawer-close').off('click').on('click', function() {
      callback && typeof callback === "function" && callback();
      $('.header-left-icon_search').show();
      $('.header-drawer-close').hide();
    });
  }

  function resetHeaderBar() {
    $('.header-left-icon_search').show();
    $('.header-drawer-close').hide();
  }

  function initHeaderInteractive() {
    var H = 50;   // 滚动范围高度
    var T = 0.5;  // 最低透明度阈值，防止导航看不清楚
    var $nav = $('.looksky-header-model-con');

    $(window).on('scroll', function() {
      var sh = $(this).scrollTop();
      var br = 1 - sh / H;
      var wr = (sh - H ) / H;
      var bo = br > 1 ? 1 : (br < T ? T : br);
      var wo = wr > 1 ? 1 : (wr < T ? T : wr);
      if (sh < H) {
        $nav.removeClass('white-bg-header').css('opacity', bo);
      } else {
        wo <= 1 && $nav.addClass('white-bg-header').css('opacity', wo);
      }
    });
  }

  function isLogin() {
    var userInfo = LS.user.getInfo();
    return userInfo.token ? true : false;
  }

  function isFunctionOpenCountry() {
    if (LS.ui.shopMap[LS.site.shop] === LS.ui.shopAU) {
      return false;
    } else if (LS.ui.shopMap[LS.site.shop] === LS.ui.shopMain) {
      return LS.site.country === 'US';
    }
    return false;
  }

  /**
   * 保存最后一个添加购物车的商品
   */
  function saveLastProductByAddCart(id) {
    LS.setData('lastProductByAddCart', id);
  }

   /**
   * 获取最后一个添加购物车的商品
   */
    function getLastProductByAddCart() {
      LS.getData('lastProductByAddCart');
    }

  function hidePopupBox(self) {
    // 恢复弹窗底部滚动方法
    LS.ui.popupRecoveryScrollHandle();
    // 隐藏弹窗
    $(self).parents(".ls-vertical-popupbox").remove();
    
    // 是否需要订阅弹窗
    // 获取订阅ab
    LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(3000, false, 1, '1', 'showJoinCollectivePopSelfPush');
  }

  // 全局公共事件绑定方法
  function publicEventBind() {
    // 转介绍点击判断登录态
    $(document).on('click', '.js-refer-click-btn', function() {
      LS.ui.loginFn.createLoginPopup(true, `${LS.site.baseUrl}/pages/refer`);
      // 上报
      var type = $(this).attr('type');
      LS.stat({
        eid: LS.ui.reportType['click'],
        ext1: LS.ui.referReportMap['clickReferEarn'],
        ext2: type ? type : 'other',
      });
    });

    $(document).on('click', '.js-my-click-btn', function() {
      sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['other']);
      LS.ui.loginFn.createLoginPopup(true, `${LS.site.baseUrl}/pages/my`);
    });

    // 点击头像
    $(document).on('click', '#header-account', function() {
      if (location.href.indexOf('pages/register') > 0) return;
      sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['account']);
      LS.ui.loginFn.createLoginPopup(true, `${LS.site.baseUrl}/pages/my`, 'my_account');
      // 上报
      LS.stat({
        eid: LS.ui.reportType['click'],
        ext1: LS.ui.globalReportMap['clickAccountEntry'],
      });
    });

    // 点击我的订单
    $(document).on('click', '#ls-menu-myorder-account', function() {
      sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['other']);
      LS.ui.loginFn.createLoginPopup(true, `${LS.site.baseUrl}/pages/my`, 'my_order');
      // 上报
      LS.stat({
        eid: LS.ui.reportType['click'],
        ext1: LS.ui.globalReportMap['clickAccountEntry'],
      });
    });

    // 判断地址栏参数，看是否需要唤起弹窗并跳转到对应页面
    var loginPop = LS.getParam('loginPop') || '';
    var jumpUrl = LS.getParam('jumpUrl') || '';
    if (loginPop && location.href.indexOf('pages/register') < 0) {
      setTimeout(function() {
        LS.ui.loginFn && LS.ui.loginFn.createLoginPopup(true, (jumpUrl ? `${LS.site.baseUrl}${jumpUrl}` : ''));
      }, 1000)
    }

    // 客服入口交互方法
    var timer = setInterval(function() {
      if ( $('#tidio-chat-iframe').length ) {
        // 打开购物车隐藏客服
        $('#tidio-chat-iframe').length && LS.ui.customerServiceEntrance();
        // 更改客服层级
        $('#tidio-chat-iframe').css('z-index', '501 !important');
        // 清除定时器
        clearInterval(timer)
      }
    }, 200);

    // 判断地址栏是否携带邮件上报参数
    var url_ext1 = LS.getParam('email_ext1') || '';
    var url_tag = LS.getParam('email_tag') || '';
    if (url_ext1 && url_tag) {
      // 上报
      LS.stat({
        eid: LS.ui.reportType['click'],
        ext1: LS.ui.userSubscriptionReportMap[url_ext1],
        ext2: url_tag,
      });
    }

    // 首页弹窗订阅弹窗需求
    var subscribePop = LS.getParam('subscribePop') || '';
    if (subscribePop) {
      // 订阅弹窗
      LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(0, true, 2, '1', 'showJoinCollectivePopSelfPush');
    }
  }

  // 会员折扣浮球注册入口方法
  function vipFloatBallHandle() {
    if (!LS.ui.isFunctionOpenCountry()) return;
    // 判断当前页面是否显示浮球
    if (!['index', 'collection', 'product'].includes(LS.site.page)) return;
    // 获取用户会员信息
    var userVipInfo = LS.userVipInfo;
    // 是否已登录
    var isLogin = LS.ui.isLogin();
    var floadBallCouponAnimationFlag = 'floadBallCouponAnimationFlag';
    // 浮球html
    var floatBallHtml = `
      <div class="ls-vip-floatball-btn" id="ls-vip-floatball-btn">
        <% if ( data.isLogin ) { %>
          <div class="vip-floatball vip-floatball-login fix-padding-bot">
            <% if (data.userVipInfo && data.userVipInfo.userPointsInfo) { %>
              <div class="coupon-num-text">
                <p><%= data.userVipInfo.userPointsInfo.couponCount %> Coupons</p>
              </div>
            <% } %>
            <div class="coupon-ballbox">
              <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/floatball_coupon2.png?v=1673337428" />
              <div class="redbox"></div>
            </div>
          </div>
        <% } else { %>
          <div class="vip-floatball vip-floatball-nologin fix-padding-bot">
            <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/floatball_login2.png?v=1673333972" />
          </div>
        <% } %>
      </div>
    `;
    // 生成模块
    var params = {
      'isLogin': isLogin,
      'userVipInfo': userVipInfo,
    }
    var htmlStr = LS.tmpl(floatBallHtml, params);
    $("body").append(htmlStr);

    // 上报
    if (isLogin) {
      // 登录后浮球曝光
      LS.stat({
        eid: LS.ui.reportType['moduleShow'],
        ext1: LS.ui.loginRegistrationProcessMap['showCouponsFloatBall'],
        ext2: document.referrer
      });
    } else {
      // 登录前浮球曝光
      LS.stat({
        eid: LS.ui.reportType['moduleShow'],
        ext1: LS.ui.loginRegistrationProcessMap['showJoinUsFloatBall'],
        ext2: document.referrer
      });
    }

    // ----- 交互方法模块 -----
    // 定义参数
    var startScrollTop = 0;
    var endScrollTop = 0;
    // 已登录情况下，收起优惠券提示信息
    if (isLogin) {
      if (!sessionStorage.getItem(floadBallCouponAnimationFlag)) {
        $('#ls-vip-floatball-btn .coupon-num-text').addClass('active');
        // 3秒后收起
        setTimeout(function() {
          // 移除样式
          $('#ls-vip-floatball-btn .coupon-num-text').removeClass('active');
          sessionStorage.setItem(floadBallCouponAnimationFlag, 1);
        }, 5000)
      }
      // 点击关闭订阅弹窗时，交互效果
      if ($('.subscribe-result-drawer').length > 0) {
        // 收起浮球
        $('#ls-vip-floatball-btn .vip-floatball').attr('style', 'right: -30px;');
      }
      $(document).on('click', '.subscribe-result-drawer_overlay, .subscribe-result-drawer_header-close-btn, .subscribe-result-drawer_footer-btn', function() {
        // 展示浮球，展示隐藏优惠券提示
        $('#ls-vip-floatball-btn .vip-floatball').attr('style', 'right: 5px;');
        setTimeout(function() {
          // 添加样式
          $('#ls-vip-floatball-btn .coupon-num-text').addClass('active');
        }, 1200)
        setTimeout(function() {
          // 移除样式
          $('#ls-vip-floatball-btn .coupon-num-text').removeClass('active');
        }, 6000)
      });
    }
    // 监听滑动
    window.addEventListener("scroll", function (e) {
      // 获取滚动的高度
      var scrollTop = $(window).scrollTop();
      // 赋值开始滚动高度
      startScrollTop = scrollTop;
      var countTimer;
      // 清除定时器
      clearTimeout(countTimer);
      // 浏览器3秒内未滚动 则停止计时
      countTimer = setTimeout(function() {
        // 结束滚动方法
        isScrollEnd(scrollTop);
      }, 3000)
      // 收起浮球
      var isLogin = LS.ui.isLogin();
      var status =  $('#ls-vip-floatball-btn .coupon-num-text').hasClass('active');
      if (isLogin) {
        !status && $('#ls-vip-floatball-btn .vip-floatball').attr('style', 'right: -30px;');
      } else {
        $('#ls-vip-floatball-btn .vip-floatball').attr('style', 'right: -30px;');
      }
    })
    // 结束滚动
    function isScrollEnd(top) {
      // 赋值结束滚动高度
      endScrollTop = top;
      // 订阅优惠券弹窗
      var subscribePopLength = $('.subscribe-result-drawer').length;
      // 判断当开始结束滚动一致时
      if ( startScrollTop === endScrollTop && !subscribePopLength ) {
        // 显示浮球
        $('#ls-vip-floatball-btn .vip-floatball-nologin').attr('style', 'right: 0px;')
        $('#ls-vip-floatball-btn .vip-floatball-login').attr('style', 'right: 5px;')
      }
    }

    // ----- 点击事件 ------
    // 用户可用优惠券集合
    var vipAvailableCoupon = [];
    // 用户不可用优惠券集合
    var vipUnavailableCoupon = [];
    // 优惠券编辑弹窗
    var vipCouponListPopupHtml = `
      <div class="ls-main-popupbox ls-main-popupbox-vip-coupon">
        <div class="ls-main-popupbox-overlay" type="1"></div>
        <div class="ls-main-popupbox-con">
          <!-- 标题区域 -->
          <div class="main-popupbox-con-title">
            <p class="p-title">Coupon</p>
            <div class="title-close" type="2">
              <img src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/looksky_popup_close_phone2.png?v=1661931061" />
            </div>
          </div>
          <!-- 内容区域 -->
          <div class="main-popupbox-con-model">
            <div class="ls-pop-coupon-edit-con">
              <!-- 切换优惠券区域 -->
              <div class="ls-coupon-tab">
                <div class="tab-li tab-active" type="1">Available Coupons</div>
                <div class="tab-li" type="2">Unavailable Coupons</div>
              </div>
              <!-- 可使用优惠券区域 -->
              <div class="con-coupon-list available-coupon-list"></div>
              <!-- 不可使用优惠券区域 -->
              <div class="con-coupon-list unavailable-coupon-module"></div>
            </div>
          </div>
        </div>
      </div>
    `;
    // 点击会员浮球
    $(document).on('click', '#ls-vip-floatball-btn', function() {
      // 判断登录态
      if ( isLogin ) {
        // 打开优惠券弹窗
        $("body").append(vipCouponListPopupHtml);
        // 禁止弹窗底部滚动方法
        LS.ui.popupNoScrollHandle();
        // 创建优惠券方法
        createCouponListHandle(1, $('.ls-main-popupbox-vip-coupon .available-coupon-list'));
        // 登录后，点击浮球
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.loginRegistrationProcessMap['clickCouponsFloatBall'],
          ext2: document.referrer
        });
        // 优惠券弹窗曝光上报
        LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.loginRegistrationProcessMap['showCouponsPop'],
        });
      } else {
        // 订阅弹窗
        LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(0, true, 1, '1', 'showJoinCollectivePopClcBall');
        sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['float_ball']);
        // 隐藏浮球
        $('#ls-vip-floatball-btn').hide();
        // 登录前，点击浮球
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.loginRegistrationProcessMap['clickJoinUsFloatBall'],
          ext2: document.referrer
        });
      }
    });
    // 点击优惠券tab切换样式
    $(document).on('click','.ls-main-popupbox-vip-coupon .tab-li', function() {
      // 切换样式
      $(this).addClass('tab-active').siblings().removeClass('tab-active');
      // 获取类型
      var type = $(this).attr('type');
      var domStr = type === '1' ? $('.ls-main-popupbox-vip-coupon .available-coupon-list') : $('.ls-main-popupbox-vip-coupon .unavailable-coupon-module');
      var domStrTwo = type === '2' ? $('.ls-main-popupbox-vip-coupon .available-coupon-list') : $('.ls-main-popupbox-vip-coupon .unavailable-coupon-module');
      $(domStr).attr('style', 'display: flex;');
      $(domStrTwo).attr('style', 'display: none;');
      // 切换不可用优惠券时，调用接口
      if ( type === '2' ) {
        // 创建优惠券方法
        createCouponListHandle(4, $('.ls-main-popupbox-vip-coupon .unavailable-coupon-module'));
      }
    });

    // 创建优惠券方法
    function createCouponListHandle(type, dom) {
      // 调用接口
      LS.ajax({
        url: LS.ui.routes.queryUserCouponsApi,
        type: "GET",
        data: {
          lastId: '',
          count: 100,
          userCouponType: type,
        },
        success: function (res) {
          // 赋值
          if (type === 1) {
            vipAvailableCoupon = res.data.record || [];
          } else {
            vipUnavailableCoupon = res.data.record || [];
          }
          // 插入模块
          if (res.data.record && res.data.record.length) {
            var htmlDom = LS.ui.renderCouponListHtml(
              {
                arr: res.data.record, 
                className: type === 1 ? 'vip-available-coupon-box' : 'vip-unavailable-coupon-box'
              }
            );
            if (!htmlDom) return;
            $(dom).html(htmlDom);
            setTimeout(function() {
              LS.ui.renderCountDownTimer('.vip-available-coupon-box');
            }, 300)
          } else {
            $(dom).html(`
              <div class="no-coupon-status">
                <img class="empty-cover" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/empty_cart_cover.png?v=1649647528" width="170" height="170" loading="lazy">
                <p class="empty-text">No coupons here.</p>
              </div>
            `);
          }
        },
        error: function (error) {
          LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    }
  }

  // 客服入口交互方法
  function customerServiceEntrance() {
    // 状态
    var status = true;
    // 滚动记录位置
    var oldScroll = 0;
    var newScroll = 0;
    // 监听滑动
    window.addEventListener("scroll", function (e) {
      // 获取滚动的高度
      var scrollTop = $(window).scrollTop();
      newScroll = scrollTop;
      if (scrollTop !== 0 && status && (oldScroll !== newScroll || oldScroll == 0 )) {
        // 判断是否已经打开了客服弹窗
        if ($("#tidio-chat-iframe").contents().find("#new-message-textarea").length) {
          return;
        }
        // 重置状态
        status = false;
        // 收起聊天
        $('#tidio-chat-iframe').css('transition', 'opacity 600ms ease-in-out !important;');
        $('#tidio-chat-iframe').css('opacity', '0');
        // 插入展开icon
        var upImgHtml = `
          <div id='chat-iframe-open-btn'>
            <img class='fix-padding-bot' src='https://cdn.shopify.com/s/files/1/0568/2895/2624/files/floatball_service2.png?v=1673342176' />
          </div>
        `;
        setTimeout(function() {
          // 判断
          if ($('#chat-iframe-open-btn').length == 0) {
            $('#tidio-chat').prepend(upImgHtml);
          }
          // 处理收起icon
          $('#chat-iframe-open-btn').css('display', 'block');
          setTimeout(function() {
            $('#chat-iframe-open-btn').css('opacity', '1');
          }, 50)
        }, 400)
        // 隐藏聊天icon
        setTimeout(function() {
          $('#tidio-chat-iframe').css('display', 'none');
        }, 600)
      }
    });

    // 点击打开聊天窗口
    $(document).on('click', '#chat-iframe-open-btn', function() {
      // 打开聊天
      $('#tidio-chat-iframe').css('display', 'block');
      setTimeout(function() {
        $('#tidio-chat-iframe').css('opacity', '1');
        // 重置状态
        status = true;
        oldScroll = newScroll;
      }, 50)
      // 隐藏按钮
      $('#chat-iframe-open-btn').css('opacity', '0');
      setTimeout(function() {
        $('#chat-iframe-open-btn').css('display', 'none');
      }, 400)
    });
  }

  /**
   * 
   * @param {*} container 插入节点容器
   * @param {*} type 1 显示在底部
   */
  function insertDeliveryDelayTipModule(container, type = 0) {
    var closeBtn = `delivery-delay-tip_close-btn-${type}`;
    var icon = type === 1 
      ? 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_remind_2x_2.png?v=1661848164' 
      : 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_remind_2x_bdc410c9-669a-4563-be2e-647d1249cdd6.png?v=1661848165';
    var deliveryDelayTipHtml = `
      <div class="delivery-delay-tip-box ${type === 1 ? 'bottom' : 'inner'}">
        <img class='delivery-delay-tip_icon' src="${icon}">
        <p class="delivery-delay-tip_content">${LS.$t('public.topbar.delayed_text_tip')}</p>
        <img class="delivery-delay-tip_close-btn ${closeBtn}" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_close_light_2x_9ff95637-0ac9-4c90-82d8-41429c1b5f5f.png?v=1661848164"/>
      </div>
    `;
    $(container).append(deliveryDelayTipHtml);
    $('.' + closeBtn).on('click', function() {
      $(container).remove();
    });
  }

  /**
   * 校验已登录用户的国家跟访问的国家站点是否匹配，不匹配则清空登陆态刷新页面
   */
  function checkUserCountry() {
    var userInfo = LS.user.getInfo();
    if (userInfo.country && userInfo.country !== LS.site.country) {
      LS.stat({
        eid: LS.ui.reportType['custom'],
        ext1: LS.ui.globalReportMap['customLogoutByDomainNoMatch']
      })

      sessionStorage.clear();
      LS.user.delUserInfo();
      location.reload();
      return;
    }
  }

  function renderCountDownTimer(couponBoxWrapperDom) {
    LS.couponListTimer && clearInterval(LS.couponListTimer);
    var countDownDomList = $(couponBoxWrapperDom).find('.count-down-wrapper');
    var len = countDownDomList.length;
    var over48 = 48 * 60 * 60 * 1000;
    var timeStampArr = [];
    if (!len) return;
    for (var i = 0; i < len; i++) {
     var timeStamp = $(countDownDomList[i]).attr('data-end-time');
     var code = $(countDownDomList[i]).attr('data-discount-code');
     var couponDiffTime = (timeStamp - new Date().getTime()) / 1000;
     var isLess = timeStamp > 0 && couponDiffTime <=  over48;
     var dom = '.count-down-wrapper-' + code;
     if (isLess) {
      timeStampArr.push({
        diffTime: couponDiffTime,
        dom: dom
      })
     }
    }
    LS.couponListTimer = setInterval(() => {
      if (!timeStampArr.length) return clearInterval(LS.couponListTimer);
      timeStampArr.forEach(function(item, index) {
        var targetDom = item.dom;
        item.diffTime--;
        if (item.diffTime <= 0) {
          timeStampArr.splice(index, 1);
          var couponDom = $(targetDom).parents('.coupon-item');
          couponDom.removeClass('available').addClass('disabled');
          couponDom.find('.coupon-code-status').addClass('expired');
          return
        }
        var h = parseInt(item.diffTime / 60 / 60 % 24);
        let m = parseInt(item.diffTime / 60 % 60);
        let s = parseInt(item.diffTime % 60);
        var res = `
          <div class="count-down-container">
            <div class="count-down-item">${h < 10 ? '0' + h : h}</div>
            <span class="count-down-symbol">:</span>
            <div class="count-down-item">${m < 10 ? '0' + m : m}</div>
            <span class="count-down-symbol">:</span>
            <div class="count-down-item">${s < 10 ? '0' + s : s}</div>
        </div>`
      $(targetDom).html(res);
      })
    }, 1000)
  }

  /**
   * 生成单个优惠券
   * @param {object} couponData 优惠券数据
   * couponItem 单个优惠券数据
   * type 1: 展示 2:可选择 3:可兑换
   * checkedCoupon 已选择的优惠券
   * needCopyBtn 是否需要复制
   * @returns 
   */
  function renderCouponItem(couponData) {
    var couponItem = couponData.couponItem;
    var type = couponData.couponType;
    var checkedCoupon = couponData.checkedCoupon;
    var needCopyBtn = couponData.needCopyBtn;
    var dateFmt = LS.ui.dateFormat;
    // 单个优惠券
    // 用户优惠券类型: userCouponType @unused:1:未使用 @used:2:已使用 @expired:3:已过期
    // 小于48小时生成倒计时器 isLess48
    var less48Hour = 48 * 60 * 60 * 1000;
    var isLess48 = couponItem.endTime > 0 && couponItem.endTime - new Date().getTime() <= less48Hour;
    couponItem.isLess48 = isLess48;
    couponItem.type = type;
    couponItem.checked = couponItem.discountCode === checkedCoupon.discountCode;
    couponItem.needCopyBtn = needCopyBtn;
    couponItem.discountMinimalPurchaseAmountStr = couponItem.discountMinimalPurchaseAmount ? (Number(couponItem.discountMinimalPurchaseAmount)).toFixed(2) : '';

    var couponStatus = '';
    if (couponItem.vailable !== undefined ) {
      couponStatus = couponItem.vailable ? 
        couponItem.userCouponType == 1 ? couponItem.isLess48 ? 'is-less-48' : 'available' : 'disabled' 
        : 'disabled';
    } else {
      couponStatus = couponItem.userCouponType == 1 ? couponItem.isLess48 ? 'is-less-48' : 'available' : 'disabled';
    }

    var couponItemHtml = `
      <div class="coupon-item ${couponStatus}">
        <div class="coupon-left">                         
          <div class="coupon-left-header">
            <% if (data.redeemCouponAmount && data.redeemCouponAmount > 0) { %>
              <div class="coupon-disount"><%= data.currencySymbol %><%= data.currencyCode %><%= data.redeemCouponAmount %> OFF</div>
            <% } else if (data.discountPercentage && data.discountPercentage != "0%") { %>
              <div class="coupon-disount"><%= data.discountPercentage %> OFF</div>
            <% } %>
          </div>
          <% if (data.discountMinimalPurchaseAmount) { %>
            <div class="coupon-left-middle">
              On orders over <%= data.currencySymbol %><%=data.currencyCode %><%= data.discountMinimalPurchaseAmountStr %>
            </div>
          <% } else if (data.minimalProductCount > 0) { %>
            <div class="coupon-left-middle">
              On orders over <%= data.minimalProductCount %> items
            </div>
          <% } else { %>
            <div class="coupon-left-middle">No minimum requirements</div>
          <% } %>
          <% if (data.isLess48) { %>
            <div class="coupon-left-bottom">
              Ends in <div class="count-down-wrapper count-down-wrapper-<%= data.discountCode %>" data-discount-code="<%= data.discountCode %>" data-end-time="<%= data.endTime %>"></div>
            </div>
          <% } else if (data.startTime > 0 && data.endTime > 0){ %>
              <div class="coupon-left-bottom">Valid from <%= LS.formatTime(data.startTime, "${dateFmt}") %> to <%= LS.formatTime(data.endTime, "${dateFmt}") %></div>
          <% } else if (data.type === 3 && data.redeemCouponExpiredDays > 0){ %>
            <div class="coupon-left-bottom">Valid for <%= data.redeemCouponExpiredDays/30 %> month after redeem.</div>
          <% } else { %>
            <div class="coupon-left-bottom">Valid time is not limited</div>
          <% } %>
        </div>
        <% if (data.type === 3) { %>
          <div class="coupon-right">      
            <div class="coupon-redeem-text">Redeem <%= data.redeemPointsAmount %></div>
            <div class="coupon-redeem-text">points</div>
            <% if ( data.vailable ) { %>
              <div class="coupon-redeem-btn ls-coupon-redeem-btn" amount="<%= data.redeemCouponAmount %>" couponid="<%= data.pointsCouponRedeemSettingsId %>">Redeem</div>
            <% } else { %>
              <div class="coupon-redeem-text mrt-4">Insufficient</div>
              <div class="coupon-redeem-text">points</div>
             <% } %>
          </div>
        <% } else { %> 
          <div class="coupon-right <% if (data.needCopyBtn) { %>code-copy-btn<% } %>" value="<%= data.discountCode %>">      
            <% if (data.type === 2) { %>
              <div class="coupon-checkbox icon-coupon-checkbox <% if (data.checked) { %>icon-coupon-checked<% } %>" code="<%= data.discountCode %>"></div>     
            <% } %>
            <div class="coupon-code"><%= data.discountCode %></div>
            <div class="coupon-code-btn">CODE</div>
            <div class="coupon-code-status <% if (data.userCouponType == 2) { %>used<% } else if (data.userCouponType == 3) { %>expired<% } %>"></div>
          </div>
        <% } %>
      </div>          
    `;
    var couponItemDomStr = LS.tmpl(couponItemHtml, couponItem);
    return couponItemDomStr;
  }

  /**
   * 生成优惠券列表
   * @param {object} arr 数据集合 
   * arr 优惠券集合 
   * className 优惠券列表累吗
   * type 1: 展示 2:可选择 3:可兑换
   * checkedCoupon 已选中的优惠券
   * needCopyBtn 复制功能
   * @returns 
   */
  function renderCouponListHtml(data) {
    var arr = data.arr || [];
    var className = data.className || '';
    var type = data.type || 1;
    var checkedCoupon = data.checkedCoupon || {};
    var needCopyBtn = data.needCopyBtn || false;
    var dom = '';
    if (arr.length) {
      arr.forEach(function(item) {
        var couponItemDom = LS.ui.renderCouponItem({
          couponItem: item, 
          couponType: type,
          checkedCoupon: checkedCoupon,
          needCopyBtn: needCopyBtn,
        });
        dom += `${couponItemDom}`
      })
    }
    var listDom = `<div class="coupon-box ${className}">${dom}</div>`
    return listDom;
  }

  function showPage(page) {
    // if ($('.ls-main-popupbox-page').length > 0) {
    //   $('.ls-main-popupbox-page').show();
    //   return;
    // }

    try {
      LS.ajax({
        url: `${LS.site.baseUrl}?sections=${page}`,
        dataType: "html",
        success: function (res) {
          var responseHTML = JSON.parse(res || 'null')[page] || '';
          var tmpl = `
            <div class="ls-main-popupbox ls-main-popupbox-page">
              <div class="ls-main-popupbox-overlay"></div>
              <div class="ls-main-popupbox-con fix-pos-bot">
                <img class="ls-main-popupbox-page_close title-close" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/ls_icon_close_white_2x_199b037d-e6bb-4ac2-b041-85247b544b1e.png?v=1665736507" />
                <div class="main-popupbox-con-model popup-page-container">
                  ${responseHTML}
                </div>
              </div>
            </div>
          `;
          $('body').append(tmpl);
        },
        error: function(e) {}
      });
    } catch(e) {} 
  }

  function getMemberIcon(currrentVip) {
    switch (currrentVip) {
      case 'C0': 
        return 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/c0_72x.png?v=1673504697';
      case 'C1':   
        return 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/c1_3x_c50c39ee-9bdf-4e08-82c3-9c09048765eb_72x.png?v=1673243154';
      case 'C2':
        return 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/c2_3x_bdceac0a-0b48-4138-90f4-cebd2f31c57b_72x.png?v=1673243154'  
    }
  }
 
  /**
   * 统一处理接口返回的报错
   */
  function watchAjaxError() {
    try {
      $(document).on("ajaxSuccess", function (event, xhr, opts, data) {
        if (data && data.hasError) {
          var errorObj = data.error;
          var errorCode = errorObj ? errorObj.code : '';
          // token无效
          if (errorCode === 'A10106') {
            LS.user.delUserInfo();
            location.reload();
          }
        }
      });
    } catch (e) {}
  }

  /**
    * 上报登录、注册入口来源
    * @param {*} type 1: 注册 2: 登录
    * @param {*} email 注册、登录的邮箱号
    */
  function reportLoginRegisterSource(type, email) {
    var ext1 = type === 1 ? LS.ui.userSubscriptionReportMap['registered'] : LS.ui.userSubscriptionReportMap['logged_in'];
    var ext3 = sessionStorage.getItem('login_register_source') || 'other';
    LS.stat({
      eid: LS.ui.reportType['custom'],
      ext1: ext1,
      ext2: email,
      ext3: ext3
    })
  }

   /**
     * 设置abtest, 登录discountTipAfterLogin、未登录guideRegisterBeforeLogin
     */
  function handleMarketAbtest() {
    LS.ui.initAbt(['discountTipAfterLogin']);
  }
  
  function getMarketAbtestResult() {
    var abtestMap = LS.abt.getPlan && LS.abt.getPlan() || {};
    var abtRes = abtestMap[LS.ui.abtMap['discountTipAfterLogin']] || '';
    var isShowModule = abtRes === 'b';

    return {
      isShowModule: isShowModule
    }
  }

  function formatMonthToEnglish(time) {
    var fmtTime = ''
    var timeArr = time.split('/');
    var month = timeArr[0];
    var date = timeArr[1];
    var year = timeArr[2];
    switch(month) {
      case '01':
        month = 'Jan';
        break; 
      case '02':
        month = 'Feb';
        break; 
      case '03':
        month = 'Mar';
        break; 
      case '04':
        month = 'Apr';
        break; 
      case '05':
        month = 'May';
        break;  
      case '06':
        month = 'Jun';
        break; 
      case '07':
        month = 'Jul';
        break; 
      case '08':
        month = 'Aug';
        break; 
      case '09':
        month = 'Sept';
        break; 
      case '10':
        month = 'Oct';
        break; 
      case '11':
        month = 'Nov';
        break; 
      case '12':
        month = 'Dec';
        break;  
    }
    fmtTime =  `${month} ${date}, ${year}`;
    return fmtTime;
  }

  function handleUrlAndDataByLogin(data, url) {
    var token = data.accessToken || '';
    var userId = data.userId;
    var accessTokenExpireTimestamp = data.accessTokenExpireTimestamp || '';
    var timestampNow = new Date().getTime();
    var hour = (accessTokenExpireTimestamp - timestampNow)/(60*60*1000);
    LS.user.setUserInfo({
      accessToken: token,
      userId: userId,
      hour: hour,
      userCountry: LS.site.country
    })
    setTimeout(function() {
      location.replace(url)
    }, 500);
  }

  function getResultHtml(info, title, img) {
    title = title || 'Submit successful!';
    img = img || 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_ic_Thank_you_succeed_2x_1_9655296c-b112-47e3-b88c-005956c99d8a.png?v=1679470310';
    var resultHtml = `
      <div class="common-success-result-wrapper">
        <img class="common-success-result-img" src="${img}" />
        <div class="common-success-result-title">${title}</div>
        <div class="common-success-result-info">${info}</div>
      </div>
    `;
    return resultHtml;
  }
  
  function escapeXSS(str) {
    let pattern = /[&<>"`=\/]/g;
    let replaceMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "\"": "&quot;",
      // "'": "&#39;",
      "`": "&#x60;",
      "=": "&#x3D;",
      "/": "&#x2F;"
    };
    return str.replace(pattern, match => replaceMap[match]);
  }   

  /**
   * 
   * @param {number} handleType 1:商详页元字段 2、商品模块元字段 3、购物车商品字段
   * @returns 
   */
  function isKindBelong(handleType, dataDom) {
    var targetDom = null;
    var productKind = '';
    var productCategory = '';
    var productMaterial = '';
    var productComposition  = '';
    var productType  = '';
    var isDuvetSets = 88 // 被套
    var isSheetSets = 89 // 床单
    var isPillowcases = 90 // 枕套
    if (handleType === 1) {
      targetDom = $('#product-page').find('.product-basic-data');
    } else if (handleType === 2) {
      targetDom =  $(dataDom).parents('.ls-product-info-databox').find('.product-basic-data');
    } else if (handleType === 3) {
      targetDom = $(dataDom).find('.product-basic-data');
    }
    if (targetDom) {
      productKind = targetDom.attr('product-kind') || 0;
      productCategory = targetDom.attr('product-category');
      productMaterial = targetDom.attr('product-material');
      productComposition = targetDom.attr('product-composition');
      productType = targetDom.attr('product-type');
    }
    return {
      isDuvetSetsOrSheetSets: productType == isDuvetSets || productType == isSheetSets,
      isPillowcases: productType == isPillowcases,
      bedding: productKind == 2 && productCategory == 87,
      clothes: productKind == 0 || productKind == 1,
      kitchenOrAccessories: false,
      productType: productType
    };
  }

  /**
   * 匹配商品品类的尺码所对应包含的套件
   * @param {object} kindBelongObj 商品品类数据
   * @param {string} productSize 商品品类尺码
   */
  function matchProductKindSizeInclusions(kindBelongObj, productSize) {
    var productType = kindBelongObj.productType;
    // 88: 被套 89: 床单 90: 枕套
    var productTypeMap = {
      '88': {
        'Full/Queen': '1 x Duvet Cover, 2 x Shams',
        'King/Cal King': '1 x Duvet Cover, 2 x Shams',
        'Twin': '1 x Duvet Cover, 1 x Sham',
      },
      '89': {
        'Full': '1 x Flat sheet, 1 x Fitted sheet, 2 x Pillowcases',
        'Queen': '1 x Flat sheet, 1 x Fitted sheet, 2 x Pillowcases',
        'King': '1 x Flat sheet, 1 x Fitted sheet, 2 x Pillowcases',
        'Cal King': '1 x Flat sheet, 1 x Fitted sheet, 2 x Pillowcases',
        'Twin': '1 x Flat sheet, 1 x Fitted sheet, 1 x Pillowcases',
      },
      '90': {
        'Standard': '2 x Pillowcases',
        'King': '2 x Pillowcases',
      }
    };
    var resMap = productTypeMap[productType];
    var res = resMap ? resMap[productSize] : ''
    return res;
  }

  // 页面居中弹窗
  function createDialog(className, innerHtml) {
    var dialog = `
      <div class="ls-vertical-popupbox ls-vertical-popupbox-${className}">
        <div class="ls-vertical-popupbox-overlay"></div>
        <div class="ls-vertical-popupbox-con common-dialog-container ls-vertical-popupbox-con_${className}">
          <img class="common-dialog-close con-close-btn popupbox-${className}_close" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic__close_2x_77f9a8aa-fdd0-4970-a8d1-e7d5a183c82a.png?v=1685088893"/>
          <div class="dialog-inner_${className}">
            ${innerHtml}
          </div>
        </div>
      </div>
    `;
    return dialog;
  }

  function storeIsRegisteAd() {
    var isRegisteAd = LS.getParam('isRegisteAd');
    if (isRegisteAd == 1) {
      sessionStorage.setItem('isRegisteAd', 1);
    }
  }

  function showRegisteModule() {
    var urlField = LS.getParam('isRegisteAd');
    var sessionField = sessionStorage.getItem('isRegisteAd');
    var isLogin = LS.ui.isLogin();
    return (urlField || sessionField) && !isLogin ? true : false;
  }

  function getRegisteModule(source) {
    var registeModule = `
      <div class="registe-module-container" data-source="${source}">
        <div class="registe-module_header-wrapper">
          <div class="registe-module_header-title">Join Us at the Collective</div>
          <div class="registe-module_header-rules-btn" id="registe-rules-btn">Join Rules</div>
        </div>
        <div class="registe-module_card-wrapper">
          <img class="registe-module_card-item" src="${LS.site.country == 'US' ? 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/9_2x_b6b42b77-b423-428b-86c6-6862a537e5e5_700x.png?v=1686900979' : 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/9_2x_1_700x.png?v=1686900979'}" />
          <img class="registe-module_card-item" src="${LS.site.country == 'US' ? 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/9_2x_1_700x.png?v=1686900979' : 'https://cdn.shopify.com/s/files/1/0568/2895/2624/files/9_2x_3_700x.png?v=1686900979'}" />
        </div>
        <div class="registe-module_input-wrapper">
          <input class="registe-module_email-inp" id="subscribe-email-inp_inner" placeholder="All we need is your email" spellcheck="false" />
          <div class="registe-module_submit-btn" id="subsuribe-btn_inner">Join Now</div>
        </div>
        <div class="registe-module_email-error-box" id="subscribe-email-error_inner">Please enter a valid email.</div>
      </div>
    `;
    sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['join_us_module']);
    return registeModule;
  }

  function insertRegisteModuel(type) {
    var registModule = getRegisteModule(type) || '';
    $('.registe-module-wrapper_mobile').append(registModule);
    LS.stat({
      eid: LS.ui.reportType['moduleShow'],
      ext1: LS.ui.loginRegistrationProcessMap['showJoinUsModule']
    })
  }  

  function handleCollectionTab(self) {
    var $this = $(self);
    var index = $this.index();
    var tabActiveCls = 'active'; 
    var contentActiveCls = 'current-active';
    var targetContentDom = $('.tab-collection-content li:eq(' + index + ')');
    var targetCollectionId = targetContentDom.find('.ls-featured-collection-listing').attr('data-collection-id');
    targetContentDom.find('.ls-featured-collection-product-list').html('');
    $this.addClass(tabActiveCls).siblings().removeClass(tabActiveCls);
    targetContentDom.addClass(contentActiveCls).siblings().removeClass(contentActiveCls);
    LS.ui.collectionFn.getCollectionModule({
      dom: targetContentDom, 
      collectionId: targetCollectionId, 
      canLoadMore: true, 
      reset: true
    });
  }

  function initTabCollection() {
    var tabColectionActiveItem = $('.tab-collection-item.current-active');
    var tabListDom = $(tabColectionActiveItem).find('.ls-featured-collection-listing');
    var tabCollectionId = tabListDom.attr('data-collection-id');
    LS.ui.collectionFn.getCollectionModule({
      dom: tabListDom, 
      collectionId: tabCollectionId, 
      canLoadMore: true
    });
    LS.ui.collectionFn.bindScrollType('tab-collection');
  }
 
   
  // 当其他国家可售的时候 用otherCountrySellable 再判断一下是否可售 otherCountrySellable 0:其他国家不可售  1:其他国家可售
  function isOtherCountrySoldout(otherCountrySellable) {
    var soldout = false;
    if (LS.site.country != 'US' && otherCountrySellable == 0) {
      soldout = true;
    }
    return soldout
  }
  
  LS.ui.renderBottomDrawer = renderBottomDrawer;
  LS.ui.genDialogConfirm = genDialogConfirm;
  LS.ui.toastShowHandle = toastShowHandle;
  LS.ui.loadingPopShow = loadingPopShow;
  LS.ui.loadingPopHide = loadingPopHide;
  LS.ui.loadingBtnShow = loadingBtnShow;
  LS.ui.loadingBtnHide = loadingBtnHide;
  LS.ui.copyToClip = copyToClip;
  LS.ui.singleDayDateFormat = singleDayDateFormat;
  LS.ui.scopeDayDateFormat = scopeDayDateFormat;
  LS.ui.reporterMuti = reporterMuti;
  LS.ui.reporterSingle = reporterSingle;
  LS.ui.reporterCollection = reporterCollection;
  LS.ui.globalListExposureHandle = globalListExposureHandle;
  LS.ui.initElementExposure = initElementExposure;
  LS.ui.setFirstView = setFirstView;
  LS.ui.setInteractive = setInteractive;
  LS.ui.handleAppPages = handleAppPages;
  LS.ui.setAddCartAnimation = setAddCartAnimation;
  LS.ui.handleCheckout = handleCheckout;
  LS.ui.getCartItem = getCartItem;
  LS.ui.getSoldoutCheckout = getSoldoutCheckout;
  LS.ui.getOnSellItems = getOnSellItems;
  LS.ui.getCartInfo = getCartInfo;
  LS.ui.getSoldoutItems = getSoldoutItems;
  LS.ui.getSourceByAddToCart = getSourceByAddToCart;
  LS.ui.reporterCartState = reporterCartState;
  LS.ui.handleBuyitnowBtn = handleBuyitnowBtn;
  LS.ui.popupNoScrollHandle = popupNoScrollHandle;
  LS.ui.popupRecoveryScrollHandle = popupRecoveryScrollHandle;
  LS.ui.initAbt = initAbt;
  LS.ui.initImgLazyloadHandle = initImgLazyloadHandle;
  LS.ui.getSizeGuideDataHandle = getSizeGuideDataHandle;
  LS.ui.setCheckoutSource = setCheckoutSource;
  LS.ui.getCheckoutStep = getCheckoutStep;
  LS.ui.globalModelShowHandle = globalModelShowHandle;
  LS.ui.genReviewsStar = genReviewsStar;
  LS.ui.batchInsertReviewsModule = batchInsertReviewsModule;
  LS.ui.handleHeaderBar = handleHeaderBar;
  LS.ui.resetHeaderBar = resetHeaderBar;
  LS.ui.initHeaderInteractive = initHeaderInteractive;
  LS.ui.isLogin = isLogin;
  LS.ui.hidePopupBox = hidePopupBox;
  LS.ui.publicEventBind = publicEventBind;
  LS.ui.vipFloatBallHandle = vipFloatBallHandle;
  LS.ui.customerServiceEntrance = customerServiceEntrance;
  LS.ui.insertDeliveryDelayTipModule = insertDeliveryDelayTipModule;
  LS.ui.checkUserCountry = checkUserCountry;
  LS.ui.loadResourceAsync = loadResourceAsync;
  LS.ui.renderCountDownTimer = renderCountDownTimer;
  LS.ui.renderCouponItem = renderCouponItem;
  LS.ui.renderCouponListHtml = renderCouponListHtml;
  LS.ui.showPage = showPage;
  LS.ui.isFunctionOpenCountry = isFunctionOpenCountry;
  LS.ui.saveLastProductByAddCart = saveLastProductByAddCart;
  LS.ui.getLastProductByAddCart = getLastProductByAddCart;
  LS.ui.getMemberIcon = getMemberIcon;
  LS.ui.watchAjaxError = watchAjaxError;
  LS.ui.reportLoginRegisterSource = reportLoginRegisterSource;
  LS.ui.handleMarketAbtest = handleMarketAbtest;
  LS.ui.getMarketAbtestResult = getMarketAbtestResult;
  LS.ui.formatMonthToEnglish = formatMonthToEnglish;
  LS.ui.handleUrlAndDataByLogin = handleUrlAndDataByLogin;
  LS.ui.getResultHtml = getResultHtml;
  LS.ui.escapeXSS = escapeXSS;
  LS.ui.isKindBelong = isKindBelong;
  LS.ui.matchProductKindSizeInclusions = matchProductKindSizeInclusions;
  LS.ui.createDialog = createDialog;
  LS.ui.createPopup = createPopup;
  LS.ui.getRegisteModule = getRegisteModule;
  LS.ui.insertRegisteModuel = insertRegisteModuel;
  LS.ui.handleCollectionTab = handleCollectionTab;
  LS.ui.initTabCollection = initTabCollection;
  LS.ui.showRegisteModule = showRegisteModule;
  LS.ui.storeIsRegisteAd = storeIsRegisteAd;
  LS.ui.isOtherCountrySoldout = isOtherCountrySoldout;
})();

// 邀请
(function() {
  var invitePopupData = {};
  var inviterId = '';
  var invitePopHtml = `
    <div class="ls-vertical-popupbox ls-vertical-popupbox-invite">
      <div class="ls-vertical-popupbox-overlay"></div>
      <div class="ls-vertical-popupbox-con ls-vertical-popupbox-con_invite">
        <div class="popup-invite_inner"></div>
      </div>
    </div>
  `;
  var resultHtml = `
    <div class="popup-invite_header-wrapper">
      <div class="popup-invite_banner-wrapper js-lazyload-img">
        <img class="popup-invite_header-banner" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_ic_popup_m_2x_d7891cfa-0911-4d22-b7a4-a598963a938c_780x.jpg?v=1678343811"/>
      </div>
      <img class="popup-invite_header-close-btn con-close-btn" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic__close_2x_1.png?v=1659597029"/>
    </div>
    <div class="popup-invite_content-wrapper">
      <h1 class="popup-invite_content-title">Congratulations on joining the Grae Cove Collective.</h1>
      <p class="popup-invite_content-info">As a special welcome gift, you have received a US$20.00 from your friend to spend on your first purchase.</p>
      <div class="popup-invite_content-code-wrapper" id="invite-code" value="<%= data.code %>">
        <p class="popup-invite_content-code"><%= data.code %></p>
        <div class="popup-invite_content-code-copy"><%t('refer.newcomer_pop.copy_btn') %></div>
      </div>
      <p class="popup-invite_content-code-tip"><%t('refer.newcomer_pop.code_detail') %></p>
      <p class="popup-invite_content-code-tip">1. <%t('refer.newcomer_pop.code_detail_info1', { email: data.email }) %> </p>
      <p class="popup-invite_content-code-tip">2. No Minimum</p>
      <% if ( data.validDateStr !== '' ) { %><p class="popup-invite_content-code-tip">3. <%= data.validDateStr %></p><% } %>
      <div class="popup-invite_content-tip">We've saved your coupon to your account. to access, click on <a class="popup-invite_content-link" href="${LS.site.baseUrl}/pages/my-coupon">My Coupons</span></a></div>
    </div>
    <div class="popup-invite_btn-wrapper">
      <div class="popup-invite_btn con-close-btn"><%t('refer.newcomer_pop.show_now_btn') %></div>
    </div>
  `;

  var loginPopupHtml = `
    <div class="popup-invite_header-wrapper">
      <div class="popup-invite_banner-wrapper js-lazyload-img">
        <img class="popup-invite_header-banner" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_ic_popup_m_2x_d7891cfa-0911-4d22-b7a4-a598963a938c_780x.jpg?v=1678343811"/>
      </div>
      <img class="popup-invite_header-close-btn con-close-btn" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic__close_2x_1.png?v=1659597029"/>
    </div>
    <div class="popup-invite_content-wrapper">
      <h1 class="popup-invite_content-title">Good to see you again.</h1>
      <p class="popup-invite_content-info">Your email <span><%= data.email %></span> has already registered an account with us. Not a new customer.We're unable to offer the referral code to you. 
      Please log into your account to view other membership offers. </p>
    </div>
    <% if ( !data.isLogin ) { %>
      <div class="popup-invite_btn-wrapper">
        <div class="popup-invite_btn" id="login-from-invite">Login Now</div>
      </div>
    <% } %>
  `;

  var emailHtml = `
    <div class="popup-invite_header-wrapper">
      <div class="popup-invite_banner-wrapper js-lazyload-img">
        <img class="popup-invite_header-banner" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_ic_popup_m_2x_d7891cfa-0911-4d22-b7a4-a598963a938c_780x.jpg?v=1678343811"/>
      </div>  
      <img class="popup-invite_header-close-btn con-close-btn" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic__close_2x_1.png?v=1659597029"/>
    </div>
    <p class="popup-invite_bind-email-title"><%t('refer.pop.title') %></p>
    <p class="popup-invite_bind-email-text">
      <%t('refer.pop.subtext', { inviter: data.inviter }) %>
    </p>
    <p class="popup-invite_bind-email-text"><%t('refer.pop.text') %></p>
    <div class="popup-invite_inp-wrapper">
      <input 
        type="email"
        placeholder="<%t('refer.pop.inp_placeholder') %>"
        class="popup-invite_inp"
        value="<%= data.email? data.email : '' %>"
      />
    </div>
    <div class="popup-invite_bind-btn" id="invite-submit-btn" data-inviter-id="<%= data.inviterId %>">
      <p><%t('refer.pop.submit_btn') %></p>
    </div>
  `;
  var inviteDialogFn = {
    handleInvitee: function() {
      var inviteeEmail = LS.getParam('inviteeEmail');
      var inviter = LS.getParam('inviter');
      var inviteResult = LS.getParam('type') || '2';
      inviterId = LS.getParam('inviterId');
      if ((!inviter || !inviterId) && inviteResult !== '1') return;
      if (LS.ui.isLogin()) {
        if (inviteResult === '2') {
          invitePopupData = {
            email: LS.userVipInfo.userBasicInfo.email || '',
            isLogin: LS.ui.isLogin()
          }
          inviteDialogFn.showPopup(2, invitePopupData);
        } else if (inviteResult === '1') {
          var startTime = LS.getParam('startTime');
          var expiredTime = LS.getParam('expiredTime');
          var code = LS.getParam('code');
          startTime && (startTime = LS.ui.formatMonthToEnglish(LS.i18n.fmtTime(startTime)));
          expiredTime && (expiredTime = LS.ui.formatMonthToEnglish(LS.i18n.fmtTime(expiredTime)));
          var validDateStr = startTime && expiredTime ? 
            LS.$t('refer.newcomer_pop.code_detail_info3', { startTime: startTime, expiredTime: expiredTime })
            : '';
          invitePopupData = {
            title: 'Congratulations on joining the Grae Cove Collective.',
            email: inviteeEmail,
            code: code || '',
            validDateStr: validDateStr
          }; 
          inviteDialogFn.showPopup(1, invitePopupData);
        }
        
      } else {
        var emialPopupData = {
          inviter: inviter,
          inviterId: inviterId,
          email: inviteeEmail,
          isLogin: true
        };
        inviteDialogFn.showPopup(0, emialPopupData);
      }
    },
    showInviteEntrance: function() {
      $('.js-refer-click-btn').css({ 'display': 'block !important;' });
      $('#my-refer-friend').show();
    },
    /**
     * 
     * @param {number} type 弹窗类型 0 填写邮件  1 结果页 2引导登录页
     * @param {object} data 弹窗数据
     */
    showPopup: function(type, data) {
      if (!$('.ls-vertical-popupbox-invite').length) {
        $('body').append(invitePopHtml);
      }

      var popupDom = $('.ls-vertical-popupbox-invite');
      var inviteModule = popupDom.find('.popup-invite_inner');
      // 清空旧的模块
      inviteModule.empty();
      if (type === 0) {
        var tmpl = LS.tmpl(emailHtml, data);
        inviteModule.append(tmpl);
        // 链接上报
        LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.referReportMap['showPopReferBindingEmail'],
          ext2: data.email
        });
      }

      if (type === 1) {
        var tmpl = LS.tmpl(resultHtml, data);
        inviteModule.append(tmpl);
      }

      if (type === 2) {
        var tmpl = LS.tmpl(loginPopupHtml, data);
        inviteModule.append(tmpl);
      }

      LS.ui.popupNoScrollHandle();
      inviteDialogFn.bindEvent();
    },
    buildInvite: function(email) {
      return new Promise(function(reslove, reject) {
        LS.ajax({
          url: LS.ui.routes.subscribeV2,
          type: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
            email: email,
            inviteUserId: inviterId
          }),
          success: function(res) {
            if (res.hasError || res.code !== '0') {
              LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
              reject();
              return;
            };
            var result = res.data || {};
            var isRegister = result.register || '';
            if (isRegister) {
              invitePopupData = {
                email: email,
                isLogin: LS.ui.isLogin()
              }
              inviteDialogFn.showPopup(2, invitePopupData);
              reslove();
              return;
            }
            
            var nowDate = Date.now();
            var startTime = nowDate + '';
            var expiredTime = (nowDate + 2592000000) + '' // 有效期一个月
            var replaceUrl = LS.addParam({ inviteeEmail: email, startTime: startTime, expiredTime: expiredTime, code: result.code, type: 1 }, LS.site.baseUrl);
            LS.ui.handleUrlAndDataByLogin(result, replaceUrl);
            reslove();
          },
          error: function (error) {
            LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            reject();
          },
        })
      })
    },
    bindEvent: function() {
      $(document).on('click', '#invite-submit-btn', async function() {
        var email = $('.popup-invite_inp').val();
        
        if ( !LS.ui.validator.emailReg.test(email) ) {
          LS.ui.toastShowHandle(LS.$t('refer.page.inp_error4'));
          return;
        }
        // 加载动画
        LS.ui.loadingBtnShow($('#invite-submit-btn'), 1);
        await inviteDialogFn.buildInvite(email).catch(function() {
          // 隐藏动画
					LS.ui.loadingBtnHide($('#invite-submit-btn'));
          // 上报
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.referReportMap['clickSubmitReferBindingEmail'],
            ext2: email
          });
        });
        // 隐藏动画
				LS.ui.loadingBtnHide($('#invite-submit-btn'));
      });

      $(document).on('click', '#login-from-invite', function() {
        if (LS.ui.loginFn) {
          LS.ui.loginFn.createLoginPopup && LS.ui.loginFn.createLoginPopup();
          LS.ui.loginFn.switchToLoginModule && LS.ui.loginFn.switchToLoginModule();
          
          var url = window.location.href;
          url = url.replace(/(\?|#)[^'"]*/, '');
          window.history.pushState({},0,url);
        }
      })

      // 复制code
      $(document).on("click", "#invite-code", function () {
        // 复制方法
        var text = $(this).attr("value");
        LS.ui.copyToClip(text);
      })
    }
  }

  LS.ui.inviteDialogFn = {
    showInviteEntrance: inviteDialogFn.showInviteEntrance,
    handleInvitee: inviteDialogFn.handleInvitee
  };
})();

// 动态插入模块方法
(function () {
  var subscribeBtnBusy = false; // 订阅按钮是否可点击，防止多次点击
  // 创建订阅弹窗-abt 对照组
  var createSubscribePopHtmlAbt = `
    <div class="ls-vertical-popupbox ls-vertical-popupbox-createSubscribeAbt_plan-a  ls-vertical-popupbox-createSubscribeAbt">
      <div class="ls-vertical-popupbox-overlay" data-no-hide-popup="1"></div>
      <div class="ls-vertical-popupbox-con">
        <!-- 内容区域 -->
        <div class="con-modelbox subscribe-popup-container">
          <img class="subscribe-popup-bg" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/pop_subscribe_bg2_900x.png?v=1673340684" />
          <div class="subscribe-popup_header">
            <img class="subscribe-popup_header-close" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_close_popup__subscribe.png?v=1669959488" />
            <p class="subscribe-popup_header-title">Join Us at the Collective</p>
          </div>
          <div class="subscribe-popup-body">
            <div class="subscribe-popup_input-wrapper">
              <input class="email-inp" id="subscribe-email-inp_popup" placeholder="All we need is your email" spellcheck="false" />
              <div class="email-error-box" id="subscribe-email-error_popup">Please enter a valid email.</div>
              <div class="join-the-collective" id="subsuribe-btn_popup">
                <p>Join the Collective for Free</p>
              </div>
            </div>
            <p class="subscribe-popup_info">By clicking "Join the Collective for Free" you agree to the <a class="show-iframe_terms-of-service">Terms of Service</a> for the Grae Cove Collective, a membership program, and to email marketing. Click how we use your personal data in our <a class="show-iframe_privacy-policy">Privacy Policy</a>.</p>
          </div>
        </div>
      </div>
    </div>
  `;

  // 其他国家 订阅弹窗
  var  createSubscribePopHtmlAbtByOtherCountry = `
    <div class="ls-vertical-popupbox ls-vertical-popupbox-createSubscribeAbt_plan-b  ls-vertical-popupbox-createSubscribeAbt">
      <div class="ls-vertical-popupbox-overlay" data-no-hide-popup="1"></div>
      <div class="ls-vertical-popupbox-con">
        <div class="con-modelbox subscribe-popup-container_plan-b">
          <div class="subscribe-popup-top">
            <div class="subscribe-popup_header_plan_b">
              <img class="subscribe-popup_header-close" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_close_popup__subscribe.png?v=1669959488" />
              <p class="subscribe-popup_header-title">Join Us at the Collective</p>
              <p class="subscribe-popup_header-sub-title"><%= data.subTitle %></p>
            </div>
            <div class="subscribe-popup_coupon-wrapper">
              <div class="subscribe-popup_coupon-list">
                <% for ( var [index, item] of data.couponList.entries() ) { %>
                  <div class="subscribe-popup_coupon-item">
                    <div class="coupon-item-left">
                      <div class="coupon-disount"><%= item.discount %></div>
                      <div class="coupon-threshold"><%= item.threshold %></div>
                    </div>    
                    <div class="coupon-item-right">
                      <div class="coupon-code">Member Coupon</div>
                    </div> 
                  </div>
                <% } %>
              </div>
            </div>
          </div>

          <div class="subscribe-popup-bottom">
            <div class="subscribe-popup_input-wrapper_plan-b">
              <input class="email-inp" id="subscribe-email-inp_popup" placeholder="All we need is your email" spellcheck="false" />
              <div class="email-error-box" id="subscribe-email-error_popup">Please enter a valid email.</div>
              <div class="join-the-collective" id="subsuribe-btn_popup">Get All for Free</div>
              <p class="subscribe-popup_info">By clicking "Join the Collective for Free" you agree to the <a class="show-iframe_terms-of-service">Terms of Service</a> for the Grae Cove Collective, a membership program, and to email marketing. Click how we use your personal data in our <a class="show-iframe_privacy-policy">Privacy Policy</a>.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  // 订阅结果弹窗
  var subscribeResultDrawerHtmlAbt = `
    <div class="subscribe-result-drawer">
      <div class="subscribe-result-drawer_overlay" type="1"></div>     
      <div class="subscribe-result-drawer_inner">
        <div class="subscribe-result-drawer_header">
          <img class="subscribe-result-drawer_header-bg" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/subscribe_coupon_top_bg2_900x.png?v=1670581430">
          <img class="subscribe-result-drawer_header-close-btn" type="2" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_close_popup__subscribe.png?v=1669959488">
          <div class="subscribe-result-drawer_header-content-box">
            <img class="subscribe-result-drawer_header-content-icon" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/subscribe_coupon_succ_icon_a7c18d79-33a4-4c82-a145-6520a584553d.png?v=1669968411">      
            <div class="subscribe-result-drawer_header-content">
              <div class="subscribe-result-drawer_header-content-text">Welcome to the Grae Cove Collective</div>
            </div>
          </div>
        </div>
        <div class="subscribe-result-drawer_body" id="subscribe-result-coupon">
          <img class="subscribe-result-drawer_body_loading-img" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/img_ic_coupon_loading_2x_d95e91e8-a22f-4f4d-ac0d-84564d34c6d5_900x.png?v=1670578516">
        </div>
        <div class="subscribe-result-drawer_footer">
          <div class="subscribe-result-drawer_footer-box">
            <div class="subscribe-result-drawer_footer-btn" type="3">Go Back</div>
            <div class="view-all-clothing-btn">View All Clothing</div>
          </div>
          <div class="subscribe-result-drawer_footer-info">All coupons have been placed in your account.</div>
          <div class="subscribe-result-drawer_footer-info">Note: The same discount coupon cannot be claimed and reused.</div>
        </div>
      </div>
    </div>
  `;

  // 弹窗状态
  var firstLoad = false;
  var dynamicInsertModuleFn = {
    // 动态插入头部菜单方法
    insertHeaderMenuHander: function () {
      // 获取接口地址
      var headerApiUrl = `${LS.site.baseUrl}/?sections=looksky-header-menu`;
      LS.ajax({
        url: headerApiUrl,
        type: "GET",
        dataType: "html",
        success: function (res) {
          // 获取接口数据
          var responseHTML = JSON.parse(res || 'null')["looksky-header-menu"];
          // 插入头部菜单
          $('#looksky-header-model-menubox').html(responseHTML || '');
          
          // 头部相关点击事件
          dynamicInsertModuleFn.bindEvent();
          if (LS.ui.isShopAU) {
            // 获取数据
            var dataInfo = LS.ui.countryInfoMap[LS.site.country];
            dataInfo.menuText = dataInfo.symbolCode + dataInfo.symbol + ' / ' + LS.ui.languageMap[LS.site.lang];
            var countryHtml = `
              <div class="ls-navbox-countryinfo switch-country-lang-btn" data-pos="menu">
                <img src=${dataInfo.icon} />
                <p class="p1">${dataInfo.menuText}</p>
              </div>
            `;
            // 插入模块
            $('.con-mobile-custom-navbox').append(countryHtml);
          }
        },
        error: function (error) {
          // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
    // 动态插入底部方法
    insertFooterHander: function () {
      // 获取接口地址
      var footerApiUrl = `${LS.site.baseUrl}/?sections=looksky-footer`;
      LS.ajax({
        url: footerApiUrl,
        type: "GET",
        dataType: "html",
        success: function (res) {
          // 获取接口数据
          var responseHTML = JSON.parse(res || 'null')['looksky-footer'];
          // 插入页面底部
          $('#section-looksky-footer').html(responseHTML || '');
          dynamicInsertModuleFn.insertLangInfoInFooter();

          // 全站footer曝光
          LS.ui.globalModelShowHandle(document.querySelector('#section-looksky-footer'), LS.ui.globalReportMap['showFooter'], '', 0.2);
          // 全站footer refer earn曝光
          LS.ui.globalModelShowHandle(document.querySelector('.ls-footer-refer-friend-box'), LS.ui.globalReportMap['showGiveGet']);
        },
        error: function (error) {
          // LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
    insertLangInfoInFooter: function() {
      var curCountry = LS.ui.countryInfoMap[LS.site.country];
      var html = `
        <div class="footer-lang-module">
          <img class="footer-lang-module_img" src=${curCountry.icon} />
          <p class="footer-lang-module_text">${curCountry.symbolCode + curCountry.symbol}</p>
        </div>
      `;
      $('.footer-lang-btn').find('.title').html(html);      
    },

    // 头部announcement-bar滚动方法
    announcementBarSlide: function () {
      // 功能开放国家、未登录、无登录过的标识，添加顶部订阅滚动条
      var hasLoginRecord = LS.cookie.get('graecove_login_record');
      if (!LS.ui.isLogin() && !hasLoginRecord && location.href.indexOf("pages/register") <= 0) {
        var subscribeTip = LS.site.country !== 'US' ? 'Up to 13% Off in Savings' : 'Get $70 + 10% Off';
        var subscribeSlide = `
          <div class="ls-bar-slide-item" id="slide-subscribe-btn">
            <div>
              ${subscribeTip}, <span class="slide-btn">Join Us to Get Free</span>
            </div>
          </div>
        `;
        $('.ls-bar-slide-wrapper').append(subscribeSlide);
      }
      // 顶部bar
      var showstatus = false;
      new LS.Slider({
        container: ".ls-bar-slide-container",
        wrapper: ".ls-bar-slide-wrapper",
        slide: ".ls-bar-slide-item",
        direction: 'x',
        isLoop: true,
        isAuto: true,
        slideSpeed: 300,
        autoInter: 4000,
        endCallback: function(index) {
          if (index == 2 && !showstatus) {
            // 曝光
            showstatus = true;
            LS.stat({
              eid: LS.ui.reportType['moduleShow'],
              ext1: LS.ui.globalReportMap['showJoinUsTopBanner'],
            });
          }
        }
      });
    },

    // 头部相关点击事件
    bindEvent: function () {
      if (!LS.ui.isLogin()) {
        $(document).on('click', '#slide-subscribe-btn', function() {
          LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(0, true, 1, '1', 'showJoinCollectivePopClcTopbanner');
          sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['join_us_clc_topbanner']);
          // 上报
          LS.stat({
            eid: LS.ui.reportType['click'],
            ext1: LS.ui.globalReportMap['clickJoinUsTopBanner'],
          });
        });
      }

      $(document).on('click', '.show-iframe_terms-of-service', function() {
        LS.ui.showPage('looksky-terms-of-service');
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.userSubscriptionReportMap['clickTermsOfServiceJoinCollectivePop'],
        });
      });

      $(document).on('click', '.show-iframe_privacy-policy', function() {
        LS.ui.showPage('looksky-privacy-policy');
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.userSubscriptionReportMap['clickPrivacyPolicyJoinCollectivePop'],
        });
      });

      $(document).on('click', '#subscribe-login-btn', function() {
        $('.ls-vertical-popupbox-createSubscribeAbt').remove();
        
      });

      $(document).on("click", "#popup-login-btn", function () {
        $('.ls-vertical-popupbox').remove();
        LS.ui.loginFn.createLoginPopup && LS.ui.loginFn.createLoginPopup(true, '', 'subscribe');
      })
      
      // 点击顶部导航左侧菜单栏
      $(document).on("click", ".header-modelcon-left .header-menu-open", function() {
        var that = this;
        // 禁止弹窗底部滚动方法
        LS.ui.popupNoScrollHandle();
        $("#looksky-header-menu-drawer").addClass("is-active");
        setTimeout(function () {
          $("#looksky-header-menu-drawer").addClass("is-visible");
          $(that).removeClass('icon-header_menu_open header-menu-open').addClass('icon-header_menu_close header-menu-close');
        }, 50);

        LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.globalReportMap['showMenu']
        });
      });
      // 点击关闭弹窗
      $(document).on("click", ".header-menu-close", function () {
        var that = this;
        // 恢复弹窗底部滚动方法
        LS.ui.popupRecoveryScrollHandle(true);
        $("#looksky-header-menu-drawer").removeClass("is-visible");
        setTimeout(function () {
          $(that).removeClass('icon-header_menu_close header-menu-close').addClass('icon-header_menu_open header-menu-open');
          $("#looksky-header-menu-drawer").removeClass("is-active");
        }, 350);
      });

      $(document).on("click", ".menu-icon_open", function() {
        if ($(this).hasClass('icon-increase')) {
          $(this).removeClass('icon-increase').addClass('icon-minus');
          $(this).parents('.item-select-box').siblings('.menulist-item-nav-children').addClass('module-open');
        } else {
          $(this).removeClass('icon-minus').addClass('icon-increase');
          $(this).parents('.item-select-box').siblings('.menulist-item-nav-children').removeClass('module-open');
        }
      })

      // 点击底部footer菜单展开
      $(document).on("click", ".ls-footer-model .menu-list-title", function () {
        // 当没有展开时，添加class并展开
        if( !$(this).hasClass('title-active') ) {
          // 添加展开样式
          $(this).addClass('title-active');
          // 显示收起图片，隐藏打开图片
          $(this).find('.btn-close').show();
          $(this).find('.btn-open').hide();
          // 显示模块
          $(this).parents('.con-menu-list').find('.menu-list-con').attr('style', 'display: flex;')
        } else {
          // 去除展开样式
          $(this).removeClass('title-active');
          // 显示打开图片，隐藏收起图片
          $(this).find('.btn-close').hide();
          $(this).find('.btn-open').show();
          // 隐藏模块
          $(this).parents('.con-menu-list').find('.menu-list-con').attr('style', 'display: none;')
        }
      })

      // 点击icon关闭弹窗
      $(document).on("click", ".ls-vertical-popupbox .con-close-btn,.ls-vertical-popupbox-overlay",function () {
        var noHidePopup = $(this).attr('data-no-hide-popup');
        if (noHidePopup) return;
        LS.ui.hidePopupBox(this);
       });

      // 邮箱输入验证
      $('.newsletter-form-email').on('focus', function(e) {
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.userSubscriptionReportMap['clickEditFooter'],
        });
      })
      
      // 点击加入集体
      $(document).on('click', '#subsuribe-btn_popup', function() {
        var needShowResult = $(this).parents('.ls-vertical-popupbox-createSubscribeAbt').attr('data-need-show-result') || '1';
        dynamicInsertModuleFn.handleClickSubscribe(1, needShowResult);
      });

      $(document).on('click', '#subsuribe-btn_inner', function() {
        dynamicInsertModuleFn.handleClickSubscribe(3);
      });

      $(document).on('click', '#registe-rules-btn', function() {
        var innerText = `<p class="registe-module_rules-info">By clicking "Join the Collective for Free" you agree to the <a class="show-iframe_terms-of-service">Terms of Service</a> for the Grae Cove Collective, a membership program, and to email marketing. Click how we use your personal data in our <a class="show-iframe_privacy-policy">Privacy Policy</a>.</p>`;
        var popupStr = LS.ui.createDialog('registe-rules', innerText);
        $('body').append(popupStr);
      });

      // 底部邮箱点击
      $(document).on('click', '#subsribe-btn', function() {
        // 判断登录态
        var isLogin = LS.ui.isLogin();
        if (isLogin) {
          LS.ui.toastShowHandle('You have logged in, no need to repeat the operation.');
        } else {
          dynamicInsertModuleFn.handleClickSubscribe(2);
        }
      });

      $(document).on('click', '.subscribe-popup_header-close', function() {
        $('.ls-vertical-popupbox-createSubscribeAbt').remove();
        // 显示浮球
        $('#ls-vip-floatball-btn').attr('style', 'display: blcok');
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.userSubscriptionReportMap['clickIcCloseJoinCollectivePop'],
        });
        LS.ui.hidePopupBox(this);
      });

      $(document).on('click', '.subscribe-result-drawer_header-close-btn, .subscribe-result-drawer_footer-btn', function() {
        clearInterval(LS.couponListTimer);
        LS.couponListTimer = null;
        LS.ui.popupRecoveryScrollHandle();
        $('.subscribe-result-drawer').remove();
        // 上报
        var type = $(this).attr('type');
        var ext1;
        switch (type) {
          case '1':
            ext1 = LS.ui.userSubscriptionReportMap['clickbBlankCollectivePackagePop'];
            break;
          case '2':
            ext1 = LS.ui.userSubscriptionReportMap['clickIcCloseCollectivePackagePop'];
            break;
          case '3':
            ext1 = LS.ui.userSubscriptionReportMap['clickGoShoppingCollectivePackagePop'];
            break;
        }
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: ext1,
        });
      })

      $(document).on('click', '.subscribe-result-drawer_footer .view-all-clothing-btn', function() {
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.loginRegistrationProcessMap['clickViewCollectionCollectivePackagePop']
        });
        // 跳转到集合页
        setTimeout(function() {
          sessionStorage.removeItem('collection_position_data');
          window.location.href = `${LS.site.dir}/collections/all-clothing?from=subscribe_pop`;
        }, 0)
      })
    },

    /**
     * 输入框事件
     */
    bindInpEvent: function () {
      // 邮箱输入验证
      $('#subscribe-email-inp').on('focus', function(e) {
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.userSubscriptionReportMap['clickEditJoinCollectivePop'],
        });
      })
    },

    /**
     * 未注册的邮箱处理
     */
    handleRegisterEmail: function(data, type, needShowResult) {
      needShowResult = needShowResult || '1';
      if (data && data.tip) {
        LS.ui.toastShowHandle(data.tip);
      }
      LS.ui.reportLoginRegisterSource(1, data.email);
      // 隐藏动画
      var subscribeBtn = type == 3 ? '#subsuribe-btn_inner' : '#subsuribe-btn_popup';
      LS.ui.loadingBtnHide($(subscribeBtn));
      type === 1 && $('.ls-vertical-popupbox-createSubscribeAbt').remove();
      var replaceUrl = '';
      if (needShowResult == '1') {
        replaceUrl = LS.addParam({ subscribeEmail: data.email }, location.href);
      } else {
        replaceUrl = LS.addParam({ subscribeEmail: data.email, toast: 'register' }, location.href);
      }

      LS.ui.handleUrlAndDataByLogin(data, replaceUrl);
    },
    /**
     * 点击订阅按钮
     * @param {*} type 1: 订阅弹窗按钮 2：底部订阅按钮 3: 页面内嵌订阅按钮
     * @returns 
     */
    handleClickSubscribe: function(type, needShowResult) {
      var emailInp = null;
      var errorTextCtn = null;
      var subscribeBtn = null;
      if (type == 1) {
        emailInp = $('#subscribe-email-inp_popup');
        errorTextCtn = $('#subscribe-email-error_popup');
        subscribeBtn = '#subsuribe-btn_popup';
      } else if (type == 2) {
        emailInp = $('.newsletter-form-email');
        errorTextCtn = '';
        subscribeBtn = '#subsuribe-btn_popup';
      } else if (type == 3) {
        emailInp = $('#subscribe-email-inp_inner');
        errorTextCtn = $('#subscribe-email-error_inner');
        subscribeBtn = '#subsuribe-btn_inner';
      }
      var email = emailInp.val();
        if ( !LS.ui.validator.easyEmailReg.test(email)) {
          errorTextCtn != '' ? errorTextCtn.show() : LS.ui.toastShowHandle(LS.$t('public.subscribe.succpop_inp_placeholder'));
          return;
        }
        errorTextCtn !== '' && errorTextCtn.hide();
        LS.ui.loadingBtnShow($(subscribeBtn), 1);
        if (subscribeBtnBusy) return;
        subscribeBtnBusy = true;
        LS.ajax({
          url: LS.ui.routes.subscribeV2,
          type: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify({
            email: email
          }),
          success: function (res) {
            if (res.hasError || res.code !== '0') {
              LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
              // 隐藏动画
				      LS.ui.loadingBtnHide($(subscribeBtn));
              subscribeBtnBusy = false;
              return;
            };
            var isRegister = res.data.register || '';
            type === 2 && sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['footer_guide']);
            // 上报
            var ext1 = type === 2 ? LS.ui.userSubscriptionReportMap['clickBtnSignupFooter'] : LS.ui.userSubscriptionReportMap['clickBtnSignupJoinCollectivePop'];
            LS.stat({
              eid: LS.ui.reportType['click'],
              ext1: ext1,
              ext3: email,
              ext6: isRegister ? 'op=registered' : 'op=newer'
            });
            // 用户已注册，显示引导用户登录弹窗
            if (isRegister) {
              // 调用订阅登录弹窗方法
              LS.ui.loginFn.createSubscribeLoginPopup(email);
              // 隐藏动画
				      LS.ui.loadingBtnHide($(subscribeBtn));
              subscribeBtnBusy = false;
              return;
            }
            
            // 未注册
            dynamicInsertModuleFn.handleRegisterEmail(res.data, type, needShowResult);
            subscribeBtnBusy = false;
          },
          error: function (error) {
            subscribeBtnBusy = false;
            setTimeout(function() {
              LS.ui.loadingBtnHide($(subscribeBtn));
            }, 1000);
            LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
          },
        });
    },
    // 订阅提交上报方法
    subsribeSubmitReportHandel: function (email, type, status) {
      LS.stat({
        eid: LS.ui.reportType['click'],
        ext1: LS.ui.globalReportMap[type === 'pop' ? 'clickBtnSubscribeSubscribePop' : 'clickBtnSubscribeFooter'],
        ext2: email,
        ext3: status
      });
    },

    // -------------------用户订阅注册引导B start----------------
    createSubscribePopupAbt: function (delay, openNow, type = 1, showResult, reportType = '') {
      // if (!LS.ui.isFunctionOpenCountry()) return;
      var needShowResult = showResult !== undefined ? showResult : '1';
      // 获取订阅弹窗内容ab
      // 判断是否已经登录
      var isLogin = LS.ui.isLogin();
      // 判断订阅弹窗当日是否打开
      var isShowSubscribe = type == 1 ? LS.cookie.get('graecove_pop_subscribe') : false;
      // 判断是否缓存邮箱
      // var useremail = LS.cookie.get('graecove_useremail');
      var page_status = (location.href.indexOf("pages/refund") <= 0 && location.href.indexOf("pages/register") <= 0 && location.href.indexOf("pages/forgetpwd") <= 0 && location.href.indexOf("pages/write-comment") <= 0 && location.href.indexOf("pages/vote") <= 0);
      var hasLoginRecord = LS.cookie.get('graecove_login_record');
      // 判断是否为不用打开的页面
      // openNow非立即打开模式，需判断
      if (!openNow && (hasLoginRecord || isShowSubscribe || !page_status || isLogin)) return;
      

      dynamicInsertModuleFn.showSubscribePopupAbt(delay, needShowResult, reportType);
    },

    // 订阅弹窗方法
    showSubscribePopupAbt: function(delay, needShowResult, reportType) {
      setTimeout(function() {
        if ($('.ls-vertical-popupbox').length) return;
        if (LS.site.country !== 'US') {
          var subscribePopData = {
            subTitle: 'Get all Coupons for Free',
            couponList: [{
              discount: '10% OFF',
              threshold: 'No minimum requirements'
            }, {
              discount: `13% OFF`,
              threshold: `On orders over 3 items`
            }, {
              discount: `13% OFF`,
              threshold: `On orders over 3 items`
            }, {
              discount: `10% OFF`,
              threshold: `On orders over 2 items`
            }, {
              discount: `10% OFF`,
              threshold: `On orders over 2 items`
            }]
          }
          var tmpl = LS.tmpl(createSubscribePopHtmlAbtByOtherCountry, subscribePopData);
          $('body').append(tmpl);
        } else {
          $('body').append(createSubscribePopHtmlAbt);
        }
        $('.ls-vertical-popupbox-createSubscribeAbt').attr('data-need-show-result', needShowResult);
        LS.ui.popupNoScrollHandle();
        // 相关事件
        dynamicInsertModuleFn.bindInpEvent();
        if (reportType === 'showJoinCollectivePopSelfPush') {
          sessionStorage.setItem('login_register_source', LS.ui.loginRegisterSourceFieldsMap['join_us_self_push']);
        }
        // 上报
        LS.stat({
          eid: LS.ui.reportType['moduleShow'],
          ext1: LS.ui.loginRegistrationProcessMap[reportType],
        });
        // 储存值
        LS.cookie.set('graecove_pop_subscribe', '1', 24); // 1天有效期
      }, delay !== undefined ? delay : 15000);
    },
    showSubscribeReuslt: function() {
      // if (!LS.ui.isFunctionOpenCountry()) return;
      var email = LS.getParam('subscribeEmail');
      var toastShow = LS.getParam('toast');
      // 获取用户类型，1:新注册用户，2:老用户
      var userType = LS.getParam('userType') || '1';
      // 去除参数
      if (email || toastShow) {
        var url = window.location.href;
        url = url.replace(/(\?|#)[^'"]*/, '');
        window.history.pushState({},0,url);
      }
      // 判断
      if (!email || !LS.ui.isLogin()) return;
      // 旧用户接口数据
      var params = {
        lastId: '',
        count: 100,
        userCouponType: 1,
      };
      LS.ajax({
        url: userType === '2' ? LS.ui.routes.queryUserCouponsApi : LS.ui.routes.getSubscribeEmailCoupons,
        type: 'GET',
        data: userType === '2' ? params : '',
        success: function (res) {
          if (res.hasError || res.code !== '0') {
            LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
            return;
          };
          var couponList = userType === '2' ? res.data.record : res.data.subscribeCouponList;
          var subscribeCouponList = couponList ? couponList : [];
          var otherAvailableCouponList = res.data.otherAvailableCouponList ? res.data.otherAvailableCouponList : [];
          $('body').append(subscribeResultDrawerHtmlAbt);
          // 上报
          if (toastShow === 'register') {
            // 只显示一个按钮
            $('.subscribe-result-drawer_footer .subscribe-result-drawer_footer-btn').addClass('only-one-btn');
            $('.subscribe-result-drawer_footer .view-all-clothing-btn').hide();
            LS.stat({
              eid: LS.ui.reportType['moduleShow'],
              ext1: LS.ui.loginRegistrationProcessMap['showCollectivePackagePopOneButton'],
            });
          } else {
            LS.stat({
              eid: LS.ui.reportType['moduleShow'],
              ext1: LS.ui.loginRegistrationProcessMap['showCollectivePackagePopTwoButton'],
            });
          }
          if (subscribeCouponList.length) {
            dynamicInsertModuleFn.insertSubscribeCouponModule(subscribeCouponList);
          } else {
            $('.subscribe-result-drawer_body_loading-img').remove();
          }
          
          if (otherAvailableCouponList.length) {
            dynamicInsertModuleFn.insertOtherCouponModule(otherAvailableCouponList);
          }
          // 动画
          $('.subscribe-result-drawer').addClass('is-visible');
          setTimeout(function() {
            $('.subscribe-result-drawer').addClass('is-visible-show');
          }, 300)
          LS.ui.popupNoScrollHandle();
          // 判断优惠券是否倒计时并设置
          setTimeout(function() {
            LS.ui.renderCountDownTimer('#subscribe-result-coupon');
          }, 300)
        },
        error: function (error) {
          LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
        },
      });
    },
    insertSubscribeCouponModule: function(arr) {
      var subscribeCouponListDom = LS.ui.renderCouponListHtml(
        {
          arr: arr, 
          className: 'subscribe-result-drawer_body_coupon-box'
        }
      );
      if (!subscribeCouponListDom) return;
      $('#subscribe-result-coupon').html(subscribeCouponListDom);
    },

    insertOtherCouponModule: function(arr) {
      var ottherCouponListHtml = `
      <div class="other-coupon-title-wrapper">
        <span class="other-coupon-title_line"></span>
        <div class="other-coupon-title-inner">
          <div class="other-coupon-title">Other Coupons</div>
          <img class="other-coupon-title_icon active" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/icon_ic_back_light_s_3_2x_d1e65589-fc29-404d-ac8a-150fd9c557d1_900x.png?v=1668761576" loading="lazy"/>
        </div>
        <span class="other-coupon-title_line"></span>
      </div>
    `
      ottherCouponListHtml = ottherCouponListHtml + `<div id="other-coupon-list-box">${LS.ui.renderCouponListHtml({
        arr: arr,
        className: 'subscribe-result-drawer_body_coupon-box'
      })}</div>`;
      $('#subscribe-result-coupon').append(ottherCouponListHtml);
      // 监听其他优惠券曝光上报
      LS.ui.globalModelShowHandle(document.querySelector('#other-coupon-list-box'), LS.ui.userSubscriptionReportMap['showOtherCouponsCollectivePackagePop']);
      $('.other-coupon-title-inner').on('click', function() {
        var iconActiveCls = 'active'
        var iconDomCls = '.other-coupon-title_icon';
        var otherCouponList = '#other-coupon-list-box';
        if ($(this).find(iconDomCls).hasClass(iconActiveCls)) {
          $(this).find(iconDomCls).removeClass(iconActiveCls);
          $(otherCouponList).hide();
        } else {
          $(this).find(iconDomCls).addClass(iconActiveCls);
          $(otherCouponList).show();
        }
        // 上报
        LS.stat({
          eid: LS.ui.reportType['click'],
          ext1: LS.ui.userSubscriptionReportMap['clickOtherCouponsCollectivePackagePop'],
        });
      });
    }
    // -------------------用户订阅注册引导B end----------------

  }

  LS.ui.dynamicInsertModuleFn = {
    insertHeaderMenuHander: dynamicInsertModuleFn.insertHeaderMenuHander,
    insertFooterHander: dynamicInsertModuleFn.insertFooterHander,
    createSubscribePopup: dynamicInsertModuleFn.createSubscribePopup,
    createSubscribePopupAbt: dynamicInsertModuleFn.createSubscribePopupAbt,
    announcementBarSlide: dynamicInsertModuleFn.announcementBarSlide,
    showSubscribeReuslt: dynamicInsertModuleFn.showSubscribeReuslt
  };
})();

// 获取用户会员信息方法
(function() {
  var userVipInfoFn = {
    // 获取会员信息
    getUserVipInfoHandle: function () {
      return new Promise(function (resolve, reject) {
        // 调用接口
        LS.ajax({
          url: LS.ui.routes.queryUserPointsInfoApi,
          type: "GET",
          success: function (res) {
            if (!res.hasError && res.code == '0' && res.data.userPointsInfo) {
              // 会员中心信息
              LS.userVipInfo = res.data;
              LS.isDeal = LS.userVipInfo.orderCount > 0; // 用户是否有成单
              // 储存用户邮箱
              if (res.data.userBasicInfo && res.data.userBasicInfo.email) {
                LS.cookie.set("graecove_useremail", res.data.userBasicInfo.email, 24*30);
              }
              // 更改用户顶部图标
              var htmlStr = `<div class="header-account-bg header-account-bg-${res.data.userPointsInfo.currentVip}"></div>`;
              $('#header-account').html(htmlStr);
              resolve();
            } else {
              res.error && LS.ui.toastShowHandle(res.error.message);
              reject();
            }
          },
          error: function (error) {
            location.href.indexOf('/pages/my') >= 0 && LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError, 3500);
            reject(error);
          },
        });
      })
    },
  }

  LS.ui.userVipInfoFn = {
    getUserVipInfoHandle: userVipInfoFn.getUserVipInfoHandle,
  };
})();

(function () {
  var allowConfirm = false;
  var pageFn = {
    bindEvent: function () {
      $(document).on('click', '.about-us_tab', function() {
        var scrollHeight = $(window).scrollTop();
        var moduleTop = 0;
        if ($(this).hasClass('about-us_tab1')) {
          moduleTop = $(".about-us-module-tab1").offset().top - 80;
        } else if ($(this).hasClass('about-us_tab2')) {
          moduleTop = $(".about-us-module-tab2").offset().top - 80;
        } else if ($(this).hasClass('about-us_tab3')) {
          moduleTop = $(".about-us-module-tab3").offset().top - 80;
        }

        if (scrollHeight < moduleTop) {
          $(window).scrollTo && $(window).scrollTo({pos : moduleTop});
        }
      });

			$(document).on('click', '#forget-pwd_confirm-btn', function() {
				pageFn.handleConfirm();
      });
      
      $(document).on('click', '#forget-pwd_login-btn', function() {
        LS.ui.loginFn.createLoginPopup(true, `${LS.site.baseUrl}/pages/my`, 'my_account');
      });

      $(document).on('click', '.forget-pwd_input-icon-show', function() {
				$(this).hide();
				$(this).siblings('.forget-pwd_input-icon-hide').show();
        $(this).siblings('.forget-pwd_input').attr("type", "password")
			});

      $(document).on('click', '.forget-pwd_input-icon-hide', function() {
				$(this).hide();
				$(this).siblings('.forget-pwd_input-icon-show').show();
        $(this).siblings('.forget-pwd_input').attr("type", "text");
			});

      $('.forget-pwd_input').on('keyup',function(e) {
        var val = $(this).val();
        var $errorTip = $(this).siblings('.forget-pwd_error-tip');
        var $title = $(this).siblings('.forget-pwd_input-title');
        var $hideValIcon = $(this).siblings('.forget-pwd_input-icon-hide');
        var $showValIcon = $(this).siblings('.forget-pwd_input-icon-show');
        var $comfirmBtn = $('#forget-pwd_confirm-btn');
        // 没输入
        if (!val) {
          $title.hide();
          $showValIcon.hide();
          $hideValIcon.hide();
          $errorTip.hide();
          allowConfirm = false;
          $(this).attr("type", "password")
        } else {
        // title显示
          $title.show();
          if ($hideValIcon.css('display') === 'none' && $showValIcon.css('display') === 'none') {
            $hideValIcon.show()
          }
          // 长度限制
          if($('#newPassword').val().length > 18 || $('#newPassword').val().length < 6) {
            $comfirmBtn.removeClass('allow-confirm');
            $errorTip.show().html('6～18 characters minimum');
            allowConfirm = false;
            return;
          } else {
            $errorTip.hide();
          }
          if (pageFn.checkPwd($('#newPassword').val()) && $('#againPassword').val()) {
            allowConfirm = true
          }
          // 都通过设置按钮可点击样式
          allowConfirm ? $comfirmBtn.addClass('allow-confirm') : $comfirmBtn.removeClass('allow-confirm');
        }
			});
		},
    checkPwd: function(val) {
      if (val.length > 18 || val.length < 6) {
        return false;
      }
      return true;
    },
		handleConfirm: function() {
      var newPwdVal = $('#newPassword').val();
      var againPwdVal = $('#againPassword').val();
      var $againPwdErrorTip = $('.again-password_error-tip');
      if (!newPwdVal) {
        return;
      }
      if (!againPwdVal) {
        return;
      }
      if (newPwdVal !== againPwdVal) {
        $againPwdErrorTip.show().html(LS.$t('public.customer.reset_password_text3'));
        return;
      }
      $againPwdErrorTip.hide();
      var params = JSON.stringify({
        newPassword: newPwdVal,
        newAgainPassword: againPwdVal,
        verifyToken: LS.getParam('verifyToken', location.href)
      })
			LS.ajax({
				url: LS.ui.routes.resetPasswordApi,
				type: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        data: params,
				success: function(resp) {
          if (!resp.hasError && resp.code == "0") {
            $('.forget-pwd_box').hide();
            $('.forget-pwd_success-box').show();
          } else if (resp.error.code == ( 'F10409' || 'f10410' )) {
            $('.forget-pwd_box').hide();
            $('.forget-pwd_fail-box').show();
          } else {
            LS.ui.toastShowHandle(resp.error.message);
          }
				},
				error: function (error) {
					LS.ui.toastShowHandle(LS.ui.errorMsgMap.baseError);
			 }
			});
		}
  };

  LS.ui.pageFn = {
    bindEvent: pageFn.bindEvent
  };
})();

(function() {
  var pintrkFn = {
    pageVisit: function() {
      try {
        pintrk('track', 'pagevisit', {
          product_id: $('#product-page').data('product-id') + ''
        });
      } catch(e) {
         console.log('pintrk error =>', e);
      }
    },
    addToCart: function(productId) {
      try {
        pintrk('track', 'AddToCart', {
          product_id: productId + ''
        });

        $('body').append( `<noscript>
          <img height="1" width="1" style="display:none;" alt="" src="https://ct.pinterest.com/v3/?tid=2613215026633&event=AddToCart&ed[product_id]=${productId}&noscript=1"/>
        </noscript>`);
      } catch(e) {
        console.log('pintrk error =>', e);
      }
    }
  }

  LS.ui.pintrkFn = {
    pageVisit: pintrkFn.pageVisit,
    addToCart: pintrkFn.addToCart
  };
})();

(function() {
  var bingFn = {
    pageVisit: function() {
      try {
        window.uetq = window.uetq || [];
        window.uetq.push('event', 'page_view', {})
      } catch(e) {
         onsole.log('bing event【page view】 error =>', e);
      }
    },
    eventReport: function(eventName, value) {
      try {
        window.uetq = window.uetq || [];
        window.uetq.push('event', eventName, {'revenue_value': value, 'currency': LS.site.currency});
      } catch(e) {
        console.log('bing event error =>', e);
      }
    }
  }

  LS.ui.bingFn = {
    pageVisit: bingFn.pageVisit,
    eventReport: bingFn.eventReport
  };
})();

/**
 * zepto 扩展方法
 */
(function() {
  $.fn.scrollTo = function(options){
    var defaultOpt = {
        pos: 0,    //滚动目标位置
        durTime : 600,  //过渡动画时间
        delay : 30,     //定时器时间
        callback: null   //回调函数
    };
    var opts = $.extend(defaultOpt,options),
        timer = null,
        _this = this,
        curTop = _this.scrollTop(),//滚动条当前的位置
        subTop = opts.pos - curTop,    //滚动条目标位置和当前位置的差值
        index = 0,
        dur = Math.round(opts.durTime / opts.delay),
        smoothScroll = function(t) {
          index++;
          var per = Math.round(subTop/dur);
          if(index >= dur){
              _this.scrollTop(t);
              timer && window.cancelAnimationFrame(timer);
              timer = null;
              // window.clearInterval(timer);
              if(opts.callback && typeof opts.callback == 'function'){
                  opts.callback();
              }
              return;
          } else {
            _this.scrollTop(curTop + index*per);
            timer = window.requestAnimationFrame(smoothScroll.bind(_this, opts.pos));
          }
        };
    smoothScroll(opts.pos);
    // timer = window.setInterval(function() {
    //   smoothScroll(opts.pos);
    // }, opts.delay);
    return _this;
  };
})();


(function () {
  var announcementHtml = `
    <div class="ls-main-popupbox">
      <div class="ls-main-popupbox-overlay"></div>
      <div class="ls-main-popupbox-con announcement-popup">
        <div class="announcement-popup_title">
          <p>We're Opening New</p>
          <p>Doors with LookSky</p>
        </div>
        <div class="top-wrapper">
          <img class="top-image" data-lazyload-src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/announcement_cover.png?v=1723098434">
          <div class="text-wrapper">
            <p class="announcement-popup_text strong">Hello Grae Cove Fam!</p>
            <p class="announcement-popup_text">We're closing the doors to Grae Cove. But, we're opening new ones with LookSky.
            The same team who brought the best in linen clothing is now switching gears.</p>
            <span class="bold announcement-popup_text" style="font-weight: bold;">Take the guesswork out of shopping in 3 easy steps. LookSky saves you time and money by curating looks you’ll love, according to your body, needs, and style.</span>
            <p class="announcement-popup_text">We're so excited to see you on LookSky!</p>
            <p class="announcement-popup_text strong">LookSky Team</p>
            <a class="announcement-popup_btn" href="https://www.looksky.ai?lsch=gc_website">Unlock Your Style Now</a>
          </div>
        </div>
        <div class="steps-wrapper">
          <div class="steps-title">
            <p>3 Easy Steps to</p>
            <p>Effortless Shopping</p>
          </div>
          <div class="steps-box">
            <div class="step-item">
              <img class="step-item-image" data-lazyload-src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/tab-icon1.png?v=1723098434">
              <div class="step-item-label">Take a Quiz</div>
              <div class="step-item-text">Tell us your body</div>
              <div class="step-item-text">shape & style</div>
              <div class="step-item-text">preferences.</div>
            </div>
            <div class="step-item">
              <img class="step-item-image" data-lazyload-src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/tab-icon2.png?v=1723098434">
              <div class="step-item-label">100 Items, Daily</div>
              <div class="step-item-text">We'll curate 100 items that will</div>
              <div class="step-item-text">flatter your shape and tastes, </div>
              <div class="step-item-text">everyday.</div>
            </div>
            <div class="step-item clear">
              <img class="step-item-image" data-lazyload-src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/tab-icon3.png?v=1723098434">
              <div class="step-item-label">Shop</div>
              <div class="step-item-text">Buy only the items you love.</div>
              <div class="step-item-text">No subscription required.</div>
            </div>
          </div>
        <a class="announcement-popup_btn" href="https://www.looksky.ai/ai-stylist/index.html#/home?lsch=gc_website">Start Your Quiz Now</a>
        </div>
      </div>
    </div>
  `;
  async function init() {
    if (location.href.indexOf('pages/form') < 0 && location.href.indexOf('pages/unsubscribe') < 0) {
      $('body').append(announcementHtml);
      $('body').css({ 'overflow': 'hidden' });
    }
    if (LS.ui.isLogin()) {
      LS.ui.checkUserCountry();
      LS.ui.dynamicInsertModuleFn.showSubscribeReuslt();

      // 初始调用会员用户信息接口，挂载参数到全局
      await LS.ui.userVipInfoFn.getUserVipInfoHandle().catch(function(e) {
        console.log('getUserVipInfoHandle Error=>', e);
      });

      setTimeout(function() {
        if (LS.isDeal) {
          LS.ui.inviteDialogFn.showInviteEntrance();
        }
      }, 2000);
    }

    LS.ui.loadResourceAsync();
    
    if (LS.site.page === 'index' || location.href.indexOf("pages/about-us") > 0 || location.href.indexOf("pages/refer") > 0) {
      // 初始化header交互效果
      LS.ui.initHeaderInteractive();
    } else {
      $('.looksky-header-model-con').addClass('white-bg-header');
    }

    // 判断集合页顶部导航样式
    if (LS.site.page === 'collection') {
      var collectionInfo = $('#js-collection-description-data').text();
      if (collectionInfo.indexOf('{') != -1 && collectionInfo.indexOf('}') != -1) {
        try {
          var descriptionData = JSON.parse(collectionInfo || 'null') || {};
          if (LS.ui.showRegisteModule() || !descriptionData || !descriptionData[`phone_image_${LS.site.lang}`]) {
            $('.looksky-header-model-con').addClass('white-bg-header');
          } else {
            if (descriptionData[`phone_image_${LS.site.lang}`] && LS.site.country == 'US') {
               // 初始化header交互效果
              LS.ui.initHeaderInteractive();
              $('.looksky-header-model-con').removeClass('white-bg-header');
            }
          }
        } catch (error) {
        }
      }
    }

    // 动态插入模块方法
    LS.ui.dynamicInsertModuleFn.insertFooterHander();
    LS.ui.dynamicInsertModuleFn.insertHeaderMenuHander();
    setTimeout(function() {
      // 初始化邀请逻辑
      LS.ui.inviteDialogFn.handleInvitee();
    }, 300);

    // 有其他弹窗先不处理，等关闭后计时15s
    // LS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(15000, false, 1, '1', 'showJoinCollectivePopSelfPush');

    
    // 头部announcement-bar滚动方法
    LS.ui.dynamicInsertModuleFn.announcementBarSlide();

    LS.ui.homePageFn.homepageHandleAll();

    LS.ui.collectionFn.handleCollectAll();
    LS.ui.productPopupFn.productPopBindEvent();

    // 全局公共事件绑定方法
    LS.ui.publicEventBind();

    // 会员折扣浮球注册入口方法
    LS.ui.vipFloatBallHandle();

    // 当为搜索页时
    if (LS.site.page == 'search') {
      LS.ui.searchFn.handleSearchAll();
    }

    // app的forgetpwd页插入
    if (location.href.indexOf("pages/forgetPwd") > 0 || location.href.indexOf("pages/forgetpwd") > 0 || location.href.indexOf("pages/about-us") > 0) {
      LS.ui.pageFn.bindEvent();
    }

    // 图片懒加载公共方法
    LS.ui.initImgLazyloadHandle();
    // 获取元素
    var lazyLoadContainer = document.querySelector("body");
    // 配置选项
    var lazyLoadConfig = { attributes: true, childList: true, subtree: true };
    var lazyLoadObserver = new MutationObserver(function (mutationsList, observer) {
      for (var mutation of mutationsList) {
        if (mutation.type == 'childList') {
          LS.ui.initImgLazyloadHandle();
        }
      }
    });
    // 开始观测
    lazyLoadObserver.observe(lazyLoadContainer, lazyLoadConfig);

  }

  LS.ui.watchAjaxError();

  // ab方案
  LS.ui.initAbt(['aatest']);

  var initConfig = {
    abt: Object.values(LS.ui.abtMap)
  };

  if (LS.site.page === 'checkout') {
    var checkoutItems = [];
    $('#js_stat_checkout_items div').each(function() {
      checkoutItems.push({
        title: $(this).text(),
        pid:$(this).attr('data-pid'),
        quantity:$(this).attr('data-quantity'),
        price:$(this).attr('data-price'),
      })
    });
    var checkoutInfoDom = $('#js_stat_checkout_info');
    var currentStep = LS.ui.getCheckoutStep();
    initConfig.pageReport = {
      ext2: JSON.stringify({ products: checkoutItems }),
      ext4: JSON.stringify({
        total: checkoutInfoDom.attr('data-total-price'),
        currency: checkoutInfoDom.attr('data-currency'),
        sum: checkoutItems.length,
      }),
      ext5: JSON.stringify({
        currency: checkoutInfoDom.attr('data-currency'),
        shippingPrice: checkoutInfoDom.attr('data-shipping-price')
      }),
      ext6: checkoutInfoDom.attr('data-id'),
      ext7: currentStep,
      ext8: LS.client.name === LS.site.brand ? 'bag_app' : LS.cookie.get('looksky-checkout-source'),
      ext9: currentStep === 'thank_you' || currentStep === 'order' ? checkoutInfoDom.attr('data-order-id') : ''
    }

    LS.setData && LS.setData('checkoutObj', initConfig.pageReport);
  }
  LS.init(initConfig);
  LS.site.page !== 'checkout' && init();

  // 客户端环境
  if(LS.client.name === LS.site.brand) {
    LS.ui.handleAppPages();
  }

  window.addEventListener('load', function() {
    LS.ui.bingFn.pageVisit && LS.ui.bingFn.pageVisit();
    // 延迟加载客服
    // if (LS.site.page !== 'cart') {
    //   if (navigator.userAgent.indexOf('iPad') !== -1 && navigator.userAgent.indexOf('Instagram') !== -1) { } else {
    //     setTimeout(function() {
    //       n = document.createElement('script'); 
    //       n.async = true;
    //       n.src = 'https://code.tidio.co/5ct8leqh8i9y7in8hf6k3cfohxsdd06v.js'; 
    //       document.body.appendChild(n);
    //     }, 2000);
    //   }
    // }
  })

  setTimeout(function() {
    LS.stat({
      eid: LS.ui.reportType['forTest'],
      ext1: document.cookie.length+''
    })
  }, 500)
})();
